import React from "react";

const defaultClassName = "inline-block h-8 w-8";

export const CheckIcon = ({ className, style }) => (
  <svg
    className={`${defaultClassName} ${className}`}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 16 12"
  >
    <path d="M14.7099 1.20998C14.617 1.11625 14.5064 1.04186 14.3845 0.991091C14.2627 0.940323 14.132 0.914185 13.9999 0.914185C13.8679 0.914185 13.7372 0.940323 13.6154 0.991091C13.4935 1.04186 13.3829 1.11625 13.29 1.20998L5.83995 8.66998L2.70995 5.52998C2.61343 5.43674 2.49949 5.36343 2.37463 5.31423C2.24978 5.26502 2.11645 5.24089 1.98227 5.24321C1.84809 5.24553 1.71568 5.27426 1.5926 5.32776C1.46953 5.38125 1.35819 5.45846 1.26495 5.55498C1.17171 5.6515 1.0984 5.76545 1.04919 5.8903C0.999989 6.01516 0.975859 6.14848 0.97818 6.28266C0.980502 6.41684 1.00923 6.54925 1.06272 6.67233C1.11622 6.79541 1.19343 6.90674 1.28995 6.99998L5.12995 10.84C5.22291 10.9337 5.33351 11.0081 5.45537 11.0589C5.57723 11.1096 5.70794 11.1358 5.83995 11.1358C5.97196 11.1358 6.10267 11.1096 6.22453 11.0589C6.34639 11.0081 6.45699 10.9337 6.54995 10.84L14.7099 2.67998C14.8115 2.58634 14.8925 2.47269 14.9479 2.34619C15.0033 2.21969 15.0319 2.08308 15.0319 1.94498C15.0319 1.80688 15.0033 1.67028 14.9479 1.54378C14.8925 1.41728 14.8115 1.30363 14.7099 1.20998Z" />
  </svg>
);

export const LocationIcon = ({ className, style }) => (
  <svg
    className={`${defaultClassName} ${className}`}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 17 20"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.24951 0C12.7985 0 16.4995 3.729 16.4995 8.313C16.4995 13.948 10.0435 19.5 8.24951 19.5C6.45551 19.5 -0.000488281 13.948 -0.000488281 8.313C-0.000488281 3.729 3.70051 0 8.24951 0ZM8.24951 1.5C4.52751 1.5 1.49951 4.557 1.49951 8.313C1.49951 13.092 7.12351 17.748 8.24951 17.996C9.37551 17.747 14.9995 13.091 14.9995 8.313C14.9995 4.557 11.9715 1.5 8.24951 1.5ZM8.25051 5C10.0425 5 11.5005 6.458 11.5005 8.251C11.5005 10.043 10.0425 11.5 8.25051 11.5C6.45851 11.5 5.00051 10.043 5.00051 8.251C5.00051 6.458 6.45851 5 8.25051 5ZM8.25051 6.5C7.28551 6.5 6.50051 7.285 6.50051 8.251C6.50051 9.216 7.28551 10 8.25051 10C9.21551 10 10.0005 9.216 10.0005 8.251C10.0005 7.285 9.21551 6.5 8.25051 6.5Z"
    />
  </svg>
);

export const LocationIcon2 = ({ className, style }) => (
  <svg
    className={`${defaultClassName} ${className}`}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path d="M12 0c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z" />
  </svg>
);

export const PhoneIcon = ({ className, style }) => (
  <svg
    className={`${defaultClassName} ${className}`}
    style={style}
    viewBox="0 0 1000 1000"
    fill="currentColor"
  >
    <g>
      <path d="M966.4,747.9c-14.9-10.5-178.6-119.3-198.7-131.6c-8.8-5.3-19.4-8-31-8c-14.9,0-31.5,4.3-47.7,12.8c-15.7,8.3-63.5,35.5-86.8,48.8c-20.6-14.5-68.9-51.5-145-127.7C381.5,466.8,344.2,418,329.6,397.3c13.3-23.3,40.5-71,48.7-86.7c15.6-29.6,17.4-59.2,4.7-79.1C371.1,212.7,262.7,48.3,251.5,32.8c-10.5-14.6-29.4-22.5-49.9-22.5c-16.2,0-33.3,4.9-48.2,15.2C152,26.7,8.1,130.9,10,190.2c5.3,166.6,167.2,362.4,302,497.3c134.8,134.9,330.6,296.9,497.9,302.2h1.4c58.5,0,161.4-142,162.4-143.4C1000.9,807.6,991,765.2,966.4,747.9L966.4,747.9z M924.2,810.6c-38.8,53.7-93.7,109.8-115.3,117.9c-114.6-5.4-275.5-106.2-453.5-284.2c-178-178.1-278.7-338.7-284.1-453c7.7-21.7,63.8-77,117.1-115.5c3.9-2.7,8.8-4.3,13.3-4.3c1,0,1.8,0.1,2.5,0.3c17.2,24.9,109.5,164.7,126.2,190.7c0.1,2.8-0.8,9.7-6.1,19.7c-5.7,10.6-23,41.5-47.8,84.9l-19.2,33.7l22.3,31.8c16.6,23.6,56.2,74.9,134.3,153C492.4,664.1,543.5,703.5,567,720l31.8,22.3l33.7-19.2c32.6-18.7,72.1-41,84.9-47.8c10.3-5.5,17.3-5.9,19.2-5.9c0.4,0,0.6,0,0.9,0.1c23.3,14.6,166.1,109.4,191.3,126.6C929.2,798.7,928.8,804,924.2,810.6L924.2,810.6z" />
    </g>
  </svg>
);

export const CrossIcon = ({ className, style }) => (
  <svg
    className={`${defaultClassName} ${className}`}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path d="M10.939 12.0003L8.81796 9.87931C8.68134 9.73786 8.60574 9.54841 8.60745 9.35176C8.60916 9.15511 8.68804 8.967 8.82709 8.82795C8.96615 8.68889 9.15426 8.61001 9.3509 8.6083C9.54755 8.6066 9.737 8.68219 9.87846 8.81881L11.9995 10.9398L14.1205 8.81881C14.1896 8.74718 14.2724 8.69004 14.3639 8.65073C14.4554 8.61143 14.5538 8.59074 14.6534 8.58987C14.753 8.58901 14.8517 8.60798 14.9439 8.64569C15.0361 8.6834 15.1198 8.73909 15.1903 8.80951C15.2607 8.87993 15.3164 8.96367 15.3541 9.05584C15.3918 9.14802 15.4108 9.24678 15.4099 9.34636C15.409 9.44595 15.3883 9.54436 15.349 9.63586C15.3097 9.72737 15.2526 9.81012 15.181 9.87931L13.06 12.0003L15.181 14.1213C15.2526 14.1905 15.3097 14.2733 15.349 14.3648C15.3883 14.4563 15.409 14.5547 15.4099 14.6543C15.4108 14.7538 15.3918 14.8526 15.3541 14.9448C15.3164 15.0369 15.2607 15.1207 15.1903 15.1911C15.1198 15.2615 15.0361 15.3172 14.9439 15.3549C14.8517 15.3926 14.753 15.4116 14.6534 15.4107C14.5538 15.4099 14.4554 15.3892 14.3639 15.3499C14.2724 15.3106 14.1896 15.2534 14.1205 15.1818L11.9995 13.0608L9.87846 15.1818C9.737 15.3184 9.54755 15.394 9.3509 15.3923C9.15426 15.3906 8.96615 15.3117 8.82709 15.1727C8.68804 15.0336 8.60916 14.8455 8.60745 14.6489C8.60574 14.4522 8.68134 14.2628 8.81796 14.1213L10.939 12.0003Z" />
    <path d="M12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12C3 14.3869 3.94821 16.6761 5.63604 18.364C7.32387 20.0518 9.61305 21 12 21ZM12 22.5C9.21523 22.5 6.54451 21.3938 4.57538 19.4246C2.60625 17.4555 1.5 14.7848 1.5 12C1.5 9.21523 2.60625 6.54451 4.57538 4.57538C6.54451 2.60625 9.21523 1.5 12 1.5C14.7848 1.5 17.4555 2.60625 19.4246 4.57538C21.3938 6.54451 22.5 9.21523 22.5 12C22.5 14.7848 21.3938 17.4555 19.4246 19.4246C17.4555 21.3938 14.7848 22.5 12 22.5Z" />
  </svg>
);

export const CrossIcon2 = ({ className, style }) => (
  <svg
    className={`${defaultClassName} ${className}`}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    viewBox="0 0 100 100"
  >
    <path
      strokeWidth="12"
      strokeLinecap="square"
      d="M 10,10 90,90 M 10,90 90,10"
    />
  </svg>
);

export const CloudIcon = ({ className, style }) => (
  <svg
    className={`${defaultClassName} ${className}`}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 34 28"
  >
    <path d="M27.7001 7.70003C26.6817 5.36004 24.9242 3.41849 22.6968 2.17291C20.4695 0.927324 17.8952 0.446415 15.3683 0.803877C12.8415 1.16134 10.5016 2.33745 8.70715 4.15199C6.9127 5.96652 5.76271 8.31939 5.43339 10.85C3.84437 11.2306 2.45043 12.1814 1.51629 13.522C0.582151 14.8626 0.172868 16.4996 0.366167 18.1221C0.559467 19.7445 1.34189 21.2395 2.56484 22.3231C3.78779 23.4067 5.36611 24.0035 7.00006 24C7.44209 24 7.86601 23.8244 8.17857 23.5119C8.49113 23.1993 8.66673 22.7754 8.66673 22.3334C8.66673 21.8913 8.49113 21.4674 8.17857 21.1548C7.86601 20.8423 7.44209 20.6667 7.00006 20.6667C6.11601 20.6667 5.26816 20.3155 4.64304 19.6904C4.01792 19.0653 3.66673 18.2174 3.66673 17.3334C3.66673 16.4493 4.01792 15.6015 4.64304 14.9763C5.26816 14.3512 6.11601 14 7.00006 14C7.44209 14 7.86601 13.8244 8.17857 13.5119C8.49113 13.1993 8.66673 12.7754 8.66673 12.3334C8.67099 10.3622 9.37387 8.45628 10.6505 6.95433C11.9271 5.45238 13.6949 4.45161 15.6396 4.12982C17.5844 3.80802 19.5803 4.18604 21.2727 5.19671C22.9651 6.20738 24.2444 7.78526 24.8834 9.65003C24.9787 9.93643 25.1499 10.1916 25.3789 10.3883C25.6078 10.5849 25.8859 10.7157 26.1834 10.7667C27.2935 10.9765 28.2998 11.556 29.0384 12.4109C29.777 13.2658 30.2043 14.3456 30.2507 15.4744C30.2971 16.6032 29.9599 17.7145 29.2939 18.6271C28.6279 19.5397 27.6725 20.1999 26.5834 20.5C26.1546 20.6105 25.7873 20.8868 25.5623 21.2682C25.3372 21.6495 25.2729 22.1046 25.3834 22.5334C25.4939 22.9621 25.7702 23.3294 26.1515 23.5545C26.5329 23.7795 26.988 23.8439 27.4167 23.7334C29.1707 23.2699 30.7255 22.2467 31.8451 20.8191C32.9646 19.3916 33.5877 17.6377 33.6198 15.8238C33.6518 14.0099 33.0911 12.2351 32.0227 10.7689C30.9543 9.30269 29.4366 8.22519 27.7001 7.70003V7.70003ZM18.1834 11.15C18.0249 10.9983 17.838 10.8794 17.6334 10.8C17.2276 10.6333 16.7725 10.6333 16.3667 10.8C16.1621 10.8794 15.9752 10.9983 15.8167 11.15L10.8167 16.15C10.5029 16.4639 10.3266 16.8895 10.3266 17.3334C10.3266 17.7772 10.5029 18.2029 10.8167 18.5167C11.1306 18.8305 11.5562 19.0068 12.0001 19.0068C12.4439 19.0068 12.8696 18.8305 13.1834 18.5167L15.3334 16.35V25.6667C15.3334 26.1087 15.509 26.5326 15.8215 26.8452C16.1341 27.1578 16.558 27.3334 17.0001 27.3334C17.4421 27.3334 17.866 27.1578 18.1786 26.8452C18.4911 26.5326 18.6667 26.1087 18.6667 25.6667V16.35L20.8167 18.5167C20.9717 18.6729 21.156 18.7969 21.3591 18.8815C21.5622 18.9661 21.78 19.0097 22.0001 19.0097C22.2201 19.0097 22.4379 18.9661 22.641 18.8815C22.8441 18.7969 23.0285 18.6729 23.1834 18.5167C23.3396 18.3618 23.4636 18.1774 23.5482 17.9743C23.6328 17.7712 23.6764 17.5534 23.6764 17.3334C23.6764 17.1133 23.6328 16.8955 23.5482 16.6924C23.4636 16.4893 23.3396 16.305 23.1834 16.15L18.1834 11.15Z" />
  </svg>
);
export const AttachIcon = ({ className }) => (
  <svg
    className={`${defaultClassName} ${className}`}
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 1 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
    />
  </svg>
);

export const ClientIcon = (className) => (
  <svg
    className={`${defaultClassName} ${className}`}
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
    />
  </svg>
);

export const SentIcon = ({ className }) => (
  <svg
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    fill="currentColor"
    className={`${className ?? defaultClassName}`}
    viewBox="0 0 495.003 495.003"
  >
    <g id="XMLID_51_">
      <path
        id="XMLID_53_"
        d="M164.711,456.687c0,2.966,1.647,5.686,4.266,7.072c2.617,1.385,5.799,1.207,8.245-0.468l55.09-37.616
		l-67.6-32.22V456.687z"
      />
      <path
        id="XMLID_52_"
        d="M492.431,32.443c-1.513-1.395-3.466-2.125-5.44-2.125c-1.19,0-2.377,0.264-3.5,0.816L7.905,264.422
		c-4.861,2.389-7.937,7.353-7.904,12.783c0.033,5.423,3.161,10.353,8.057,12.689l125.342,59.724l250.62-205.99L164.455,364.414
		l156.145,74.4c1.918,0.919,4.012,1.376,6.084,1.376c1.768,0,3.519-0.322,5.186-0.977c3.637-1.438,6.527-4.318,7.97-7.956
		L494.436,41.257C495.66,38.188,494.862,34.679,492.431,32.443z"
      />
    </g>
  </svg>
);
export const PaperClipIcon = ({ className }) => (
  <svg
    className={className ?? defaultClassName}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
    />
  </svg>
);

export const TimeIcon = ({ className }) => (
  <svg
    className={`${defaultClassName} ${className}`}
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);

export const CheckCircleIcon = ({ className }) => (
  <svg
    className={`${defaultClassName} ${className}`}
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);

export const WrenchIcon = ({ className }) => (
  <svg
    className={`${defaultClassName} ${className}`}
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 700 700"
  >
    <path
      className="cls-1"
      d="M875,348.16s-6.48-22.08-26.88-27.12-36.24,9.6-36.24,9.6l-84.75,85a4.57,4.57,0,0,1-4,1.28L668,408a4.55,4.55,0,0,1-3.78-3.86l-7.62-54.22a4.57,4.57,0,0,1,1.26-3.82L741,261.54a5.23,5.23,0,0,0,.48-.56c20.7-28.92,8.55-46.31-3.5-55.29a52.1,52.1,0,0,0-22.2-9.35c-26.32-4.6-114.82-13.47-186.68,56.78-85.44,83.52-51.84,196.08-51.84,196.08S271.36,653.68,214.72,711.52s-19.92,128.64-1,146.16,34.56,28.56,73.92,30.48,73-30.72,73-30.72l262.08-261.6c15.36,2.88,113.76,28.8,197.28-52.32S875,348.16,875,348.16ZM788.84,511.32C713,589.87,611.36,546.4,611.36,546.4S336.48,820.64,331,825.76s-45.44,39-85.12,0c-36.6-36-5.69-76.37-.66-82.42.38-.46.77-.89,1.19-1.31L527.84,461.6C509,425.44,505.6,335.68,559.36,285.28s104.53-49.2,113.76-49.44c11.52-.29,30.24,2.88,30.24,2.88l-95.52,92.64,19.68,113.28L740.8,463.36l93.6-93.12c11.7,90.3-42.58,138.49-45.33,140.87Z"
      transform="translate(-184.45 -193.3)"
    />
    <circle className="cls-1" cx="109.15" cy="586.54" r="21.84" />
  </svg>
);

export const PersonIcon = ({ className }) => (
  <svg
    className={`${defaultClassName} ${className}`}
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 512 512"
  >
    <g id="XMLID_1_">
      <path
        id="XMLID_5_"
        d="M256,0C123.8,0,14.9,100.5,1.9,229C0.9,238.3,0,246.7,0,256c0,9.3,0.9,17.7,1.9,27
		c13,128.5,121.9,229,254.1,229c141.5,0,256-114.5,256-256S397.5,0,256,0z M423.6,401.2c-27.9-10.2-73.5-26.1-101.5-34.4
		c-2.8-0.9-3.7-0.9-3.7-13c0-10.2,3.7-20.5,8.4-28.9c4.7-9.3,9.3-25.1,11.2-39.1c5.6-5.6,12.1-17.7,16.8-40
		c3.7-19.5,1.9-27-0.9-33.5c0-0.9-0.9-1.9-0.9-1.9c-0.9-4.7,0-28.9,3.7-47.5c2.8-13-0.9-40-18.6-63.3c-11.2-14-32.6-31.7-71.7-34.4
		h-21.4c-39.1,2.8-60.5,20.5-71.7,34.4c-17.7,22.3-20.5,50.3-18.6,63.3c3.7,18.6,4.7,42.8,3.7,47.5c0,0.9-0.9,1.9-0.9,1.9
		c-2.8,6.5-4.7,14-0.9,33.5c4.7,22.3,11.2,34.4,16.8,40c1.9,14,7.4,29.8,11.2,39.1c2.8,6.5,4.7,15.8,4.7,28.9
		c0,12.1-0.9,12.1-2.8,13c-28.9,8.4-72.6,24.2-98.7,34.4C52.1,361.2,32.6,310,32.6,256c0-59.6,23.3-114.5,65.2-156.4
		s97.7-65.2,156.4-65.2s114.5,23.3,156.4,65.2s65.2,97.7,65.2,156.4C477.6,310,458,361.2,423.6,401.2z"
      />
    </g>
  </svg>
);

export const PersonIcon2 = ({ className, style }) => (
  <svg
    className={`${defaultClassName} ${className}`}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 16 20"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.84 16.1932C15.84 19.4892 11.32 19.8702 7.921 19.8702L7.67776 19.8699C5.51221 19.8647 0 19.728 0 16.1732C0 12.9444 4.33835 12.5129 7.71148 12.4967L8.16423 12.4964C10.3296 12.5016 15.84 12.6383 15.84 16.1932ZM7.921 13.9962C3.66 13.9962 1.5 14.7282 1.5 16.1732C1.5 17.6312 3.66 18.3702 7.921 18.3702C12.181 18.3702 14.34 17.6382 14.34 16.1932C14.34 14.7352 12.181 13.9962 7.921 13.9962ZM7.921 -0.000244141C10.849 -0.000244141 13.23 2.38176 13.23 5.30976C13.23 8.23775 10.849 10.6188 7.921 10.6188H7.889C4.967 10.6098 2.6 8.22676 2.60997 5.30676C2.60997 2.38176 4.992 -0.000244141 7.921 -0.000244141ZM7.921 1.42776C5.78 1.42776 4.03798 3.16876 4.03798 5.30976C4.031 7.44375 5.76 9.18376 7.892 9.19176L7.921 9.90575V9.19176C10.061 9.19176 11.802 7.44976 11.802 5.30976C11.802 3.16876 10.061 1.42776 7.921 1.42776Z"
    />
  </svg>
);

export const PersonInCircleIcon = ({ className }) => (
  <svg
    className={`${defaultClassName} ${className}`}
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
  >
    <path d="M10 0C8.06053 0.00368503 6.16393 0.571311 4.54128 1.63374C2.91862 2.69617 1.63994 4.20754 0.86099 5.98377C0.0820354 7.76 -0.163575 9.72442 0.154075 11.6378C0.471725 13.5511 1.33893 15.3308 2.65005 16.76C3.58647 17.775 4.72299 18.5851 5.98799 19.1392C7.25298 19.6933 8.61903 19.9793 10 19.9793C11.3811 19.9793 12.7471 19.6933 14.0121 19.1392C15.2771 18.5851 16.4136 17.775 17.35 16.76C18.6612 15.3308 19.5284 13.5511 19.846 11.6378C20.1637 9.72442 19.9181 7.76 19.1391 5.98377C18.3602 4.20754 17.0815 2.69617 15.4588 1.63374C13.8362 0.571311 11.9396 0.00368503 10 0ZM10 18C7.92851 17.9969 5.93896 17.1903 4.45005 15.75C4.90209 14.6495 5.67108 13.7083 6.6593 13.0459C7.64752 12.3835 8.81036 12.0298 10 12.0298C11.1897 12.0298 12.3526 12.3835 13.3408 13.0459C14.329 13.7083 15.098 14.6495 15.55 15.75C14.0611 17.1903 12.0716 17.9969 10 18ZM8.00005 8C8.00005 7.60444 8.11735 7.21776 8.33711 6.88886C8.55687 6.55996 8.86923 6.30362 9.23468 6.15224C9.60013 6.00087 10.0023 5.96126 10.3902 6.03843C10.7782 6.1156 11.1346 6.30608 11.4143 6.58579C11.694 6.86549 11.8844 7.22186 11.9616 7.60982C12.0388 7.99778 11.9992 8.39991 11.8478 8.76537C11.6964 9.13082 11.4401 9.44318 11.1112 9.66294C10.7823 9.8827 10.3956 10 10 10C9.46962 10 8.96091 9.78929 8.58584 9.41421C8.21076 9.03914 8.00005 8.53043 8.00005 8ZM16.91 14C16.0166 12.4718 14.6415 11.283 13 10.62C13.5092 10.0427 13.841 9.33066 13.9555 8.56944C14.0701 7.80822 13.9625 7.03011 13.6458 6.3285C13.3291 5.62688 12.8166 5.03156 12.17 4.61397C11.5233 4.19637 10.7698 3.97425 10 3.97425C9.23026 3.97425 8.47682 4.19637 7.83014 4.61397C7.18346 5.03156 6.67102 5.62688 6.3543 6.3285C6.03758 7.03011 5.93004 7.80822 6.04458 8.56944C6.15912 9.33066 6.49088 10.0427 7.00005 10.62C5.35865 11.283 3.98352 12.4718 3.09005 14C2.37799 12.7871 2.00177 11.4065 2.00005 10C2.00005 7.87827 2.8429 5.84344 4.34319 4.34315C5.84349 2.84285 7.87832 2 10 2C12.1218 2 14.1566 2.84285 15.6569 4.34315C17.1572 5.84344 18 7.87827 18 10C17.9983 11.4065 17.6221 12.7871 16.91 14Z" />
  </svg>
);

export const CalenderIcon = ({ className }) => (
  <svg
    className={`${defaultClassName} ${className}`}
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 22"
  >
    <path d="M10 18C10.1978 18 10.3911 17.9414 10.5556 17.8315C10.72 17.7216 10.8482 17.5654 10.9239 17.3827C10.9996 17.2 11.0194 16.9989 10.9808 16.8049C10.9422 16.6109 10.847 16.4327 10.7071 16.2929C10.5673 16.153 10.3891 16.0578 10.1951 16.0192C10.0011 15.9806 9.80004 16.0004 9.61732 16.0761C9.43459 16.1518 9.27841 16.28 9.16853 16.4444C9.05865 16.6089 9 16.8022 9 17C9 17.2652 9.10536 17.5196 9.29289 17.7071C9.48043 17.8946 9.73478 18 10 18ZM15 18C15.1978 18 15.3911 17.9414 15.5556 17.8315C15.72 17.7216 15.8482 17.5654 15.9239 17.3827C15.9996 17.2 16.0194 16.9989 15.9808 16.8049C15.9422 16.6109 15.847 16.4327 15.7071 16.2929C15.5673 16.153 15.3891 16.0578 15.1951 16.0192C15.0011 15.9806 14.8 16.0004 14.6173 16.0761C14.4346 16.1518 14.2784 16.28 14.1685 16.4444C14.0586 16.6089 14 16.8022 14 17C14 17.2652 14.1054 17.5196 14.2929 17.7071C14.4804 17.8946 14.7348 18 15 18ZM15 14C15.1978 14 15.3911 13.9414 15.5556 13.8315C15.72 13.7216 15.8482 13.5654 15.9239 13.3827C15.9996 13.2 16.0194 12.9989 15.9808 12.8049C15.9422 12.6109 15.847 12.4327 15.7071 12.2929C15.5673 12.153 15.3891 12.0578 15.1951 12.0192C15.0011 11.9806 14.8 12.0004 14.6173 12.0761C14.4346 12.1518 14.2784 12.28 14.1685 12.4444C14.0586 12.6089 14 12.8022 14 13C14 13.2652 14.1054 13.5196 14.2929 13.7071C14.4804 13.8946 14.7348 14 15 14ZM10 14C10.1978 14 10.3911 13.9414 10.5556 13.8315C10.72 13.7216 10.8482 13.5654 10.9239 13.3827C10.9996 13.2 11.0194 12.9989 10.9808 12.8049C10.9422 12.6109 10.847 12.4327 10.7071 12.2929C10.5673 12.153 10.3891 12.0578 10.1951 12.0192C10.0011 11.9806 9.80004 12.0004 9.61732 12.0761C9.43459 12.1518 9.27841 12.28 9.16853 12.4444C9.05865 12.6089 9 12.8022 9 13C9 13.2652 9.10536 13.5196 9.29289 13.7071C9.48043 13.8946 9.73478 14 10 14ZM17 2H16V1C16 0.734784 15.8946 0.48043 15.7071 0.292893C15.5196 0.105357 15.2652 0 15 0C14.7348 0 14.4804 0.105357 14.2929 0.292893C14.1054 0.48043 14 0.734784 14 1V2H6V1C6 0.734784 5.89464 0.48043 5.70711 0.292893C5.51957 0.105357 5.26522 0 5 0C4.73478 0 4.48043 0.105357 4.29289 0.292893C4.10536 0.48043 4 0.734784 4 1V2H3C2.20435 2 1.44129 2.31607 0.87868 2.87868C0.316071 3.44129 0 4.20435 0 5V19C0 19.7956 0.316071 20.5587 0.87868 21.1213C1.44129 21.6839 2.20435 22 3 22H17C17.7956 22 18.5587 21.6839 19.1213 21.1213C19.6839 20.5587 20 19.7956 20 19V5C20 4.20435 19.6839 3.44129 19.1213 2.87868C18.5587 2.31607 17.7956 2 17 2ZM18 19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H3C2.73478 20 2.48043 19.8946 2.29289 19.7071C2.10536 19.5196 2 19.2652 2 19V10H18V19ZM18 8H2V5C2 4.73478 2.10536 4.48043 2.29289 4.29289C2.48043 4.10536 2.73478 4 3 4H4V5C4 5.26522 4.10536 5.51957 4.29289 5.70711C4.48043 5.89464 4.73478 6 5 6C5.26522 6 5.51957 5.89464 5.70711 5.70711C5.89464 5.51957 6 5.26522 6 5V4H14V5C14 5.26522 14.1054 5.51957 14.2929 5.70711C14.4804 5.89464 14.7348 6 15 6C15.2652 6 15.5196 5.89464 15.7071 5.70711C15.8946 5.51957 16 5.26522 16 5V4H17C17.2652 4 17.5196 4.10536 17.7071 4.29289C17.8946 4.48043 18 4.73478 18 5V8ZM5 14C5.19778 14 5.39112 13.9414 5.55557 13.8315C5.72002 13.7216 5.84819 13.5654 5.92388 13.3827C5.99957 13.2 6.01937 12.9989 5.98079 12.8049C5.9422 12.6109 5.84696 12.4327 5.70711 12.2929C5.56725 12.153 5.38907 12.0578 5.19509 12.0192C5.00111 11.9806 4.80004 12.0004 4.61732 12.0761C4.43459 12.1518 4.27841 12.28 4.16853 12.4444C4.05865 12.6089 4 12.8022 4 13C4 13.2652 4.10536 13.5196 4.29289 13.7071C4.48043 13.8946 4.73478 14 5 14ZM5 18C5.19778 18 5.39112 17.9414 5.55557 17.8315C5.72002 17.7216 5.84819 17.5654 5.92388 17.3827C5.99957 17.2 6.01937 16.9989 5.98079 16.8049C5.9422 16.6109 5.84696 16.4327 5.70711 16.2929C5.56725 16.153 5.38907 16.0578 5.19509 16.0192C5.00111 15.9806 4.80004 16.0004 4.61732 16.0761C4.43459 16.1518 4.27841 16.28 4.16853 16.4444C4.05865 16.6089 4 16.8022 4 17C4 17.2652 4.10536 17.5196 4.29289 17.7071C4.48043 17.8946 4.73478 18 5 18Z" />
  </svg>
);

export const CalenderIcon2 = ({ className, style }) => (
  <svg
    className={`${defaultClassName} ${className}`}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 14 14"
  >
    <path d="M11.6667 1.66665H10.3333V0.99998C10.3333 0.823169 10.2631 0.653599 10.1381 0.528575C10.0131 0.403551 9.84349 0.333313 9.66668 0.333313C9.48987 0.333313 9.3203 0.403551 9.19527 0.528575C9.07025 0.653599 9.00001 0.823169 9.00001 0.99998V1.66665H5.00001V0.99998C5.00001 0.823169 4.92977 0.653599 4.80475 0.528575C4.67972 0.403551 4.51015 0.333313 4.33334 0.333313C4.15653 0.333313 3.98696 0.403551 3.86194 0.528575C3.73691 0.653599 3.66668 0.823169 3.66668 0.99998V1.66665H2.33334C1.80291 1.66665 1.2942 1.87736 0.91913 2.25243C0.544057 2.62751 0.333344 3.13621 0.333344 3.66665V11.6666C0.333344 12.1971 0.544057 12.7058 0.91913 13.0809C1.2942 13.4559 1.80291 13.6666 2.33334 13.6666H11.6667C12.1971 13.6666 12.7058 13.4559 13.0809 13.0809C13.456 12.7058 13.6667 12.1971 13.6667 11.6666V3.66665C13.6667 3.13621 13.456 2.62751 13.0809 2.25243C12.7058 1.87736 12.1971 1.66665 11.6667 1.66665ZM12.3333 11.6666C12.3333 11.8435 12.2631 12.013 12.1381 12.1381C12.0131 12.2631 11.8435 12.3333 11.6667 12.3333H2.33334C2.15653 12.3333 1.98696 12.2631 1.86194 12.1381C1.73691 12.013 1.66668 11.8435 1.66668 11.6666V6.99998H12.3333V11.6666ZM12.3333 5.66665H1.66668V3.66665C1.66668 3.48984 1.73691 3.32027 1.86194 3.19524C1.98696 3.07022 2.15653 2.99998 2.33334 2.99998H3.66668V3.66665C3.66668 3.84346 3.73691 4.01303 3.86194 4.13805C3.98696 4.26308 4.15653 4.33331 4.33334 4.33331C4.51015 4.33331 4.67972 4.26308 4.80475 4.13805C4.92977 4.01303 5.00001 3.84346 5.00001 3.66665V2.99998H9.00001V3.66665C9.00001 3.84346 9.07025 4.01303 9.19527 4.13805C9.3203 4.26308 9.48987 4.33331 9.66668 4.33331C9.84349 4.33331 10.0131 4.26308 10.1381 4.13805C10.2631 4.01303 10.3333 3.84346 10.3333 3.66665V2.99998H11.6667C11.8435 2.99998 12.0131 3.07022 12.1381 3.19524C12.2631 3.32027 12.3333 3.48984 12.3333 3.66665V5.66665Z" />
  </svg>
);

export const CalenderIcon3 = ({ className, style }) => (
  <svg
    className={`${defaultClassName} ${className}`}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 22"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7935 0C14.2075 0 14.5435 0.336 14.5435 0.75L14.544 1.59781C16.0041 1.69792 17.2167 2.19805 18.075 3.0581C19.012 3.9991 19.505 5.3521 19.5 6.9751V16.0981C19.5 19.4301 17.384 21.5001 13.979 21.5001H5.521C2.116 21.5001 0 19.4011 0 16.0221V6.9731C0 3.83029 1.88706 1.81294 4.96469 1.59815L4.9653 0.75C4.9653 0.336 5.3013 0 5.7153 0C6.1293 0 6.4653 0.336 6.4653 0.75L6.465 1.579H13.043L13.0435 0.75C13.0435 0.336 13.3795 0 13.7935 0ZM18 8.904H1.5V16.0221C1.5 18.5881 2.928 20.0001 5.521 20.0001H13.979C16.572 20.0001 18 18.6141 18 16.0981L18 8.904ZM14.2012 15.1963C14.6152 15.1963 14.9512 15.5323 14.9512 15.9463C14.9512 16.3603 14.6152 16.6963 14.2012 16.6963C13.7872 16.6963 13.4472 16.3603 13.4472 15.9463C13.4472 15.5323 13.7782 15.1963 14.1922 15.1963H14.2012ZM9.7637 15.1963C10.1777 15.1963 10.5137 15.5323 10.5137 15.9463C10.5137 16.3603 10.1777 16.6963 9.7637 16.6963C9.3497 16.6963 9.0097 16.3603 9.0097 15.9463C9.0097 15.5323 9.3407 15.1963 9.7547 15.1963H9.7637ZM5.3169 15.1963C5.7309 15.1963 6.0669 15.5323 6.0669 15.9463C6.0669 16.3603 5.7309 16.6963 5.3169 16.6963C4.9029 16.6963 4.5619 16.3603 4.5619 15.9463C4.5619 15.5323 4.8939 15.1963 5.3079 15.1963H5.3169ZM14.2012 11.3096C14.6152 11.3096 14.9512 11.6456 14.9512 12.0596C14.9512 12.4736 14.6152 12.8096 14.2012 12.8096C13.7872 12.8096 13.4472 12.4736 13.4472 12.0596C13.4472 11.6456 13.7782 11.3096 14.1922 11.3096H14.2012ZM9.7637 11.3096C10.1777 11.3096 10.5137 11.6456 10.5137 12.0596C10.5137 12.4736 10.1777 12.8096 9.7637 12.8096C9.3497 12.8096 9.0097 12.4736 9.0097 12.0596C9.0097 11.6456 9.3407 11.3096 9.7547 11.3096H9.7637ZM5.3169 11.3096C5.7309 11.3096 6.0669 11.6456 6.0669 12.0596C6.0669 12.4736 5.7309 12.8096 5.3169 12.8096C4.9029 12.8096 4.5619 12.4736 4.5619 12.0596C4.5619 11.6456 4.8939 11.3096 5.3079 11.3096H5.3169ZM13.043 3.079H6.465L6.4653 4.041C6.4653 4.455 6.1293 4.791 5.7153 4.791C5.3013 4.791 4.9653 4.455 4.9653 4.041L4.96477 3.1017C2.72454 3.28989 1.5 4.64786 1.5 6.9731V7.404H18L18 6.9731C18.004 5.7381 17.672 4.7781 17.013 4.1181C16.4345 3.53791 15.5889 3.1914 14.5444 3.10218L14.5435 4.041C14.5435 4.455 14.2075 4.791 13.7935 4.791C13.3795 4.791 13.0435 4.455 13.0435 4.041L13.043 3.079Z"
    />
  </svg>
);
export const LogoutIcon = ({ className }) => (
  <svg
    className={`${defaultClassName} ${className}`}
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
  >
    <path d="M10.59 11L8.29 13.29C8.19627 13.3829 8.12188 13.4935 8.07111 13.6154C8.02034 13.7373 7.9942 13.868 7.9942 14C7.9942 14.132 8.02034 14.2627 8.07111 14.3846C8.12188 14.5064 8.19627 14.617 8.29 14.71C8.38296 14.8037 8.49356 14.8781 8.61542 14.9289C8.73728 14.9796 8.86799 15.0058 9 15.0058C9.13201 15.0058 9.26272 14.9796 9.38458 14.9289C9.50644 14.8781 9.61704 14.8037 9.71 14.71L13.71 10.71C13.801 10.6149 13.8724 10.5027 13.92 10.38C14.02 10.1365 14.02 9.86344 13.92 9.61998C13.8724 9.49723 13.801 9.38508 13.71 9.28998L9.71 5.28998C9.61676 5.19674 9.50607 5.12278 9.38425 5.07232C9.26243 5.02186 9.13186 4.99589 9 4.99589C8.86814 4.99589 8.73757 5.02186 8.61575 5.07232C8.49393 5.12278 8.38324 5.19674 8.29 5.28998C8.19676 5.38322 8.1228 5.49391 8.07234 5.61573C8.02188 5.73755 7.99591 5.86812 7.99591 5.99998C7.99591 6.13184 8.02188 6.26241 8.07234 6.38423C8.1228 6.50605 8.19676 6.61674 8.29 6.70998L10.59 8.99998H1C0.734784 8.99998 0.48043 9.10534 0.292893 9.29287C0.105357 9.48041 0 9.73476 0 9.99998C0 10.2652 0.105357 10.5195 0.292893 10.7071C0.48043 10.8946 0.734784 11 1 11H10.59ZM10 -2.23766e-05C8.13109 -0.00836616 6.29724 0.50719 4.70647 1.48817C3.11569 2.46915 1.83165 3.87629 1 5.54998C0.880653 5.78867 0.861015 6.065 0.945406 6.31818C1.0298 6.57135 1.21131 6.78063 1.45 6.89998C1.68869 7.01932 1.96502 7.03896 2.2182 6.95457C2.47137 6.87018 2.68065 6.68867 2.8 6.44998C3.43219 5.1733 4.39383 4.0886 5.58555 3.30797C6.77727 2.52733 8.15582 2.0791 9.57876 2.00957C11.0017 1.94004 12.4174 2.25175 13.6795 2.91249C14.9417 3.57322 16.0045 4.55901 16.7581 5.76797C17.5118 6.97694 17.9289 8.36522 17.9664 9.78936C18.0039 11.2135 17.6605 12.6218 16.9715 13.8688C16.2826 15.1158 15.2731 16.1561 14.0475 16.8824C12.8219 17.6087 11.4246 17.9945 10 18C8.50888 18.0064 7.04615 17.5923 5.77969 16.8052C4.51323 16.0181 3.49435 14.8899 2.84 13.55C2.72065 13.3113 2.51137 13.1298 2.2582 13.0454C2.00502 12.961 1.72869 12.9806 1.49 13.1C1.25131 13.2193 1.0698 13.4286 0.985406 13.6818C0.901015 13.935 0.920653 14.2113 1.04 14.45C1.83283 16.0455 3.03752 17.4002 4.52947 18.374C6.02142 19.3478 7.74645 19.9054 9.52612 19.989C11.3058 20.0726 13.0755 19.6792 14.6521 18.8495C16.2288 18.0198 17.5552 16.784 18.4941 15.2698C19.433 13.7556 19.9503 12.0181 19.9925 10.237C20.0347 8.45585 19.6003 6.69577 18.7342 5.13881C17.8682 3.58185 16.6018 2.28454 15.0663 1.38108C13.5307 0.477623 11.7816 0.000814076 10 -2.23766e-05Z" />
  </svg>
);

export const LeftArrowIcon2 = ({ className }) => (
  <svg
    className={`${defaultClassName} ${className}`}
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 14 14"
  >
    <path
      opacity="0.2"
      d="M0.813876 5.6805C0.888652 5.61283 1.17099 5.3235 1.434 5.0855C2.97592 3.58867 6.99832 1.13867 9.10364 0.390833C9.42336 0.270666 10.2317 0.0163332 10.6636 -1.33898e-07C11.0774 -1.14761e-07 11.472 0.0839999 11.8484 0.254333C12.3177 0.492333 12.6941 0.866833 12.9004 1.309C13.0332 1.61583 13.2395 2.534 13.2395 2.55033C13.4458 3.55483 13.5592 5.187 13.5592 6.99067C13.5592 8.70917 13.4458 10.2748 13.2769 11.2945C13.2575 11.3108 13.0513 12.4518 12.8256 12.8427C12.4118 13.5567 11.6035 14 10.7384 14L10.6636 14C10.1002 13.9825 8.91541 13.5392 8.91541 13.5228C6.92354 12.7738 2.99397 10.444 1.41466 8.89583C1.41466 8.89583 0.969872 8.498 0.776488 8.2495C0.474807 7.8925 0.325257 7.45033 0.325257 7.00817C0.325257 6.51467 0.494147 6.055 0.813876 5.6805Z"
      fill="#030229"
    />
  </svg>
);

export const TruckIcon = ({ className, style }) => (
  <svg
    className={`${defaultClassName} ${className}`}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    style={style}
  >
    <path
      d="M8 19C8.53043 19 9.03914 18.7893 9.41421 18.4142C9.78929 18.0391 10 17.5304 10 17C10 16.4696 9.78929 15.9609 9.41421 15.5858C9.03914 15.2107 8.53043 15 8 15C7.46957 15 6.96086 15.2107 6.58579 15.5858C6.21071 15.9609 6 16.4696 6 17C6 17.5304 6.21071 18.0391 6.58579 18.4142C6.96086 18.7893 7.46957 19 8 19V19ZM18 19C18.5304 19 19.0391 18.7893 19.4142 18.4142C19.7893 18.0391 20 17.5304 20 17C20 16.4696 19.7893 15.9609 19.4142 15.5858C19.0391 15.2107 18.5304 15 18 15C17.4696 15 16.9609 15.2107 16.5858 15.5858C16.2107 15.9609 16 16.4696 16 17C16 17.5304 16.2107 18.0391 16.5858 18.4142C16.9609 18.7893 17.4696 19 18 19V19Z"
      stroke-width="1.5"
      stroke-miterlimit="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.05 17H15V6.6C15 6.44087 14.9368 6.28826 14.8243 6.17574C14.7117 6.06321 14.5591 6 14.4 6H1M5.65 17H3.6C3.52121 17 3.44319 16.9845 3.37039 16.9543C3.29759 16.9242 3.23145 16.88 3.17574 16.8243C3.12002 16.7685 3.07583 16.7024 3.04567 16.6296C3.01552 16.5568 3 16.4788 3 16.4V11.5"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M2 9H6"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15 9H20.61C20.726 9.00003 20.8395 9.03367 20.9367 9.09685C21.034 9.16003 21.1108 9.25005 21.158 9.356L22.948 13.384C22.9821 13.4605 22.9998 13.5433 23 13.627V16.4C23 16.4788 22.9845 16.5568 22.9543 16.6296C22.9242 16.7024 22.88 16.7685 22.8243 16.8243C22.7685 16.88 22.7024 16.9242 22.6296 16.9543C22.5568 16.9845 22.4788 17 22.4 17H20.5M15 17H16"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
);

export const Alarm = (className) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    className={`${defaultClassName} ${className}`}
  >
    <g>
      <g>
        <path
          d="M485.445,29.246c-17.123-17.124-39.891-26.555-64.108-26.555s-46.984,9.43-64.108,26.555
			c-3.983,3.983-3.983,10.441,0,14.424l48.924,48.924l-7.247,7.247C361.544,64.652,311.25,43.053,256,43.053
			c-55.25,0-105.544,21.599-142.904,56.786l-7.247-7.247l48.924-48.924c3.983-3.983,3.983-10.441,0-14.424
			C137.648,12.121,114.882,2.691,90.665,2.691s-46.985,9.43-64.108,26.555C9.431,46.369,0,69.137,0,93.354
			s9.431,46.984,26.555,64.108c1.913,1.912,4.507,2.987,7.212,2.987s5.299-1.075,7.212-2.987l50.445-50.446l7.513,7.513
			c-32.076,36.693-51.541,84.678-51.541,137.127c0,77.542,42.531,145.331,105.486,181.282l-58.961,58.961
			c-3.983,3.983-3.983,10.441,0,14.424c1.992,1.992,4.602,2.987,7.212,2.987s5.221-0.996,7.212-2.987l63.716-63.715
			c25.698,11.339,54.091,17.653,83.937,17.653c29.846,0,58.24-6.313,83.937-17.653l63.716,63.715
			c1.992,1.992,4.602,2.987,7.212,2.987c2.61,0,5.22-0.996,7.212-2.987c3.983-3.983,3.983-10.441,0-14.424l-58.961-58.961
			c62.956-35.951,105.486-103.74,105.486-181.282c0-52.45-19.464-100.435-51.541-137.127l7.513-7.513l50.445,50.446
			c1.913,1.912,4.507,2.987,7.212,2.987s5.298-1.075,7.212-2.987C502.569,140.338,512,117.571,512,93.354
			S502.569,46.369,485.445,29.246z M34.283,135.31c-9.011-12.056-13.884-26.632-13.884-41.956c0-18.769,7.309-36.414,20.581-49.685
			c13.27-13.27,30.915-20.579,49.684-20.579c15.323,0,29.899,4.872,41.956,13.884L34.283,135.31z M444.205,251.658
			c0,103.776-84.428,188.205-188.205,188.205S67.795,355.435,67.795,251.658S152.223,63.453,256,63.453
			S444.205,147.881,444.205,251.658z M477.717,135.31l-98.337-98.337c12.057-9.012,26.632-13.884,41.956-13.884
			c18.769,0,36.413,7.309,49.684,20.58c13.271,13.271,20.58,30.916,20.58,49.684C491.602,108.678,486.728,123.254,477.717,135.31z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M256,83.837c-92.536,0-167.821,75.283-167.821,167.82S163.464,419.477,256,419.477s167.821-75.283,167.821-167.82
			S348.536,83.837,256,83.837z M256,399.079c-81.289,0-147.422-66.133-147.422-147.421S174.711,104.235,256,104.235
			s147.422,66.133,147.422,147.421S337.289,399.079,256,399.079z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M256,129.029c-5.632,0-10.199,4.566-10.199,10.199v108.203l-46.613,46.615c-3.983,3.983-3.983,10.441,0,14.424
			c1.992,1.992,4.602,2.987,7.212,2.987s5.22-0.996,7.212-2.987l48.498-48.498c0.182-0.182,0.346-0.374,0.511-0.566
			c2.188-1.871,3.579-4.645,3.579-7.749V139.228C266.199,133.595,261.632,129.029,256,129.029z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M376.125,277.162c-5.395-1.622-11.082,1.438-12.704,6.831c-5.65,18.796-16.244,35.88-30.635,49.405
			c-4.104,3.857-4.305,10.312-0.447,14.417c2.007,2.136,4.717,3.215,7.434,3.215c2.504,0,5.014-0.917,6.983-2.767
			c17.001-15.978,29.519-36.17,36.2-58.397C384.578,284.472,381.52,278.783,376.125,277.162z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M320.215,356.32c-2.542-5.028-8.675-7.044-13.704-4.502c-3.275,1.655-6.673,3.166-10.098,4.49
			c-5.254,2.031-7.868,7.936-5.838,13.191c1.564,4.045,5.424,6.525,9.516,6.525c1.223,0,2.466-0.221,3.675-0.688
			c4.053-1.567,8.073-3.354,11.947-5.312C320.74,367.483,322.756,361.347,320.215,356.32z"
        />
      </g>
    </g>
  </svg>
);
export const Listing = (className) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1020 612"
  >
    <title>online_organizer</title>
    <path
      d="M569.75916,855.19685l-26.49227-74.17837s29.1415,14.57075,30.46612,33.11534c0,0-6.62307-92.723-19.86921-112.59217,0,0,21.19382,2.64923,45.03687,105.9691,0,0,3.97384-119.21524-31.79073-153.6552,0,0,49.01071,39.73842,52.98455,125.83831v75.503Z"
      transform="translate(-290 -244)"
      fill="#f2f2f2"
    />
    <path
      d="M1066.59028,855.19685l-6.36981-17.83546s7.00679,3.50339,7.32528,7.96226c0,0-1.59245-22.29433-4.77735-27.07168,0,0,5.09584.637,10.82867,25.47923,0,0,.95547-28.66414-7.64377-36.94488,0,0,11.78414,9.55471,12.73961,30.25658v18.154Z"
      transform="translate(-290 -244)"
      fill="#f2f2f2"
    />
    <circle cx="658.58268" cy="341.33858" r="116.45669" fill="#f2f2f2" />
    <rect y="8.83465" width="274.67717" height="152.59843" fill="#f2f2f2" />
    <rect
      x="372.66142"
      y="8.83465"
      width="274.67717"
      height="152.59843"
      fill="#f2f2f2"
    />
    <rect
      x="745.32283"
      y="8.83465"
      width="274.67717"
      height="152.59843"
      fill="#f2f2f2"
    />
    <path
      d="M996.08615,855.61568c-.18431-.30118-4.53026-7.55776-6.03695-22.62623-1.382-13.82453-.49334-37.12685,11.59155-69.63166,22.89447-61.5782-5.27616-111.26289-5.564-111.7578l1.38983-.80628c.07294.12549,7.34207,12.79313,11.63625,32.96443a143.81285,143.81285,0,0,1-5.95617,80.15966c-22.85525,61.4731-5.86362,90.57394-5.6895,90.861Z"
      transform="translate(-290 -244)"
      fill="#3f3d56"
    />
    <circle cx="697.13386" cy="393.54331" r="10.44094" fill="#6c63ff" />
    <circle cx="730.06299" cy="432.09449" r="10.44094" fill="#3f3d56" />
    <circle cx="707.5748" cy="457.79528" r="10.44094" fill="#6c63ff" />
    <circle cx="734.88189" cy="479.48031" r="10.44094" fill="#6c63ff" />
    <circle cx="699.54331" cy="513.2126" r="10.44094" fill="#3f3d56" />
    <path
      d="M1002.3937,856s-10.44094-25.70079,20.88189-44.97638Z"
      transform="translate(-290 -244)"
      fill="#3f3d56"
    />
    <path
      d="M989.553,855.5338s-4.75177-27.33065-41.52966-27.09641Z"
      transform="translate(-290 -244)"
      fill="#3f3d56"
    />
    <rect x="0.40157" width="273.87402" height="13.65354" fill="#3f3d56" />
    <rect x="373.06299" width="274.67717" height="13.65354" fill="#3f3d56" />
    <rect x="745.72441" width="273.87402" height="13.65354" fill="#3f3d56" />
    <rect
      x="20.88189"
      y="34.93701"
      width="49.79528"
      height="35.33858"
      fill="#fff"
    />
    <rect
      x="116.45669"
      y="34.93701"
      width="137.33858"
      height="4.01575"
      fill="#fff"
    />
    <rect x="116.45669" y="51" width="137.33858" height="4.01575" fill="#fff" />
    <rect
      x="116.45669"
      y="67.06299"
      width="137.33858"
      height="4.01575"
      fill="#fff"
    />
    <rect
      x="393.54331"
      y="34.93701"
      width="49.79528"
      height="35.33858"
      fill="#fff"
    />
    <rect
      x="489.11811"
      y="34.93701"
      width="137.33858"
      height="4.01575"
      fill="#fff"
    />
    <rect x="489.11811" y="51" width="137.33858" height="4.01575" fill="#fff" />
    <rect
      x="489.11811"
      y="67.06299"
      width="137.33858"
      height="4.01575"
      fill="#fff"
    />
    <rect
      x="766.20472"
      y="34.93701"
      width="49.79528"
      height="35.33858"
      fill="#fff"
    />
    <rect
      x="861.77953"
      y="34.93701"
      width="137.33858"
      height="4.01575"
      fill="#fff"
    />
    <rect x="861.77953" y="51" width="137.33858" height="4.01575" fill="#fff" />
    <rect
      x="861.77953"
      y="67.06299"
      width="137.33858"
      height="4.01575"
      fill="#fff"
    />
    <circle cx="45.77953" cy="53.00787" r="16.06299" fill="#6c63ff" />
    <circle cx="791.10236" cy="53.00787" r="16.06299" fill="#6c63ff" />
    <rect
      x="126.71411"
      y="161.43307"
      width="1.6063"
      height="4.8189"
      fill="#3f3d56"
    />
    <path
      d="M418.3204,603.00787h-1.60629v-9.63779h1.60629Zm0-19.27559h-1.60629v-9.63779h1.60629Zm0-19.27559h-1.60629V554.8189h1.60629Zm0-19.27559h-1.60629v-9.63779h1.60629Zm0-19.27559h-1.60629v-9.63779h1.60629Zm0-19.27559h-1.60629v-9.63779h1.60629Zm0-19.27559h-1.60629v-9.63779h1.60629Zm0-19.27559h-1.60629v-9.6378h1.60629Zm0-19.27559h-1.60629v-9.6378h1.60629Zm0-19.27559h-1.60629v-9.6378h1.60629Z"
      transform="translate(-290 -244)"
      fill="#3f3d56"
    />
    <polygon
      points="132.336 374.268 126.714 374.268 126.714 368.646 128.32 368.646 128.32 372.661 132.336 372.661 132.336 374.268"
      fill="#3f3d56"
    />
    <path
      d="M1158.1608,618.26772h-9.68172v-1.6063h9.68172Zm-19.36343,0h-9.68172v-1.6063h9.68172Zm-19.36344,0h-9.6825v-1.6063h9.6825Zm-19.36422,0H1090.388v-1.6063h9.68171Zm-19.36343,0h-9.6825v-1.6063h9.6825Zm-19.36422,0h-9.68172v-1.6063h9.68172Zm-19.36344,0h-9.6825v-1.6063h9.6825Zm-19.36422,0h-9.68171v-1.6063h9.68171Zm-19.36343,0h-9.6825v-1.6063h9.6825Zm-19.36422,0H974.205v-1.6063h9.68172Zm-19.36344,0h-9.6825v-1.6063h9.6825Zm-19.36421,0h-9.68172v-1.6063h9.68172Zm-19.36344,0h-9.6825v-1.6063h9.6825Zm-19.36422,0h-9.68172v-1.6063h9.68172Zm-19.36343,0H877.3855v-1.6063H887.068Zm-19.36422,0h-9.68172v-1.6063h9.68172Zm-19.36344,0h-9.6825v-1.6063h9.6825Zm-19.36422,0h-9.68172v-1.6063h9.68172Zm-19.36343,0h-9.68211v-1.6063h9.68211Zm-19.36383,0h-9.68211v-1.6063h9.68211Zm-19.36383,0h-9.68211v-1.6063H770.885Zm-19.36382,0h-9.68211v-1.6063h9.68211Zm-19.36383,0h-9.68211v-1.6063h9.68211Zm-19.36383,0h-9.68211v-1.6063h9.68211Zm-19.36383,0h-9.68211v-1.6063h9.68211Zm-19.36382,0H664.3838v-1.6063h9.68211Zm-19.36383,0H645.02v-1.6063h9.68211Zm-19.36383,0h-9.68211v-1.6063h9.68211Zm-19.36383,0h-9.6821v-1.6063h9.6821Zm-19.36382,0h-9.68211v-1.6063h9.68211Zm-19.36383,0h-9.68211v-1.6063h9.68211Zm-19.36383,0h-9.68171v-1.6063h9.68171Zm-19.36382,0H528.8374v-1.6063h9.68172Zm-19.36383,0h-9.68172v-1.6063h9.68172Zm-19.36383,0h-9.68172v-1.6063h9.68172Zm-19.36383,0h-9.68171v-1.6063h9.68171Zm-19.36382,0h-9.68172v-1.6063h9.68172Zm-19.36383,0h-9.68172v-1.6063H441.7Z"
      transform="translate(-290 -244)"
      fill="#3f3d56"
    />
    <polygon
      points="883.465 374.268 877.843 374.268 877.843 372.661 881.858 372.661 881.858 368.646 883.465 368.646 883.465 374.268"
      fill="#3f3d56"
    />
    <path
      d="M1173.46457,603.00787h-1.6063v-9.63779h1.6063Zm0-19.27559h-1.6063v-9.63779h1.6063Zm0-19.27559h-1.6063V554.8189h1.6063Zm0-19.27559h-1.6063v-9.63779h1.6063Zm0-19.27559h-1.6063v-9.63779h1.6063Zm0-19.27559h-1.6063v-9.63779h1.6063Zm0-19.27559h-1.6063v-9.63779h1.6063Zm0-19.27559h-1.6063v-9.6378h1.6063Zm0-19.27559h-1.6063v-9.6378h1.6063Zm0-19.27559h-1.6063v-9.6378h1.6063Z"
      transform="translate(-290 -244)"
      fill="#3f3d56"
    />
    <rect
      x="881.85827"
      y="161.43307"
      width="1.6063"
      height="4.8189"
      fill="#3f3d56"
    />
    <rect
      x="372.66142"
      y="325.27559"
      width="274.67717"
      height="285.92126"
      fill="#3f3d56"
    />
    <rect
      x="393.54331"
      y="362.62205"
      width="49.79528"
      height="35.33858"
      fill="#fff"
    />
    <rect
      x="489.11811"
      y="362.62205"
      width="137.33858"
      height="4.01575"
      fill="#fff"
    />
    <rect
      x="489.11811"
      y="378.68504"
      width="137.33858"
      height="4.01575"
      fill="#fff"
    />
    <rect
      x="489.11811"
      y="394.74803"
      width="137.33858"
      height="4.01575"
      fill="#fff"
    />
    <rect
      x="393.54331"
      y="489.92126"
      width="49.79528"
      height="35.33858"
      fill="#fff"
    />
    <rect
      x="489.11811"
      y="489.92126"
      width="137.33858"
      height="4.01575"
      fill="#fff"
    />
    <rect
      x="489.11811"
      y="505.98425"
      width="137.33858"
      height="4.01575"
      fill="#fff"
    />
    <rect
      x="489.11811"
      y="522.04724"
      width="137.33858"
      height="4.01575"
      fill="#fff"
    />
    <polygon
      points="418.652 389.229 401.607 366.503 405.645 363.475 419.53 381.989 454.923 353.324 458.119 357.23 418.652 389.229"
      fill="#6c63ff"
    />
    <polygon
      points="418.652 515.324 401.607 492.598 405.645 489.57 419.53 508.083 454.923 479.418 458.119 483.325 418.652 515.324"
      fill="#6c63ff"
    />
    <rect
      x="7.22835"
      y="610.3937"
      width="991.88976"
      height="1.6063"
      fill="#3f3d56"
    />
    <path
      d="M834.57387,414.26772s26.50393-11.54886,38.95275.65077S840.19591,423.10236,834.57387,414.26772Z"
      transform="translate(-290 -244)"
      fill="#3f3d56"
    />
    <path
      d="M880.33918,359.49668c-8.90681-15.04974-26.52821-15.75113-26.52821-15.75113s-17.171-2.19581-28.18616,20.72513c-10.267,21.3642-24.4367,41.99177-2.28122,46.993l4.00193-12.45578,2.47837,13.3831a86.68625,86.68625,0,0,0,9.47951.162c23.72674-.766,46.32287.22413,45.59531-8.29C883.93154,392.94459,888.90931,373.97754,880.33918,359.49668Z"
      transform="translate(-290 -244)"
      fill="#2f2e41"
    />
    <path
      d="M892.80221,632.32283s-11.24409,20.88189-18.47244,20.88189-6.4252,13.65355-4.8189,16.86615,5.62205,10.44094-.80315,20.88189c-2.24432,3.647-1.84284,7.784-.37009,11.62368,4.12646,10.75826,20.17827,7.49888,19.66619-4.01223q-.00848-.19035-.02051-.38311c-.80315-12.85039,5.62205-32.92913,12.04725-37.748s12.04724-17.66929,12.04724-17.66929Z"
      transform="translate(-290 -244)"
      fill="#ffb8b8"
    />
    <path
      d="M815.69985,627.50394s11.24409,20.88189,18.47244,20.88189,6.4252,13.65354,4.8189,16.86614-5.622,10.44094.80315,20.88189c2.24432,3.647,1.84284,7.784.37009,11.62368-4.12646,10.75827-20.17827,7.49888-19.66619-4.01223q.00847-.19035.02051-.38311c.80315-12.85039-5.622-32.92913-12.04725-37.748s-12.04724-17.66929-12.04724-17.66929Z"
      transform="translate(-290 -244)"
      fill="#ffb8b8"
    />
    <path
      d="M824.53449,524.70079l-4.81889,10.44094s-70.67717,23.29134-64.252,50.59843,37.748,69.874,42.56693,68.26771,30.51968-6.42519,31.32283-20.07874-18.47244-37.748-18.47244-37.748l26.50394-24.09449,38.56752-.80315L908.8652,596.1811s-34.53543,30.51969-19.27559,42.56693,37.748,20.07874,40.96063,15.25984,39.35433-76.29921,33.73229-82.72441-62.64567-30.51968-62.64567-30.51968l-15.25985-21.685-59.43307-3.2126Z"
      transform="translate(-290 -244)"
      fill="#2f2e41"
    />
    <path
      d="M838.99119,392.1811s4.01575,26.50394-4.01575,29.71654,16.063,16.86614,16.063,16.86614H864.692l8.83464-18.47244s-8.0315-14.45669-3.2126-28.11024S838.99119,392.1811,838.99119,392.1811Z"
      transform="translate(-290 -244)"
      fill="#ffb8b8"
    />
    <path
      d="M838.99119,392.1811s4.01575,26.50394-4.01575,29.71654,16.063,16.86614,16.063,16.86614H864.692l8.83464-18.47244s-8.0315-14.45669-3.2126-28.11024S838.99119,392.1811,838.99119,392.1811Z"
      transform="translate(-290 -244)"
      opacity="0.1"
    />
    <path
      d="M833.36914,414.66929s8.83465,9.6378,10.44095,11.2441,8.83464,10.44094,24.09448-2.40945,16.86615,2.40945,16.86615,2.40945v96.378s-12.8504-5.622-23.29134,0-32.126-1.6063-32.126-1.6063l-4.01575-99.59055Z"
      transform="translate(-290 -244)"
      fill="#fff"
    />
    <path
      d="M839.26859,414.66929s-7.50575-3.2126-13.931,0-28.91338,19.27559-27.30708,26.50394S820.51875,499,806.06205,523.09449s-16.86614,30.51968-16.86614,30.51968l35.33858-18.47244s27.30709-16.86614,24.89764-27.30708S839.26859,414.66929,839.26859,414.66929Z"
      transform="translate(-290 -244)"
      fill="#6c63ff"
    />
    <path
      d="M871.12665,414.66929s16.85666,1.6063,17.65981,3.2126,25.29922,8.43307,23.69292,15.66142-23.69292,71.88189-14.05512,83.92913,25.70079,28.91339,20.07874,30.51969-15.25984-2.40945-24.89764,0-32.126-17.6693-29.71653-39.35433S863.90777,420.29134,871.12665,414.66929Z"
      transform="translate(-290 -244)"
      fill="#6c63ff"
    />
    <path
      d="M830.95969,568.07087v8.03149s-4.01575,18.47244,8.83465,17.66929,4.8189-22.48819,4.8189-22.48819l-.80315-7.22834Z"
      transform="translate(-290 -244)"
      fill="#ffb8b8"
    />
    <path
      d="M867.10142,568.874s-8.83464,18.47244,0,20.07874,15.25985-10.441,15.25985-13.65355S867.10142,568.874,867.10142,568.874Z"
      transform="translate(-290 -244)"
      fill="#ffb8b8"
    />
    <ellipse
      cx="588.74709"
      cy="137.33858"
      rx="1.6063"
      ry="3.2126"
      fill="#ffb8b8"
    />
    <ellipse
      cx="541.36127"
      cy="137.33858"
      rx="1.6063"
      ry="3.2126"
      fill="#ffb8b8"
    />
    <path
      d="M892.80221,425.11024s20.07874,0,19.27559,8.03149S884.77072,579.315,884.77072,579.315s-11.2441-10.44094-20.88189-8.0315Z"
      transform="translate(-290 -244)"
      fill="#6c63ff"
    />
    <path
      d="M814.8967,427.51969s-20.07874,4.01574-20.07874,16.063,28.91339,127.70078,32.92913,127.70078,19.27559-2.40944,19.27559-6.42519S814.8967,427.51969,814.8967,427.51969Z"
      transform="translate(-290 -244)"
      fill="#6c63ff"
    />
    <path
      d="M819.314,451.2126l18.07087,70.67S828.95182,460.04724,819.314,451.2126Z"
      transform="translate(-290 -244)"
      opacity="0.2"
    />
    <path
      d="M889.60328,441.28263l-18.27637,92.39721S877.16812,446.6125,889.60328,441.28263Z"
      transform="translate(-290 -244)"
      opacity="0.2"
    />
    <circle cx="565.05418" cy="137.74016" r="23.29134" fill="#ffb8b8" />
    <polygon
      points="586.401 114.046 568.992 104.927 544.951 108.657 539.977 130.626 552.359 130.15 555.818 122.079 555.818 130.017 561.531 129.797 564.847 116.947 566.92 130.626 587.23 130.212 586.401 114.046"
      fill="#2f2e41"
    />
  </svg>
);
export const Growth = (className) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 736.82665 633.87739"
  >
    <path
      d="M325.92294,211.15459s9.67082,22.96817-12.0885,33.84783,58.02488,31.43013,66.48684,4.8354c0,0-21.75933-8.462-12.08851-33.84784Z"
      transform="translate(-231.58668 -133.06131)"
      fill="#ffb9b9"
    />
    <polygon
      points="120.327 552.567 119.118 577.953 139.668 581.58 139.668 556.194 120.327 552.567"
      fill="#ffb9b9"
    />
    <polygon
      points="42.96 552.567 44.169 577.953 23.619 581.58 23.619 556.194 42.96 552.567"
      fill="#ffb9b9"
    />
    <circle cx="117.90887" cy="58.14723" r="33.84783" fill="#ffb9b9" />
    <polygon
      points="165.055 303.544 163.845 313.214 169.89 336.183 178.351 315.633 165.055 303.544"
      fill="#ffb9b9"
    />
    <path
      d="M262.4583,440.23188l-7.25309,85.82843s-8.462,15.7151-3.62655,29.01241c0,0-7.25309,18.13278-4.83541,24.17706s3.62655,12.0885,1.20881,14.50623-3.62654,70.11338,0,76.1576,6.04428,20.55046,6.04428,20.55046,20.55046,4.83541,25.38587-8.462,2.41768-14.50623,7.25309-18.13277,4.83541-54.39828,4.83541-54.39828-6.04428-6.04428-2.41768-8.462,6.04428,0,2.41768-6.04428-9.67082-6.04428-3.62654-8.462a57.63955,57.63955,0,0,0,9.67082-4.83542l35.05669-91.8727s13.29737,102.75234,15.715,107.58775,6.04428-1.20881,2.41768,4.83541-4.83541,2.41768-3.62654,6.04428-7.25309,55.60715-2.41768,66.48683a163.82283,163.82283,0,0,1,7.25309,19.34165s19.34164,8.462,21.75932,2.41773,1.20881-16.92391,4.83541-18.13278,7.25309-3.62654,7.25309-13.29736,7.25309-56.816,7.25309-56.816-8.462-3.62654-6.04428-9.67082,2.41774-4.83541,1.20887-9.67082-3.62654-6.04428-1.20887-9.67082,2.41774-14.50624,2.41774-14.50624l14.50623-95.49924-11.20216-32.639Z"
      transform="translate(-231.58668 -133.06131)"
      fill="#2f2e41"
    />
    <path
      d="M353.12213,704.9703s-3.62654-3.62654-4.83541,0-1.20886,37.47437-1.20886,37.47437,9.67082,7.25309,9.67082,10.87964,7.25309,15.715,24.17706,13.29736q.25386-.03628.50229-.07579a16.0046,16.0046,0,0,0,11.90012-22.65438l-17.23783-36.50357S364.00177,695.29954,353.12213,704.9703Z"
      transform="translate(-231.58668 -133.06131)"
      fill="#2f2e41"
    />
    <path
      d="M273.33793,704.9703s3.62655-3.62654,4.83541,0,1.20887,37.47437,1.20887,37.47437-9.67082,7.25309-9.67082,10.87964-7.25309,15.715-24.17706,13.29736q-.25386-.03628-.50229-.07579a16.0047,16.0047,0,0,1-11.9001-22.65438l17.2378-36.50357S262.4583,695.29954,273.33793,704.9703Z"
      transform="translate(-231.58668 -133.06131)"
      fill="#2f2e41"
    />
    <path
      d="M323.69805,154.54587l-6.04755-2.42109s12.64474-13.92113,30.23757-12.71054L342.94,133.96676s12.095-4.84209,23.09046,7.86847c5.78011,6.68169,12.4677,14.53563,16.63675,23.383h6.47644L386.44069,171.17l9.46066,5.95179-9.71044-1.0691a32.93394,32.93394,0,0,1-.91843,15.41446l.2603,4.70428S374.277,178.7565,374.277,176.33542v6.05268s-6.04749-5.44739-6.04749-9.079l-3.29862,4.23687-1.64931-6.658L342.94,177.546l3.29862-5.44738-12.64479,1.81576,4.9481-6.658s-14.29405,7.86848-14.84391,14.52645c-.5497,6.65788-7.69664,15.13165-7.69664,15.13165l-3.29862-6.05267S307.75463,163.62485,323.69805,154.54587Z"
      transform="translate(-231.58668 -133.06131)"
      fill="#2f2e41"
    />
    <path
      d="M401.47619,266.15731h13.4682a4.35761,4.35761,0,0,1,4.25323,3.3997c2.07832,9.2028,7.43389,35.28949,6.45563,55.834-1.20887,25.38587,1.20886,43.51864,0,47.14519s0,4.83541,0,8.462,3.62654,1.20887,0,6.04425-3.62655,3.62655-3.62655,7.25312-12.0885,59.23372-12.0885,59.23372-8.31069-13.65913-17.45274-11.06051l1.73764-49.382,2.41774-20.55048-3.62655-36.26553Z"
      transform="translate(-231.58668 -133.06131)"
      fill="#3f3d56"
    />
    <path
      d="M342.84691,253.46438s-20.55046-.74694-27.19914-9.43985c0,0-42.91424,14.27526-47.7496,26.36377s16.92391,66.48684,16.92391,66.48684-37.47442,111.21429-19.3417,111.21429,59.23369,14.50624,83.41075,6.04425a310.72112,310.72112,0,0,1,45.93638-12.0885s2.41768-32.639,0-38.68323-8.462-2.41771-4.83541-10.87966,2.41773-9.6708,1.20886-13.29737,2.41774-8.462,2.41774-13.29737-1.20882-15.71507-1.20882-15.71507,32.639-76.1576,25.38587-83.41072-44.17329-21.22855-44.17329-21.22855S363.39736,258.29975,342.84691,253.46438Z"
      transform="translate(-231.58668 -133.06131)"
      fill="#3f3d56"
    />
    <path
      d="M247.95206,448.69384s-10.87963,56.816,7.25309,51.9806,9.67083-51.9806,9.67083-51.9806Z"
      transform="translate(-231.58668 -133.06131)"
      fill="#ffb9b9"
    />
    <path
      d="M275.75567,266.15731l-4.29324,2.14662a12.10773,12.10773,0,0,0-6.48559,8.59811l-17.02478,90.79878s-4.83541,10.87967-4.83541,12.08851,2.41768,1.20881,0,4.83541-6.04427,2.4177-3.62654,4.83541a7.48769,7.48769,0,0,1,2.41773,4.83541l2.41768,59.23372s20.55046-6.04425,26.59473,0c0,0-6.04427-18.13278-2.41773-24.17706s3.62655-14.5062,3.62655-14.5062-2.41774,0,3.62654-6.04426,7.25309-8.462,6.04428-9.67079-2.41768-12.0885-2.41768-13.29737,12.0885-82.20188,12.0885-82.20188Z"
      transform="translate(-231.58668 -133.06131)"
      fill="#3f3d56"
    />
    <path
      d="M527.41332,148.10156a7.00787,7.00787,0,0,0-7,7v296a7.00777,7.00777,0,0,0,7,6.99952h434a7.00807,7.00807,0,0,0,7-6.99952v-296a7.00818,7.00818,0,0,0-7-7Z"
      transform="translate(-231.58668 -133.06131)"
      fill="#e6e6e6"
    />
    <path
      d="M537.41332,158.10156a7.00787,7.00787,0,0,0-7,7V441.10108a7.00787,7.00787,0,0,0,7,7h414a7.00818,7.00818,0,0,0,7-7V165.10156a7.00818,7.00818,0,0,0-7-7Z"
      transform="translate(-231.58668 -133.06131)"
      fill="#fff"
    />
    <polygon
      points="329.713 255 351.608 238.989 438.145 225.264 491.319 211.54 520.512 223.089 560.131 166.937 587.239 172.655 627.901 128.052 648.753 134.914 696.713 56 696.713 254.89 329.713 255"
      fill="#6c63ff"
      opacity="0.2"
    />
    <path
      d="M563.80007,387.56131a2,2,0,0,1,0-4c92.415,0,180.54981-18.50391,248.16992-52.10352,63.40723-31.50683,103.81348-74.23144,110.85645-117.21972a1.99993,1.99993,0,1,1,3.94727.64648c-3.65821,22.33057-15.53418,44.23535-35.2959,65.10644-19.49024,20.58448-45.6416,39.106-77.72754,55.04883C745.58816,368.909,656.82058,387.56131,563.80007,387.56131Z"
      transform="translate(-231.58668 -133.06131)"
      fill="#6c63ff"
    />
    <polygon
      points="711.827 254.904 329.827 254.904 329.827 66.176 331.827 66.176 331.827 252.904 711.827 252.904 711.827 254.904"
      fill="#e6e6e6"
    />
  </svg>
);
export const Architecture = (className) => (
  <svg
    id="06c42c9d-6d9c-45ee-a61b-17902c1dca73"
    className={className}
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1145.57 819.91"
  >
    <defs>
      <linearGradient
        id="2f697947-2a6f-450c-95af-56e5336b1d5f"
        x1="591.3"
        y1="646.08"
        x2="591.3"
        y2="107.75"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="gray" stopOpacity="0.25" />
        <stop offset="0.54" stopColor="gray" stopOpacity="0.12" />
        <stop offset="1" stopColor="gray" stopOpacity="0.1" />
      </linearGradient>
      <linearGradient
        id="2563b911-9cd4-457d-b636-acc38b40f33a"
        x1="944.34"
        y1="854.67"
        x2="944.34"
        y2="289.29"
      />
    </defs>
    <title>security</title>
    <path
      d="M1154.4,591.26c-26.57,54.81-80.52,91.46-136.43,115.63-75.27,32.55-158.16,45.46-239.91,40q-21.49-1.43-42.85-4.57a540.44,540.44,0,0,1-143.27-41.72q-19.74-8.89-38.68-19.41a494.85,494.85,0,0,1-60.46-39.54q-7.23-5.52-14.26-11.32c-3.25-2.68-6.47-5.42-9.74-8.08-6.9-5.61-14-10.94-21.92-14.93a78.31,78.31,0,0,0-7.34-3.24c-25.08-9.54-54-5.94-80.11,1.5-19.86,5.66-39.22,13.41-59.06,18.94a196,196,0,0,1-26.91,5.72A143.21,143.21,0,0,1,213,624.93l-1.67-.52q-4.2-1.32-8.33-2.89l-1.67-.64q-4-1.54-7.83-3.31l-1.67-.76q-4-1.86-7.83-3.93c-.92-.48-1.83-1-2.73-1.49a163.67,163.67,0,0,1-39.16-30.49c-.33-.33-.64-.67-1-1-1.59-1.72-3.15-3.47-4.66-5.26-.56-.66-1.12-1.32-1.67-2q-2.69-3.28-5.19-6.71c-.25-.33-.49-.67-.73-1A144.59,144.59,0,0,1,112,534.44c-.14-.33-.27-.67-.39-1q-2-5.15-3.65-10.47c-.45-1.48-.88-3-1.26-4.48-.13-.44-.25-.89-.36-1.33-5.52-21.73-6.15-44.32-6.15-66.78q0-3.93,0-7.85c.16-36.33.72-73.28,6.08-109.11,0-.25.07-.5.11-.74a340.76,340.76,0,0,1,7.31-35.82A264.25,264.25,0,0,1,126,260.56c12.33-29,30.26-55.39,50.17-79.85C226.32,119.16,292.09,67.49,369.07,48.15c82.95-20.83,175.14-.87,242.05,52.4,20.4,16.24,38.73,35.47,61.64,47.92,20,10.84,43.41,15.33,64.83,6.8,17.7-7.05,29.22-10.55,49.1-9.48A411.56,411.56,0,0,1,907.05,171c1.56.57,3.12,1.16,4.67,1.75C1012.43,211.28,1099,287.83,1144,386.2q1.79,3.9,3.47,7.86C1174.3,456.73,1184,530.18,1154.4,591.26Z"
      transform="translate(-26.97 -40.04)"
      fill="#6c63ff"
      opacity="0.1"
    />
    <ellipse
      cx="120.3"
      cy="728.81"
      rx="88.28"
      ry="14.18"
      fill="#6c63ff"
      opacity="0.1"
    />
    <ellipse
      cx="912.26"
      cy="804.71"
      rx="156.53"
      ry="15.2"
      fill="#6c63ff"
      opacity="0.1"
    />
    <rect
      x="116.14"
      y="107.75"
      width="950.33"
      height="538.33"
      rx="12.49"
      ry="12.49"
      fill="url(#2f697947-2a6f-450c-95af-56e5336b1d5f)"
    />
    <rect
      x="117.65"
      y="115.32"
      width="947.42"
      height="528.97"
      rx="12.49"
      ry="12.49"
      fill="#fff"
    />
    <rect
      x="117.65"
      y="115.32"
      width="947.42"
      height="528.97"
      rx="12.49"
      ry="12.49"
      fill="#fff"
    />
    <rect
      x="117.65"
      y="115.32"
      width="947.42"
      height="528.97"
      rx="12.49"
      ry="12.49"
      fill="#fff"
      opacity="0.04"
    />
    <path
      d="M1087.23,149.29H149.43a4.81,4.81,0,0,0-4.81,4.81v20.33H1092V154.1A4.81,4.81,0,0,0,1087.23,149.29Z"
      transform="translate(-26.97 -40.04)"
      fill="#5a5773"
    />
    <g id="6c975d28-8d47-4ade-9154-b3b78f637b65" data-name="buttons">
      <circle cx="136.57" cy="121.82" r="6.5" fill="#fff" />
      <circle cx="154.07" cy="121.82" r="6.5" fill="#fff" />
      <circle cx="171.57" cy="121.82" r="6.5" fill="#fff" />
    </g>
    <rect
      x="195.68"
      y="181.67"
      width="254.25"
      height="21.58"
      fill="#6c63ff"
      opacity="0.2"
    />
    <rect
      x="195.68"
      y="268.2"
      width="791.36"
      height="331.96"
      fill="#5a5773"
      opacity="0.1"
    />
    <path
      d="M686,329.89H672.45V303.57c0-29.7-23.68-54.39-53.38-54.84a54.28,54.28,0,0,0-54.85,54.11v27.05H550.7a22.62,22.62,0,0,0-22.55,22.55V460.66a22.62,22.62,0,0,0,22.55,22.55H686a22.61,22.61,0,0,0,22.54-22.55V352.44A22.61,22.61,0,0,0,686,329.89Zm-59.75,70.35V439a8.09,8.09,0,0,1-7.5,8.12,7.91,7.91,0,0,1-8.28-7.9v-39a18,18,0,1,1,15.78,0Zm30.44-70.35H580V302.84a38.33,38.33,0,0,1,76.66,0Z"
      transform="translate(-26.97 -40.04)"
      opacity="0.1"
    />
    <path
      d="M686,327.89H672.45V301.57c0-29.7-23.68-54.39-53.38-54.84a54.28,54.28,0,0,0-54.85,54.11v27.05H550.7a22.62,22.62,0,0,0-22.55,22.55V458.66a22.62,22.62,0,0,0,22.55,22.55H686a22.61,22.61,0,0,0,22.54-22.55V350.44A22.61,22.61,0,0,0,686,327.89Zm-59.75,70.35V437a8.09,8.09,0,0,1-7.5,8.12,7.91,7.91,0,0,1-8.28-7.9v-39a18,18,0,1,1,15.78,0Zm30.44-70.35H580V300.84a38.33,38.33,0,0,1,76.66,0Z"
      transform="translate(-26.97 -40.04)"
      fill="#6c63ff"
    />
    <rect
      x="906.94"
      y="236.25"
      width="80.1"
      height="18.91"
      fill="#5a5773"
      opacity="0.1"
    />
    <path
      d="M1041.27,849.33a28.47,28.47,0,0,0-2.68-7.61l-12-17.92h.07s-1.89-9,0-13.42-6.74-15.29-6.74-15.29-1.05-2.73,1.69-6.09-1.69-13.2-1.69-13.2-2.1-20.55-2.31-23.69-1.9-20.54-1.9-20.54l-4-36.89-7.12-97.77-.13-1.83c.88-.43,1.35-.7,1.35-.7l-1.42-54.06,1.23-1.11c10.74-9.72,35.51-32.22,35.26-32.71s-3-37.57-3.32-46.85a55.83,55.83,0,0,0-4.26-19.18c-.62-1.23-2.41-9.34-3.15-12.77-.2-.94-.33-1.53-.33-1.53s-7.26-13.84-6.63-20.13,1.89-11-13.59-13.2c0,0-13-1.94-20.74-7.23A59,59,0,0,0,974,378.17s-4.34-8-7.36-5.29a42,42,0,0,1-2.85-8.91l-.09-.56a29.47,29.47,0,0,0,11.64-16.66c.1-.38.18-.77.27-1.15a3.25,3.25,0,0,0,.93.17c2.63,0,4.25-2.93,6.71-3.86,1-.39,2.23-.45,3-1.24a2.93,2.93,0,0,0,.66-2.21,4.51,4.51,0,0,0,0-.82,2.93,2.93,0,0,0,0-.29l0,.1c-.67-3.64-3.49-6.87-3.18-10.57.3-3.48,3.36-6.54,3.11-9.93a5.4,5.4,0,0,0-.07-.8l0,.12a8.56,8.56,0,0,0-2-3.54,11.36,11.36,0,0,0-4.12-3.46c-1.39-.61-3-.75-4.3-1.48-3.82-2.08-3.81-7.5-6.08-11.2A9.91,9.91,0,0,0,961,292c-2.84.28-5.41,1.79-8.22,2.28-3.84.68-7.75-.57-11.39-2s-7.33-3-11.24-3-8.14,2-9.32,5.69c-.63,2-.32,4.15-.8,6.18-.86,3.58-4,6.14-7.25,7.92-2,1.11-4.38,2.38-5,4.48,0-.06,0-.11,0-.16a3.84,3.84,0,0,0-.1.51,3.75,3.75,0,0,0,0,.67c0,1.44.76,2.81,1.27,4.18a11.53,11.53,0,0,1-.06,8.06c-.74,1.9-2,3.57-2.72,5.46a10.75,10.75,0,0,0-.66,2.74l0-.16a11,11,0,0,0,0,1.28,9,9,0,0,0,1,4.2A7.54,7.54,0,0,0,911,344.1c2,.46,3.25-1.5,5.36-1a8.42,8.42,0,0,1,1.11.35c.07.45.14.9.22,1.34a29.39,29.39,0,0,0,10.14,17.17c0,.24.08.48.11.73h0a67.15,67.15,0,0,1,.83,12.06s-3.15-4.61-7.47,4.29c0,0-11.27,6.5-15.16,7.24s-17.7,5.55-17.7,5.55a12.18,12.18,0,0,1-7.16,2.31c-4.31,0-7.89,9.43-7.37,14.56s-.31,8.91-4.32,9.12-1.82,8.34-1.79,8.48l-.37,1.75c-.78,3.58-2.48,11.26-3.08,12.46a56,56,0,0,0-4.27,19.18c-.31,9.28-3,46.22-3.31,46.85-.21.41,16.76,15.92,28.69,26.76l1.73,1.56-5.49,51.28a13.69,13.69,0,0,0,5.64,10c0,.6,0,1.21-.06,1.84-.24,6-.72,13.26-1.68,15.16-1.68,3.36-1.26,21.38-1.26,21.38s-1.69,36.68-3.79,40.67-2.53,12.36-1.9,14-2.11,45.69-2.11,45.69l-2.1,19.71s.63,18.86-1.27,19.28-2.95,13.42-2.95,13.42-6.73,9.22-3.79,12.57-.43,4.83-.74,5.66-6.42,4-2,15.72a3.45,3.45,0,0,0,.14.34c-4.14,5.75-17.26,24.3-16.46,27.12a7.43,7.43,0,0,0,3.5,4.2c3.09,1.85,8.39,2.71,16.82,0,14-4.51,13-7.76,13-7.76a5.94,5.94,0,0,1,5.9-5.66c5.79-.42,10.11-5.76,10.11-5.76l-.68-2.53-.93-3.5c.11-1,.82-2.75,4-3.72,4.85-1.47,3.58-10.69,3.58-10.69s-.42-9.64,1.68-10.9,1.27-17.19,1.27-17.19,2.32-11.53,5.68-19.29,7.38-53.86,7.38-53.86,2.73-22.64,5.26-29.14,4.85-24.73,4.85-24.73,15.59-30.19,15.79-36.9c0,0,2-6.29,4,.63s7.62,23.48,7.62,23.48l5.47,20.33,6.53,30.39,4.22,25.58s-.64,9.64,1,13,4,11.1,2.74,12.57,2.52,8.39,3.58,9.85,0,32.49,0,32.49,4.84,26.41,11.79,31a8.5,8.5,0,0,0,1.54.8c-.1,2.86-.2,6.69-.07,8.69a3.33,3.33,0,0,0,.22,1.31c.63.84,7.79,6.5,9.27,6.5s6.73,3.67,6.95,5.45,15.39,9.32,17.54,9.54,12.57,2.09,14-.84A4.85,4.85,0,0,0,1041.27,849.33ZM1004,471.61l1.08.93s1.11,8.65,1.9,11.24-.16,7.63-.16,7.63a17.55,17.55,0,0,0,1.11,5.5c.94,1.89-1.9,6-1.9,6h-2.53l-.79-32.38Zm-75.23-96.68v-.19C928.75,374.8,928.74,374.87,928.74,374.93ZM889.92,499.58a3.65,3.65,0,0,1-.16-2.67,8,8,0,0,0,.53-1.48,22.92,22.92,0,0,0,.58-4,.28.28,0,0,0,0-.05c-.09-.48-.9-5.12-.15-7.58s1.89-11.24,1.89-11.24l.72-.61L895,470.5s0-.54.12-1.43c.35,7.6.63,16,.18,16.42-.84.83-3.9,9-3.16,9.32.24.11-.09,3.38-.65,7.78A15.94,15.94,0,0,1,889.92,499.58Z"
      transform="translate(-26.97 -40.04)"
      fill="url(#2563b911-9cd4-457d-b636-acc38b40f33a)"
    />
    <path
      d="M970.52,382.92v12.44L945,408.19s-25.34-15.33-19.09-21.43c4-3.86,3.23-14.46,2.15-21.75h0c-.63-4.24-1.36-7.35-1.36-7.35s45.52-13,38.64-3.13c-2.3,3.3-2.48,7.57-1.71,11.8C965.19,374.72,970.52,382.92,970.52,382.92Z"
      transform="translate(-26.97 -40.04)"
      fill="#c37098"
    />
    <path
      d="M900.61,504.57l-3.29,40.52s-4.93-4.47-11.31-10.29c-11.83-10.79-28.63-26.22-28.43-26.63.31-.63,3-37.39,3.29-46.63a55.8,55.8,0,0,1,4.22-19.08c.6-1.2,2.29-8.84,3-12.41.24-1.11.39-1.83.39-1.83L874,426s23,25.66,23,26.13-1.57,20.18-1.57,20.18l-1.63,1.42-.71.61s-1.1,8.61-1.88,11.19.06,7.06.15,7.54v0a23.25,23.25,0,0,1-.57,4,8.38,8.38,0,0,1-.53,1.47,3.67,3.67,0,0,0,.16,2.66,16.08,16.08,0,0,0,1.72,3.29Z"
      transform="translate(-26.97 -40.04)"
      fill="#3f3d56"
    />
    <path
      d="M1040,508.17c.24.49-24.29,22.88-34.92,32.55l-4.82,4.37L997,504.57h8.45s2.82-4.07,1.88-5.95a17.39,17.39,0,0,1-1.09-5.47s.93-5,.15-7.59-1.88-11.19-1.88-11.19l-1.07-.92-1.27-1.11s-1.57-19.71-1.57-20.18,23-26.13,23-26.13l5.48,2.19s.12.59.32,1.53c.74,3.41,2.51,11.48,3.12,12.71a55.8,55.8,0,0,1,4.22,19.08C1037,470.78,1039.68,507.54,1040,508.17Z"
      transform="translate(-26.97 -40.04)"
      fill="#3f3d56"
    />
    <path
      d="M1040.1,852.11c-1.47,2.92-11.79,1-13.92.84s-17.17-7.73-17.38-9.5-5.42-5.42-6.88-5.42-8.55-5.64-9.18-6.47a3.19,3.19,0,0,1-.21-1.3c-.22-3.43.21-12.26.21-12.26l30.25,1.67,14.7,22.11a28.52,28.52,0,0,1,2.66,7.57A5,5,0,0,1,1040.1,852.11Z"
      transform="translate(-26.97 -40.04)"
      fill="#3f3d56"
    />
    <path
      d="M1040.1,852.11c-1.47,2.92-11.79,1-13.92.84s-17.17-7.73-17.38-9.5-5.42-5.42-6.88-5.42-8.55-5.64-9.18-6.47a3.19,3.19,0,0,1-.21-1.3c-.22-3.43.21-12.26.21-12.26l30.25,1.67,14.7,22.11a28.52,28.52,0,0,1,2.66,7.57A5,5,0,0,1,1040.1,852.11Z"
      transform="translate(-26.97 -40.04)"
      opacity="0.1"
    />
    <path
      d="M1040.1,852.11c-1.47,2.92-11.79,1-13.92.84s-17.17-7.73-17.38-9.5-5.42-5.42-6.88-5.42-8.55-5.64-9.18-6.47a3.19,3.19,0,0,1-.21-1.3l9.8,6.2s6.26,4,7.93,6.37,14.83,7.3,15.92,7.4c.81.08,9.45-1.58,14.17-.88A5,5,0,0,1,1040.1,852.11Z"
      transform="translate(-26.97 -40.04)"
      opacity="0.1"
    />
    <path
      d="M897.1,833.86s-4.28,5.32-10,5.73a5.89,5.89,0,0,0-5.84,5.63s1,3.24-12.83,7.73c-8.35,2.69-13.6,1.84-16.66,0a7.44,7.44,0,0,1-3.47-4.18c-.94-3.33,17.52-28.68,17.52-28.68l16.8-1,12,5.42,1.84,6.87Z"
      transform="translate(-26.97 -40.04)"
      fill="#3f3d56"
    />
    <path
      d="M897.1,833.86s-4.28,5.32-10,5.73a5.89,5.89,0,0,0-5.84,5.63s1,3.24-12.83,7.73c-8.35,2.69-13.6,1.84-16.66,0a7.44,7.44,0,0,1-3.47-4.18c-.94-3.33,17.52-28.68,17.52-28.68l16.8-1,12,5.42,1.84,6.87Z"
      transform="translate(-26.97 -40.04)"
      opacity="0.1"
    />
    <path
      d="M897.1,833.86s-4.28,5.32-10,5.73a5.89,5.89,0,0,0-5.84,5.63s1,3.24-12.83,7.73c-8.35,2.69-13.6,1.84-16.66,0,7.87-.82,25.26-5.79,27-7.51,2.09-2.09,4.7-7.83,6.47-7.93,1.23-.08,7.48-3.84,11.23-6.17Z"
      transform="translate(-26.97 -40.04)"
      fill="none"
    />
    <path
      d="M897.1,833.86s-4.28,5.32-10,5.73a5.89,5.89,0,0,0-5.84,5.63s1,3.24-12.83,7.73c-8.35,2.69-13.6,1.84-16.66,0,7.87-.82,25.26-5.79,27-7.51,2.09-2.09,4.7-7.83,6.47-7.93,1.23-.08,7.48-3.84,11.23-6.17Z"
      transform="translate(-26.97 -40.04)"
      opacity="0.1"
    />
    <path
      d="M1025.91,810.6c-1.88,4.38,0,13.35,0,13.35s-28,1.46-34.84-3.13-11.68-30.88-11.68-30.88,1-30.87,0-32.33-4.8-8.34-3.55-9.8-1-9.18-2.71-12.52-1-12.93-1-12.93l-4.18-25.46-6.46-30.24L956,646.42s-5.63-16.48-7.54-23.36-3.93-.63-3.93-.63c-.2,6.68-15.64,36.72-15.64,36.72s-2.3,18.15-4.8,24.61-5.22,29-5.22,29-4,45.89-7.3,53.61S906,785.56,906,785.56s.84,15.86-1.25,17.11S903,813.52,903,813.52s1.25,9.17-3.55,10.64-4,4.59-4,4.59-26.7,4.38-31.08-7.31,1.67-14.8,2-15.64,3.66-2.29.74-5.64,3.75-12.51,3.75-12.51,1.05-12.93,2.92-13.35,1.26-19.19,1.26-19.19l2.08-19.61s2.72-43.81,2.09-45.48-.21-10,1.88-14,3.75-40.48,3.75-40.48-.42-17.93,1.25-21.27c1-1.89,1.42-9.16,1.66-15.09.18-4.53.22-8.28.22-8.28l23.36-8.76,30-9.59,25.24,12.1,36.93,7.09.46,6.37,7.05,97.31,4,36.71s1.67,17.31,1.88,20.44,2.29,23.58,2.29,23.58,4.38,9.8,1.67,13.14-1.67,6-1.67,6S1027.79,806.22,1025.91,810.6Z"
      transform="translate(-26.97 -40.04)"
      fill="#3f3d56"
    />
    <path
      d="M965.36,354.53c-2.3,3.3-2.48,7.57-1.71,11.8A29.34,29.34,0,0,1,928.08,365h0c-.63-4.24-1.36-7.35-1.36-7.35S972.24,344.67,965.36,354.53Z"
      transform="translate(-26.97 -40.04)"
      opacity="0.1"
    />
    <path
      d="M976,341.77a29.3,29.3,0,1,1-29.3-29.3A29.16,29.16,0,0,1,976,341.77Z"
      transform="translate(-26.97 -40.04)"
      fill="#c37098"
    />
    <polygon
      points="955.13 350.42 945.53 521.37 893.38 510.42 883.05 441.89 893.28 349.89 900.98 350.88 914.56 352.61 928.01 353.44 942.59 351.82 955.13 350.42"
      opacity="0.1"
    />
    <polygon
      points="955.13 351.67 945.53 522.62 893.38 511.67 883.05 443.14 893.28 351.15 900.98 352.13 914.56 353.86 928.01 354.69 942.59 353.07 955.13 351.67"
      fill="#6c63ff"
    />
    <path
      d="M939.23,396.3l18.78.63-5.28,7.39s.37,14.93,2.88,19.21,1.77,70.4,1.77,70.4l-5,9.49-8.55-10.64.11-87.3Z"
      transform="translate(-26.97 -40.04)"
      fill="#3f3d56"
    />
    <path
      d="M939.23,396.3l18.78.63-5.28,7.39s.37,14.93,2.88,19.21,1.77,70.4,1.77,70.4l-5,9.49-8.55-10.64.11-87.3Z"
      transform="translate(-26.97 -40.04)"
      opacity="0.1"
    />
    <polygon
      points="941.67 336.86 924.15 356.26 934.16 366.69 950.75 350.52 941.67 336.86"
      opacity="0.1"
    />
    <polygon
      points="941.67 335.61 924.15 355.01 934.16 365.44 950.75 349.27 941.67 335.61"
      fill="#6c63ff"
    />
    <polygon
      points="916.75 355.32 899.01 337.59 897.34 346.87 905.48 367.21 916.75 355.32"
      opacity="0.1"
    />
    <polygon
      points="917.37 354.07 899.64 336.34 897.97 345.62 906.11 365.96 917.37 354.07"
      fill="#6c63ff"
    />
    <path
      d="M1004.05,598.14a86.57,86.57,0,0,1-27,7.81c-17.21,2.19-28.47-19.71-28.47-19.71l-6.57,8.55c-2.09,9.08-33.9,11.37-46.83,7.93a20.69,20.69,0,0,1-7.42-3.51c.18-4.53.22-8.28.22-8.28l23.36-8.76,30-9.59,25.24,12.1,36.93,7.09Z"
      transform="translate(-26.97 -40.04)"
      opacity="0.1"
    />
    <path
      d="M982.1,391.72l-9.59,170.94-52.16-10.95L910,483.19l10.22-92,7.7,1a93.48,93.48,0,0,1-1.13,10c-1.25,5.85,6.47,47.36,6.47,47.36s14.67,46.55,21.27,39.84,16-42.14,16-42.14c6.37-13.14.11-50-.36-50.74a14.88,14.88,0,0,1-.6-3.35Z"
      transform="translate(-26.97 -40.04)"
      opacity="0.1"
    />
    <path
      d="M1004.63,524l.44,16.75-4.82,4.37L997,504.57h7.2Z"
      transform="translate(-26.97 -40.04)"
      opacity="0.1"
    />
    <path
      d="M891.37,493.1v0a23.25,23.25,0,0,1-.57,4c0-.37,0-.58-.08-.61C890.42,496.41,890.78,494.88,891.37,493.1Z"
      transform="translate(-26.97 -40.04)"
      opacity="0.1"
    />
    <path
      d="M900.61,504.57l-3.29,40.52s-4.93-4.47-11.31-10.29l.76-7.18s2.69-17.64,3.67-26.34a16.08,16.08,0,0,0,1.72,3.29Z"
      transform="translate(-26.97 -40.04)"
      opacity="0.1"
    />
    <path
      d="M928.9,377s-3.12-4.59-7.4,4.27c0,0-11.16,6.47-15,7.2S889,394,889,394a12.08,12.08,0,0,1-7.09,2.29c-4.28,0-7.83,9.39-7.31,14.5s-.31,8.87-4.27,9.08-1.78,8.44-1.78,8.44l26.39,30.25s1.67,27.85.84,28.69-3.86,9-3.13,9.28-4,31.08-4,31.08l-6.36,59.77s0,10,12.94,13.45S940,602,942.05,592.92l6.57-8.56s11.26,21.91,28.47,19.72,28.17-8.45,28.17-8.45L1003.38,524l-1.25-51.63L1029,428.22s-7.2-13.77-6.57-20,1.87-10.95-13.46-13.14c0,0-12.93-1.93-20.55-7.2a58.74,58.74,0,0,0-14.7-7.4s-4.3-8-7.29-5.26c0,0,3,11.31,2.75,13s.47,9.33.94,10.12,6.73,37.6.36,50.74c0,0-9.35,35.43-16,42.14s-21.27-39.84-21.27-39.84-7.72-41.52-6.47-47.36S928.9,377,928.9,377Z"
      transform="translate(-26.97 -40.04)"
      fill="#3f3d56"
    />
    <circle cx="924.25" cy="469.12" r="4.59" fill="#3f3d56" />
    <circle cx="924.25" cy="490.76" r="4.59" fill="#3f3d56" />
    <circle cx="924.25" cy="469.12" r="4.59" opacity="0.1" />
    <circle cx="924.25" cy="490.76" r="4.59" opacity="0.1" />
    <path
      d="M992.47,804.34s18.84,1.46,20.71,2.92S992.47,804.34,992.47,804.34Z"
      transform="translate(-26.97 -40.04)"
      stroke="#6c63ff"
      strokeMiterlimit="10"
      opacity="0.1"
    />
    <path
      d="M880.3,789.53s4,5,2.3,7.3S880.3,789.53,880.3,789.53Z"
      transform="translate(-26.97 -40.04)"
      stroke="#6c63ff"
      strokeMiterlimit="10"
      opacity="0.1"
    />
    <path
      d="M885.1,807.56s7.3-4.8,10.22-1.61S885.1,807.56,885.1,807.56Z"
      transform="translate(-26.97 -40.04)"
      stroke="#6c63ff"
      strokeMiterlimit="10"
      opacity="0.1"
    />
    <path
      d="M976,341.77a29.16,29.16,0,0,1-.94,7.41,3.33,3.33,0,0,1-1.94-3.26c.13-1.19.92-2.28.75-3.46-.25-1.82-2.45-2.56-3.61-4-1.43-1.74-1.12-4.27-1-6.52s-.45-5-2.56-5.77c-.63-.23-1.32-.25-1.93-.51-1.66-.7-2.17-2.76-3.28-4.18-2.22-2.86-6.63-2.8-10-1.44a47.53,47.53,0,0,1-4.5,1.88,5.88,5.88,0,0,1-4.71-.35c-.66-.42-1.19-1-1.87-1.42-2.26-1.36-5.22,0-7.18,1.75s-3.53,4.1-6,5.17c-1.11.5-2.48.8-3,1.88a3.94,3.94,0,0,0-.32,1.87c0,3.89.46,7.84-.35,11.65-.52,2.45-2.24,5.23-4.73,4.93a4.67,4.67,0,0,1-.91-.23,29.3,29.3,0,1,1,58.1-5.42Z"
      transform="translate(-26.97 -40.04)"
      opacity="0.1"
    />
    <path
      d="M916.61,345.51c.75.17,1.46.56,2.23.66,2.49.3,4.21-2.48,4.73-4.93.81-3.81.39-7.76.36-11.65a3.81,3.81,0,0,1,.31-1.87c.57-1.08,1.94-1.38,3-1.88,2.42-1.08,4-3.38,6-5.17s4.91-3.11,7.17-1.75c.67.4,1.21,1,1.87,1.42a6,6,0,0,0,4.72.35c1.55-.46,3-1.27,4.49-1.88,3.34-1.36,7.76-1.41,10,1.43,1.11,1.43,1.62,3.48,3.28,4.18.61.26,1.3.29,1.93.52,2.11.79,2.65,3.52,2.56,5.77s-.39,4.78,1,6.52c1.16,1.42,3.36,2.16,3.61,4,.16,1.18-.62,2.28-.75,3.46a3.32,3.32,0,0,0,3.13,3.54c2.6,0,4.21-2.91,6.64-3.84,1-.39,2.21-.45,3-1.24a3.31,3.31,0,0,0,.62-2.71c-.49-3.83-3.56-7.16-3.23-11,.31-3.68,3.72-6.89,3-10.51a8.52,8.52,0,0,0-2-3.57,11.56,11.56,0,0,0-4.08-3.45c-1.39-.6-3-.74-4.27-1.47-3.78-2.07-3.77-7.47-6-11.15a9.79,9.79,0,0,0-9.12-4.54c-2.81.28-5.36,1.77-8.14,2.27-3.81.68-7.67-.57-11.28-2s-7.26-3-11.13-3-8.06,2-9.24,5.66c-.62,2-.31,4.14-.79,6.15-.84,3.57-4,6.11-7.18,7.88-2.19,1.22-4.82,2.62-5.08,5.11-.17,1.58.7,3,1.25,4.53a11.53,11.53,0,0,1-.06,8c-.73,1.89-1.95,3.55-2.69,5.43a9.75,9.75,0,0,0,.26,8,7.46,7.46,0,0,0,4.57,3.75C913.27,347,914.51,345.05,916.61,345.51Z"
      transform="translate(-26.97 -40.04)"
      fill="#3f3d56"
    />
    <g opacity="0.1">
      <path
        d="M923.57,339.06c-.52,2.45-2.25,5.23-4.74,4.93-.77-.1-1.47-.49-2.23-.66-2.09-.46-3.33,1.5-5.3,1a7.48,7.48,0,0,1-4.58-3.75,8.66,8.66,0,0,1-.93-3.27,9.13,9.13,0,0,0,.93,5.15,7.48,7.48,0,0,0,4.58,3.75c2,.46,3.21-1.5,5.3-1a22.61,22.61,0,0,0,2.23.65c2.49.31,4.22-2.47,4.74-4.92a28.89,28.89,0,0,0,.48-6.57A24.63,24.63,0,0,1,923.57,339.06Z"
        transform="translate(-26.97 -40.04)"
      />
      <path
        d="M909.87,324a11.51,11.51,0,0,0-.66-4.83,25.53,25.53,0,0,1-1.15-3.16,4.59,4.59,0,0,0-.1.51c-.17,1.57.71,3,1.25,4.53A11.47,11.47,0,0,1,909.87,324Z"
        transform="translate(-26.97 -40.04)"
      />
      <path
        d="M986.27,318.73c-.47,2.84-2.77,5.51-3,8.5a7.15,7.15,0,0,0,0,1.54C983.77,325.28,986.86,322.19,986.27,318.73Z"
        transform="translate(-26.97 -40.04)"
      />
      <path
        d="M986.44,339.83a2.35,2.35,0,0,1-.57,1.12c-.74.79-2,.85-3,1.24-2.43.93-4,3.87-6.64,3.84a3.35,3.35,0,0,1-3-2.32,5.18,5.18,0,0,0-.14.66,3.32,3.32,0,0,0,3.13,3.53c2.61,0,4.21-2.91,6.64-3.83,1-.39,2.22-.45,3-1.24a3.31,3.31,0,0,0,.62-2.71C986.47,340,986.45,339.92,986.44,339.83Z"
        transform="translate(-26.97 -40.04)"
      />
      <path
        d="M973.9,339c-.25-1.82-2.45-2.56-3.61-4a5.48,5.48,0,0,1-1.1-3.28c-.08,1.86-.05,3.76,1.1,5.16s2.9,2,3.46,3.44A3.21,3.21,0,0,0,973.9,339Z"
        transform="translate(-26.97 -40.04)"
      />
      <path
        d="M969.25,328.53c.08-2.25-.46-5-2.57-5.77-.62-.23-1.31-.26-1.92-.51-1.66-.7-2.18-2.76-3.28-4.18-2.23-2.85-6.64-2.8-10-1.44-1.5.61-2.93,1.42-4.49,1.88a5.88,5.88,0,0,1-4.71-.35c-.66-.42-1.2-1-1.87-1.42-2.27-1.36-5.23,0-7.18,1.75s-3.53,4.09-6,5.17c-1.12.5-2.48.8-3.06,1.88a3.93,3.93,0,0,0-.31,1.87c0,.39,0,.78,0,1.17a2.84,2.84,0,0,1,.29-1.16c.58-1.08,1.94-1.38,3.06-1.88,2.42-1.08,4-3.38,6-5.17s4.91-3.11,7.18-1.75c.67.4,1.21,1,1.87,1.41a5.84,5.84,0,0,0,4.71.35,46.21,46.21,0,0,0,4.49-1.87c3.35-1.36,7.76-1.42,10,1.43,1.1,1.42,1.62,3.48,3.28,4.18.61.26,1.3.29,1.92.52,1.71.64,2.39,2.56,2.54,4.46Z"
        transform="translate(-26.97 -40.04)"
      />
    </g>
    <g opacity="0.1">
      <path
        d="M920,339a7.67,7.67,0,0,1,5.78-7.17,24,24,0,0,1,13.48.61c9.49,3.14-1.2,14.44-1.2,14.44s-7.11,7-13.74,2.11a10.39,10.39,0,0,1-3.87-6A15.3,15.3,0,0,1,920,339Z"
        transform="translate(-26.97 -40.04)"
      />
      <path
        d="M972.17,339a7.67,7.67,0,0,0-5.79-7.17,24,24,0,0,0-13.47.61c-9.49,3.14,1.2,14.44,1.2,14.44s7.1,7,13.74,2.11a10.39,10.39,0,0,0,3.87-6A15.3,15.3,0,0,0,972.17,339Z"
        transform="translate(-26.97 -40.04)"
      />
      <polygon points="910.5 291.48 910.5 291.95 927.83 291.95 927.83 291.39 910.5 291.48" />
      <path
        d="M943,336.53h.55v-1.59s1.76-1.37,4.68,0v1.42h1v-.93h-.49s.2-1.93-3.06-1.62c0,0-2.62-.25-2.56,1.41h-.6Z"
        transform="translate(-26.97 -40.04)"
      />
    </g>
    <path
      d="M920,338.35a7.67,7.67,0,0,1,5.78-7.17,24.13,24.13,0,0,1,13.48.61c9.49,3.15-1.2,14.44-1.2,14.44s-7.11,7-13.74,2.11a10.33,10.33,0,0,1-3.87-6A15.21,15.21,0,0,1,920,338.35Z"
      transform="translate(-26.97 -40.04)"
      fill="#6c63ff"
    />
    <path
      d="M972.17,338.35a7.67,7.67,0,0,0-5.79-7.17,24.09,24.09,0,0,0-13.47.61c-9.49,3.15,1.2,14.44,1.2,14.44s7.1,7,13.74,2.11a10.33,10.33,0,0,0,3.87-6A15.21,15.21,0,0,0,972.17,338.35Z"
      transform="translate(-26.97 -40.04)"
      fill="#6c63ff"
    />
    <polygon
      points="910.5 290.85 910.5 291.33 927.83 291.33 927.83 290.76 910.5 290.85"
      fill="#6c63ff"
    />
    <path
      d="M943,335.9h.55v-1.59s1.76-1.36,4.68,0v1.43h1v-.94h-.49s.2-1.92-3.06-1.62c0,0-2.62-.24-2.56,1.41h-.6Z"
      transform="translate(-26.97 -40.04)"
      fill="#6c63ff"
    />
    <rect x="117.46" y="457.19" width="5.68" height="127.9" fill="#535461" />
    <path
      d="M185.81,624.74l-.36,5.76-.5,8.13-.21,3.39-.5,8.14-.22,3.39-.5,8.13-5.73,92.47a15.66,15.66,0,0,1-15.63,14.7H132.38a15.65,15.65,0,0,1-15.62-14.7L111,661.68l-.5-8.13-.21-3.39L109.8,642l-.21-3.39-.5-8.13-.36-5.76a8.11,8.11,0,0,1,8.1-8.61h60.89A8.1,8.1,0,0,1,185.81,624.74Z"
      transform="translate(-26.97 -40.04)"
      fill="#3f3d56"
    />
    <polygon
      points="158.48 590.46 157.98 598.59 82.61 598.59 82.11 590.46 158.48 590.46"
      fill="#9d9cb5"
    />
    <polygon
      points="157.77 601.98 157.27 610.12 83.33 610.12 82.82 601.98 157.77 601.98"
      fill="#9d9cb5"
    />
    <polygon
      points="157.05 613.51 156.55 621.64 84.05 621.64 83.54 613.51 157.05 613.51"
      fill="#9d9cb5"
    />
    <path
      d="M100.41,545.17c33.08,23.93,46.86,61.37,46.86,61.37s-39.87-1.37-73-25.3-46.86-61.37-46.86-61.37S67.32,521.24,100.41,545.17Z"
      transform="translate(-26.97 -40.04)"
      fill="#6c63ff"
    />
    <path
      d="M27.46,519.87s41.38,23,54.65,42,65.16,44.68,65.16,44.68"
      transform="translate(-26.97 -40.04)"
      fill="none"
      stroke="#535461"
      strokeMiterlimit="10"
      strokeWidth="2"
    />
    <path
      d="M121.76,497c18,13,25.51,33.4,25.51,33.4s-21.7-.74-39.71-13.77-25.5-33.4-25.5-33.4S103.76,483.92,121.76,497Z"
      transform="translate(-26.97 -40.04)"
      fill="#6c63ff"
    />
    <path
      d="M82.06,483.18s22.52,12.5,29.74,22.85,35.47,24.32,35.47,24.32"
      transform="translate(-26.97 -40.04)"
      fill="none"
      stroke="#535461"
      strokeMiterlimit="10"
      strokeWidth="2"
    />
    <path
      d="M173.44,529.32c-20.69,22.73-25.06,52.43-25.06,52.43s29.16-7.15,49.84-29.88,25.06-52.44,25.06-52.44S194.12,506.58,173.44,529.32Z"
      transform="translate(-26.97 -40.04)"
      fill="#6c63ff"
    />
    <path
      d="M223.28,499.43s-26.94,23.3-33.79,39.36-41.11,43-41.11,43"
      transform="translate(-26.97 -40.04)"
      fill="none"
      stroke="#535461"
      strokeMiterlimit="10"
      strokeWidth="2"
    />
  </svg>
);
export const History = (className) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={`${className}`}
    viewBox="0 0 176.5 176.3"
  >
    <title>History</title>
    <path
      d="M138.9,215.8C92.6,223.5,48,193.2,38.4,147.3c-.5-2.6-.4-5.9.9-8s4.7-3.1,6.2-2.4a10.5,10.5,0,0,1,5.4,6.1c3,13.1,8.5,24.9,17.3,35A74.5,74.5,0,1,0,72.7,75.3l-3,3.2c4.6,3.2,8.8,6,12.8,9s4.2,6.6-1,8.7c-12.3,5-24.7,9.9-37.1,14.7-5.4,2-8.6-.1-8.5-5.8.1-13,.3-26,.7-39,.1-2.1,1-5.5,2.4-5.9s4.6.6,6.6,1.7c4.3,2.6,8.2,5.6,12.6,8.6l3.3-3.1c26.4-25.1,57.2-33.2,91.6-21.3s53.7,37,58.5,72.6C217.8,164.8,184.8,208.2,138.9,215.8Z"
      transform="translate(-35.9 -40.7)"
    />
    <path
      d="M157.7,162.6c-2.6,2.8-6.2,2.3-9.9-1.4-8.9-8.8-17.8-17.5-26.4-26.6a12.4,12.4,0,0,1-3.2-7.8c-.5-7.6-.2-15.3-.2-23V80.3c0-4,1.5-6.8,5.8-7.2s6.2,2.5,6.2,7.3c0,13.8.1,27.6-.1,41.5a9.7,9.7,0,0,0,3.2,7.8c7.8,7.5,15.4,15.3,23,22.9C159.9,156.5,160.4,159.9,157.7,162.6Z"
      transform="translate(-35.9 -40.7)"
    />
  </svg>
);

export const Routine = (className) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={` ${className}`}
    enable-background="new 0 0 207.4 207.4"
    viewBox="0 0 207.4 207.4"
  >
    <title>Routinesvg</title>
    <path
      class="a"
      d="M231.7,231.7H24.3V24.3H231.7M203.1,62.8c-12.4-13.9-27-23.7-44.3-29.3a98.9,98.9,0,0,0-52.6-2.3A96.4,96.4,0,0,0,59.8,56c-20.9,20.2-31.5,44.9-31,74S41,183.1,62.5,203l-14.3.8c-3,.1-4.7,1.6-4.5,4.2s2,3.9,4.9,3.7l22-1.1a5.9,5.9,0,0,1,3.2.9c22.5,14.4,47,19.4,73.2,14.4,69.4-13.4,103.1-93,64.6-152a5.8,5.8,0,0,1-.9-3.4c.4-7.4.9-14.7,1.4-22.1.2-2.6-1.3-4.6-3.7-4.7s-4,1.5-4.2,4.1-.3,4.6-.5,6.9S203.4,59.7,203.1,62.8Z"
      transform="translate(-24.3 -24.3)"
    />
    <path
      d="M203.1,62.8c.3-3.1.4-5.6.6-8.1s.3-4.6.5-6.9,1.9-4.2,4.2-4.1,3.9,2.1,3.7,4.7c-.5,7.4-1,14.7-1.4,22.1a5.8,5.8,0,0,0,.9,3.4c38.5,59,4.8,138.6-64.6,152-26.2,5-50.7,0-73.2-14.4a5.9,5.9,0,0,0-3.2-.9l-22,1.1c-2.9.2-4.8-1.2-4.9-3.7s1.5-4.1,4.5-4.2l14.3-.8C41,183.1,29.3,159,28.8,130s10.1-53.8,31-74a96.4,96.4,0,0,1,46.4-24.8,98.9,98.9,0,0,1,52.6,2.3C176.1,39.1,190.7,48.9,203.1,62.8ZM68.1,197.3l.6-.2c-.3-5-.6-10.1-.8-15.1a9,9,0,0,1,.4-2.8,3.7,3.7,0,0,1,4.4-2.1,3.8,3.8,0,0,1,3.1,3.7c.4,7.2.8,14.3,1.1,21.4a2.9,2.9,0,0,0,1.5,2.8c22.5,14.2,46.7,18.3,72.4,11.9a91.3,91.3,0,0,0,68-76.2,90.1,90.1,0,0,0-14-62.5,3.4,3.4,0,0,0-2.4-1.3c-7-.6-14.1-1-21.1-1.5-2.9-.2-4.4-1.9-4.2-4.4s2-3.6,4.8-3.5l12.3.8a29.9,29.9,0,0,0,3,0,91.1,91.1,0,0,0-92.3-28.6C69.7,48.9,42,78.8,37.5,116.5,33.6,148.6,44.5,175.5,68.1,197.3Z"
      transform="translate(-24.3 -24.3)"
    />
    <path
      class="b"
      d="M66.5,98.3l18.6,15.6,14.9-5.1,2.3-15.3L83.6,77.8s11.1-6.1,25.1,1.5,14.1,19.1,11.6,28c0,0,59.5,50,60.8,51.7s7.7,12.2-3.1,20.5-27.7-10.2-27.7-10.2l-48.4-40.5s-11.1,6.7-21,1.1A29.6,29.6,0,0,1,66.5,98.3Z"
      transform="translate(-24.3 -24.3)"
    />
  </svg>
);

export const ImageIcon = (className) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    className={{ className }}
  >
    <g>
      <g>
        <path
          d="M446.575,0H65.425C29.349,0,0,29.35,0,65.426v381.149C0,482.65,29.349,512,65.425,512h381.15
			C482.651,512,512,482.65,512,446.574V65.426C512,29.35,482.651,0,446.575,0z M481.842,446.575
			c0,19.447-15.821,35.267-35.267,35.267H65.425c-19.447,0-35.268-15.821-35.268-35.267v-55.007l99.255-84.451
			c3.622-3.082,8.906-3.111,12.562-0.075l62.174,51.628c5.995,4.977,14.795,4.569,20.304-0.946L372.181,209.77
			c2.67-2.675,5.783-2.935,7.408-2.852c1.62,0.083,4.695,0.661,7.078,3.596l95.176,117.19V446.575z M481.842,279.865l-71.766-88.366
			c-7.117-8.764-17.666-14.122-28.942-14.701c-11.268-0.57-22.317,3.672-30.294,11.662L212.832,326.681l-51.59-42.839
			c-14.959-12.422-36.563-12.293-51.373,0.308l-79.712,67.822V65.426c0-19.447,15.821-35.268,35.268-35.268h381.15
			c19.447,0,35.267,15.821,35.267,35.268V279.865z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M161.174,62.995c-40.095,0-72.713,32.62-72.713,72.713c0,40.094,32.619,72.713,72.713,72.713s72.713-32.619,72.713-72.713
			S201.269,62.995,161.174,62.995z M161.174,178.264c-23.466,0-42.556-19.091-42.556-42.556c0-23.466,19.09-42.556,42.556-42.556
			c23.466,0,42.556,19.091,42.556,42.556S184.64,178.264,161.174,178.264z"
        />
      </g>
    </g>
  </svg>
);

export const ImageIcon2 = ({ className, style }) => (
  <svg
    className={className ?? "h-5"}
    style={style}
    stroke="none"
    fill="currentColor"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.3338 0C17.7231 0 20 2.37811 20 5.91672V14.0833C20 17.6219 17.7231 20 14.3328 20H5.66618C2.2769 20 0 17.6219 0 14.0833V5.91672C0 2.37811 2.2769 0 5.66618 0H14.3338ZM15.4366 10.55C14.3646 9.88132 13.5371 10.8204 13.3138 11.1207C13.0986 11.4107 12.9136 11.7306 12.7185 12.0506C12.2419 12.84 11.6958 13.7503 10.7506 14.2797C9.37699 15.0402 8.3342 14.3395 7.58404 13.8297C7.30248 13.6398 7.02896 13.4603 6.75645 13.3406C6.08473 13.0506 5.48038 13.3808 4.5834 14.5201C4.11279 15.1156 3.6462 15.7059 3.17358 16.2941C2.89102 16.646 2.95839 17.1889 3.3395 17.4241C3.94788 17.7988 4.68999 18 5.52864 18H13.9564C14.432 18 14.9087 17.935 15.3632 17.7864C16.3869 17.452 17.1994 16.6863 17.6237 15.6749C17.9817 14.8246 18.1557 13.7926 17.8208 12.934C17.7092 12.6491 17.5423 12.3839 17.308 12.1507C16.6936 11.5408 16.1194 10.9711 15.4366 10.55ZM6.49886 4C5.12021 4 4 5.12173 4 6.5C4 7.87827 5.12021 9 6.49886 9C7.8765 9 8.99771 7.87827 8.99771 6.5C8.99771 5.12173 7.8765 4 6.49886 4Z" />
  </svg>
);

export const Team = (className) => (
  <svg
    viewBox="0 0 512 512"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m512 256c0 37.867188-8.222656 73.8125-22.976562 106.152344-25.222657 55.285156-69.539063 100.015625-124.511719 125.785156-9.957031 4.660156-20.269531 8.703125-30.886719 12.066406-11.941406 3.816406-24.261719 6.75-36.90625 8.765625-.050781.011719-.113281.023438-.167969.023438-6.203125.992187-12.464843 1.753906-18.804687 2.289062-1.351563.113281-2.707032.21875-4.066406.3125-1.914063.125-3.835938.238281-5.769532.324219-3.949218.1875-7.917968.28125-11.910156.28125-4.097656 0-8.160156-.09375-12.203125-.292969-1.828125-.082031-3.660156-.1875-5.488281-.324219-1.367188-.09375-2.726563-.1875-4.085938-.300781-6.488281-.542969-12.914062-1.339843-19.253906-2.363281-3.03125-.492188-6.050781-1.023438-9.039062-1.621094-12.96875-2.570312-25.570313-6.109375-37.742188-10.5625-7.054688-2.570312-13.960938-5.445312-20.710938-8.609375-2.296874-1.078125-4.585937-2.195312-6.855468-3.355469-5.828125-2.945312-11.523438-6.113281-17.082032-9.488281-27.847656-16.863281-52.214843-38.890625-71.796874-64.75-11.753907-15.527343-21.773438-32.433593-29.777344-50.449219-14.117188-31.742187-21.964844-66.894531-21.964844-103.882812 0-141.386719 114.613281-256 256-256s256 114.613281 256 256zm0 0"
      fill="#ffe152"
    />
    <path
      d="m205.929688 332.214844v174.882812c-12.96875-2.570312-25.570313-6.109375-37.742188-10.5625-7.054688-2.570312-13.960938-5.445312-20.710938-8.609375-2.296874-1.078125-4.585937-2.195312-6.855468-3.355469-5.828125-2.945312-11.523438-6.113281-17.082032-9.488281-27.847656-16.863281-52.214843-38.890625-71.796874-64.75-11.753907-15.527343-21.773438-32.433593-29.777344-50.449219v-27.667968c0-32.097656 21.796875-59.109375 51.398437-67.019532 1.085938-.292968 2.171875-.566406 3.28125-.792968 2.933594-.648438 5.953125-1.089844 9.027344-1.339844 1.871094-.144531 3.761719-.230469 5.671875-.230469h45.191406c5.046875 0 9.96875.535157 14.714844 1.570313.269531.050781.542969.113281.8125.175781.796875.179687 1.601562.375 2.382812.585937.023438.011719.042969.011719.0625.019532 7.816407 2.089844 15.078126 5.507812 21.546876 10 18.054687 12.527344 29.875 33.394531 29.875 57.03125zm0 0"
      fill="#2ba1cf"
    />
    <path
      d="m205.929688 332.214844v174.882812c-12.96875-2.570312-25.570313-6.109375-37.742188-10.5625-7.054688-2.570312-13.960938-5.445312-20.710938-8.609375-2.296874-1.078125-4.585937-2.195312-6.855468-3.355469-5.828125-2.945312-11.523438-6.113281-17.082032-9.488281-27.847656-16.863281-52.214843-38.890625-71.796874-64.75v-78.117187c0-32.097656 21.796874-59.109375 51.398437-67.019532 1.089844-.292968 2.175781-.566406 3.28125-.792968 2.9375-.648438 5.957031-1.089844 9.027344-1.339844 1.871093-.144531 3.761719-.230469 5.675781-.230469h15.410156c5.046875 0 9.96875.535157 14.714844 1.570313.269531.050781.542969.113281.8125.175781.796875.179687 1.601562.375 2.382812.585937.023438.011719.042969.011719.0625.019532 7.816407 2.089844 15.078126 5.507812 21.546876 10 18.054687 12.527344 29.875 33.394531 29.875 57.03125zm0 0"
      fill="#66baed"
    />
    <path
      d="m154.679688 264.398438-.164063.785156-20.757813 96.542968c-1.992187 9.277344-10.15625 16.003907-19.640624 16.011719-.058594 0-.113282 0-.167969 0-.0625 0-.121094 0-.183594 0-9.488281-.007812-17.648437-6.734375-19.640625-16.011719l-20.757812-96.535156-.164063-.792968zm0 0"
      fill="#f2f0ec"
    />
    <path
      d="m113.941406 291.238281-31.238281 17.359375-9.5-44.199218 19.410156-11.429688"
      fill="#d8d5d0"
    />
    <path
      d="m113.941406 291.238281 31.238282 17.359375 9.5-44.199218-19.410157-11.429688"
      fill="#d8d5d0"
    />
    <path
      d="m20.675781 246.109375v-104.640625c0-10.632812 1.773438-21.050781 5.273438-30.964844 13.097656-37.265625 48.460937-62.3125 87.996093-62.3125 4.898438 0 9.785157.378906 14.535157 1.128906 21.71875 3.394532 41.648437 14.480469 56.097656 31.21875 14.601563 16.917969 22.644531 38.554688 22.644531 60.929688v104.640625"
      fill="#cc7a3b"
    />
    <path
      d="m59.042969 145.554688c0 37.011718 21.675781 79.832031 33.578125 100.554687h-71.949219v-104.640625c0-10.628906 1.777344-21.046875 5.273437-30.964844 13.019532-37.050781 48.058594-62.023437 87.320313-62.304687-28.675781.714843-54.222656 46.722656-54.222656 97.355469zm0 0"
      fill="#a35418"
    />
    <path
      d="m138.703125 236.105469v30.382812c0 11.121094-7.332031 20.523438-17.433594 23.644531-2.3125.71875-4.777343 1.105469-7.324219 1.105469-13.671874 0-24.75-11.078125-24.75-24.75v-30.382812zm0 0"
      fill="#eab599"
    />
    <path
      d="m138.703125 264.5625v1.925781c0 11.121094-7.332031 20.523438-17.433594 23.644531-9.113281-2.800781-15.964843-10.726562-17.230469-20.421874 1.652344.101562 3.316407.152343 4.984376.152343 4.683593 0 9.277343-.371093 13.746093-1.105469 5.511719-.886718 10.839844-2.304687 15.933594-4.195312zm0 0"
      fill="#f6caae"
    />
    <path
      d="m46.042969 186.316406c0 11.460938-8.371094 20.964844-19.335938 22.726563-1.195312.195312-2.429687.296875-3.6875.296875-12.714843 0-23.019531-10.304688-23.019531-23.023438 0-12.714844 10.304688-23.019531 23.019531-23.019531 1.257813 0 2.492188.101563 3.6875.296875 10.964844 1.761719 19.335938 11.261719 19.335938 22.722656zm0 0"
      fill="#f6caae"
    />
    <path
      d="m46.042969 186.316406c0 11.460938-8.371094 20.964844-19.335938 22.726563-1.988281-7.238281-3.054687-14.859375-3.054687-22.726563 0-7.863281 1.066406-15.484375 3.054687-22.722656 10.964844 1.761719 19.335938 11.261719 19.335938 22.722656zm0 0"
      fill="#eab599"
    />
    <path
      d="m31.25 186.316406c0 4.546875-3.683594 8.230469-8.230469 8.230469-4.542969 0-8.226562-3.683594-8.226562-8.230469 0-4.542968 3.683593-8.226562 8.226562-8.226562 4.546875 0 8.230469 3.683594 8.230469 8.226562zm0 0"
      fill="#eab599"
    />
    <path
      d="m173.058594 156.921875v79.132813c-12.230469 11.675781-27.914063 19.761718-45.363282 22.574218-.136718.023438-.285156.046875-.421874.070313-4.335938.691406-8.785157 1.035156-13.328126 1.035156-47.300781 0-85.648437-38.347656-85.648437-85.648437v-32.617188c0-4.175781.296875-8.285156.875-12.300781 20.378906 14.65625 49.597656 13.207031 68.214844-4.386719 6.164062-5.824219 10.449219-12.757812 12.871093-20.113281 1.347657 12.878906 7.238282 25.414062 17.679688 35.285156 12.429688 11.734375 28.851562 17.394531 45.121094 16.96875zm0 0"
      fill="#eab599"
    />
    <path
      d="m173.058594 156.921875v79.132813c-12.230469 11.675781-27.914063 19.761718-45.363282 22.574218-.136718.023438-.285156.046875-.421874.070313-40.96875-6.402344-72.304688-41.855469-72.304688-84.613281v-32.617188c0-.867188.015625-1.730469.046875-2.589844 15.101563 1.546875 30.789063-3.148437 42.371094-14.101562 6.164062-5.820313 10.449219-12.757813 12.871093-20.109375 1.347657 12.878906 7.238282 25.414062 17.679688 35.285156 12.429688 11.734375 28.851562 17.394531 45.121094 16.96875zm0 0"
      fill="#f6caae"
    />
    <path
      d="m159.949219 166.851562c0-7.859374-6.371094-14.226562-14.226563-14.226562-7.855468 0-14.226562 6.367188-14.226562 14.226562"
      fill="#eab599"
    />
    <path
      d="m96.410156 166.851562c0-7.859374-6.371094-14.226562-14.226562-14.226562-7.855469 0-14.222656 6.367188-14.222656 14.226562"
      fill="#eab599"
    />
    <path
      d="m91.902344 172.90625c0 5.367188-4.351563 9.71875-9.71875 9.71875-5.367188 0-9.714844-4.351562-9.714844-9.71875s4.347656-9.714844 9.714844-9.714844c5.367187 0 9.71875 4.347656 9.71875 9.714844zm0 0"
      fill="#3d4159"
    />
    <path
      d="m155.4375 172.90625c0 5.367188-4.347656 9.71875-9.714844 9.71875-5.367187 0-9.714844-4.351562-9.714844-9.71875s4.347657-9.714844 9.714844-9.714844c5.367188 0 9.714844 4.347656 9.714844 9.714844zm0 0"
      fill="#3d4159"
    />
    <path
      d="m123.671875 197.371094h-19.433594c-2.316406 0-4.191406-1.878906-4.191406-4.191406s1.875-4.191407 4.191406-4.191407h19.433594c2.3125 0 4.1875 1.878907 4.1875 4.191407s-1.875 4.191406-4.1875 4.191406zm0 0"
      fill="#eab599"
    />
    <path
      d="m113.953125 223.890625c-7.171875 0-14.34375-1.796875-20.882813-5.394531-1.84375-1.011719-2.515624-3.328125-1.503906-5.171875 1.015625-1.84375 3.332032-2.515625 5.175782-1.503907 10.777343 5.925782 23.644531 5.925782 34.421874 0 1.84375-1.015624 4.160157-.339843 5.175782 1.503907 1.011718 1.84375.339844 4.160156-1.503906 5.171875-6.539063 3.597656-13.710938 5.394531-20.882813 5.394531zm0 0"
      fill="#eab599"
    />
    <path
      d="m89.921875 171.191406c0 2.300782-1.867187 4.164063-4.164063 4.164063-2.300781 0-4.164062-1.863281-4.164062-4.164063 0-2.300781 1.863281-4.164062 4.164062-4.164062 2.296876 0 4.164063 1.863281 4.164063 4.164062zm0 0"
      fill="#fff"
    />
    <path
      d="m153.933594 171.191406c0 2.300782-1.863282 4.164063-4.160156 4.164063-2.300782 0-4.164063-1.863281-4.164063-4.164063 0-2.300781 1.863281-4.164062 4.164063-4.164062 2.296874 0 4.160156 1.863281 4.160156 4.164062zm0 0"
      fill="#fff"
    />
    <path
      d="m172.25 196.574219c0 5.890625-4.777344 10.667969-10.671875 10.667969-5.890625 0-10.667969-4.777344-10.667969-10.667969 0-5.894531 4.777344-10.671875 10.667969-10.671875 5.894531 0 10.671875 4.777344 10.671875 10.671875zm0 0"
      fill="#eab599"
    />
    <path
      d="m76.988281 196.574219c0 5.890625-4.773437 10.667969-10.667969 10.667969-5.890624 0-10.667968-4.777344-10.667968-10.667969 0-5.894531 4.777344-10.671875 10.667968-10.671875 5.894532 0 10.667969 4.777344 10.667969 10.671875zm0 0"
      fill="#eab599"
    />
    <path
      d="m489.023438 330.105469v32.046875c-25.222657 55.285156-69.539063 100.015625-124.511719 125.785156-9.957031 4.660156-20.269531 8.703125-30.886719 12.066406-11.941406 3.816406-24.261719 6.75-36.90625 8.765625-.050781.011719-.113281.023438-.167969.023438v-178.6875c0-38.085938 29.332031-69.332031 66.65625-72.339844 1.964844-.167969 3.9375-.238281 5.933594-.238281h47.273437c5.589844 0 11.03125.613281 16.257813 1.816406 32.265625 7.375 56.351563 36.269531 56.351563 70.761719zm0 0"
      fill="#bfd5de"
    />
    <path
      d="m489.023438 330.105469v32.046875c-25.222657 55.285156-69.539063 100.015625-124.511719 125.785156-9.957031 4.660156-20.269531 8.703125-30.886719 12.066406v-169.898437c0-40.082031 32.507812-72.578125 72.601562-72.578125h10.195313c40.105469 0 72.601563 32.496094 72.601563 72.578125zm0 0"
      fill="#dde8ed"
    />
    <path
      d="m321.734375 177.464844c0 11.992187-8.757813 21.933594-20.226563 23.777344-1.253906.203124-2.542968.308593-3.859374.308593-13.304688 0-24.085938-10.78125-24.085938-24.085937 0-13.304688 10.78125-24.085938 24.085938-24.085938 1.316406 0 2.605468.105469 3.859374.308594 11.46875 1.847656 20.226563 11.789062 20.226563 23.777344zm0 0"
      fill="#d3a489"
    />
    <path
      d="m412.273438 283.710938-19.488282 31.257812-19.488281-31.257812"
      fill="#f74f4f"
    />
    <path
      d="m419.003906 403.265625-26.21875 33.085937-26.222656-33.085937 26.226562-96.429687zm0 0"
      fill="#f74f4f"
    />
    <path
      d="m321.734375 177.464844c0 11.992187-8.757813 21.933594-20.226563 23.777344-2.082031-7.574219-3.195312-15.546876-3.195312-23.777344 0-8.226563 1.113281-16.199219 3.195312-23.777344 11.46875 1.847656 20.226563 11.789062 20.226563 23.777344zm0 0"
      fill="#bf8e75"
    />
    <path
      d="m306.257812 177.464844c0 4.753906-3.855468 8.609375-8.609374 8.609375-4.753907 0-8.605469-3.855469-8.605469-8.609375s3.851562-8.605469 8.605469-8.605469c4.753906 0 8.609374 3.851563 8.609374 8.605469zm0 0"
      fill="#bf8e75"
    />
    <path
      d="m392.777344 287.238281-32.679688 18.164063-9.941406-46.246094 20.304688-11.960938"
      fill="#bfd5de"
    />
    <path
      d="m392.777344 287.238281 32.683594 18.164063 9.941406-46.246094-20.308594-11.960938"
      fill="#bfd5de"
    />
    <path
      d="m463.828125 177.464844c0 11.992187 8.757813 21.933594 20.226563 23.777344 1.253906.203124 2.542968.308593 3.859374.308593 13.304688 0 24.085938-10.78125 24.085938-24.085937 0-13.304688-10.78125-24.085938-24.085938-24.085938-1.316406 0-2.605468.105469-3.859374.308594-11.46875 1.847656-20.226563 11.789062-20.226563 23.777344zm0 0"
      fill="#d3a489"
    />
    <g fill="#bf8e75">
      <path d="m463.828125 177.464844c0 11.992187 8.757813 21.933594 20.226563 23.777344 2.085937-7.574219 3.195312-15.546876 3.195312-23.777344 0-8.226563-1.109375-16.199219-3.195312-23.777344-11.46875 1.847656-20.226563 11.789062-20.226563 23.777344zm0 0" />
      <path d="m496.523438 177.464844c0 4.753906-3.855469 8.609375-8.609376 8.609375-4.753906 0-8.609374-3.855469-8.609374-8.609375s3.855468-8.605469 8.609374-8.605469c4.753907 0 8.609376 3.851563 8.609376 8.605469zm0 0" />
      <path d="m482.398438 164.664062c0 44.59375-32.578126 81.589844-75.234376 88.457032-4.675781.769531-9.480468 1.15625-14.382812 1.15625-49.496094 0-89.613281-40.117188-89.613281-89.613282 0-23.417968 8.132812-58.574218 22.839843-74.539062 16.375-17.777344 40.695313-15.078125 66.773438-15.078125 4.902344 0 9.703125.390625 14.382812 1.160156 42.65625 6.867188 75.234376 43.859375 75.234376 88.457031zm0 0" />
      <path d="m418.683594 229.558594v31.785156c0 11.636719-7.671875 21.472656-18.242188 24.738281-2.417968.75-4.996094 1.15625-7.664062 1.15625-14.300782 0-25.894532-11.59375-25.894532-25.894531v-31.785156zm0 0" />
    </g>
    <path
      d="m418.683594 259.328125v2.015625c0 11.636719-7.671875 21.472656-18.242188 24.738281-9.535156-2.929687-16.703125-11.222656-18.027344-21.367187 1.730469.105468 3.46875.160156 5.21875.160156 4.898438 0 9.703126-.390625 14.382813-1.15625 5.765625-.929688 11.335937-2.410156 16.667969-4.390625zm0 0"
      fill="#d3a489"
    />
    <path
      d="m482.398438 164.664062c0 44.59375-32.578126 81.589844-75.234376 88.457032-42.652343-6.867188-75.230468-43.863282-75.230468-88.457032 0-27.460937 12.351562-52.039062 31.808594-68.480468 12.132812-10.257813 27.035156-17.339844 43.421874-19.980469 39.765626 6.402344 70.785157 39 74.792969 79.523437.292969 2.941407.441407 5.925782.441407 8.9375zm0 0"
      fill="#d3a489"
    />
    <path
      d="m392.785156 208.800781c-7.507812 0-15.007812-1.878906-21.847656-5.640625-1.933594-1.058594-2.636719-3.484375-1.574219-5.414062 1.058594-1.929688 3.484375-2.632813 5.414063-1.570313 11.273437 6.195313 24.738281 6.195313 36.015625 0 1.925781-1.0625 4.351562-.359375 5.410156 1.570313 1.0625 1.929687.359375 4.355468-1.570313 5.414062-6.839843 3.761719-14.347656 5.640625-21.847656 5.640625zm0 0"
      fill="#bf8e75"
    />
    <path
      d="m373.699219 159.449219c0 5.613281-4.550781 10.164062-10.167969 10.164062-5.613281 0-10.164062-4.550781-10.164062-10.164062 0-5.617188 4.550781-10.167969 10.164062-10.167969 5.617188 0 10.167969 4.550781 10.167969 10.167969zm0 0"
      fill="#3d4159"
    />
    <path
      d="m432.199219 159.449219c0 5.613281-4.550781 10.164062-10.164063 10.164062-5.617187 0-10.167968-4.550781-10.167968-10.164062 0-5.617188 4.550781-10.167969 10.167968-10.167969 5.613282 0 10.164063 4.550781 10.164063 10.167969zm0 0"
      fill="#3d4159"
    />
    <path
      d="m371.625 157.652344c0 2.40625-1.949219 4.359375-4.355469 4.359375s-4.355469-1.953125-4.355469-4.359375c0-2.402344 1.949219-4.355469 4.355469-4.355469s4.355469 1.953125 4.355469 4.355469zm0 0"
      fill="#fff"
    />
    <path
      d="m430.625 157.652344c0 2.40625-1.949219 4.359375-4.355469 4.359375s-4.355469-1.953125-4.355469-4.359375c0-2.402344 1.949219-4.355469 4.355469-4.355469s4.355469 1.953125 4.355469 4.355469zm0 0"
      fill="#fff"
    />
    <path
      d="m402.949219 185.042969h-20.332031c-2.421876 0-4.386719-1.964844-4.386719-4.386719s1.964843-4.382812 4.386719-4.382812h20.332031c2.421875 0 4.386719 1.960937 4.386719 4.382812-.003907 2.421875-1.964844 4.386719-4.386719 4.386719zm0 0"
      fill="#bf8e75"
    />
    <path
      d="m422.289062 327.726562h39.066407v11.957032h-39.066407zm0 0"
      fill="#bfd5de"
    />
    <path
      d="m387.539062 49.449219c27.148438 1.9375 48.945313 23.867187 50.324219 51.472656l.257813 5.183594h15.617187l8.410157 55.929687 20.371093-6.304687-2.734375-54.804688c-1.445312-29-25.429687-51.726562-54.453125-51.617187zm0 0"
      fill="#2a2f4f"
    />
    <path
      d="m478.058594 27.816406c21.617187 21.617188 21.617187 56.667969 0 78.285156-21.617188 21.617188-56.667969 21.617188-78.285156 0zm0 0"
      fill="#3d4159"
    />
    <path
      d="m399.773438 106.101562h-67.9375l-8.414063 55.933594-20.371094-6.304687 2.730469-54.808594c1.445312-28.992187 25.429688-51.726563 54.457031-51.617187l98.121094.371093 12.972656 23.347657"
      fill="#3d4159"
    />
    <path
      d="m398.027344 49.449219c-27.148438 1.9375-48.945313 23.867187-50.324219 51.472656l-.257813 5.183594h-15.613281l-8.414062 55.929687-20.371094-6.304687 2.734375-54.804688c1.445312-29 25.429688-51.726562 54.453125-51.617187zm0 0"
      fill="#2a2f4f"
    />
    <path
      d="m364.511719 468.742188v19.195312c-32.945313 15.433594-69.714844 24.0625-108.511719 24.0625s-75.578125-8.628906-108.523438-24.074219v-19.183593c0-37.878907 25.714844-69.738282 60.644532-79.078126 1.277344-.34375 2.5625-.660156 3.867187-.941406 3.46875-.753906 7.03125-1.273437 10.648438-1.566406 2.214843-.179688 4.441406-.273438 6.699219-.273438h53.308593c5.964844 0 11.765625.628907 17.367188 1.839844.324219.0625.648437.136719.960937.210938.941406.21875 1.878906.449218 2.808594.699218.035156.007813.042969.007813.074219.019532 9.21875 2.464844 17.796875 6.5 25.414062 11.796875 21.304688 14.777343 35.242188 39.402343 35.242188 67.292969zm0 0"
      fill="#3d4159"
    />
    <path
      d="m304.054688 388.722656-.199219.929688-26.109375 121.429687c-1.351563.113281-2.707032.21875-4.066406.3125-1.914063.125-3.835938.238281-5.769532.324219-3.949218.1875-7.917968.28125-11.910156.28125-4.097656 0-8.160156-.09375-12.203125-.292969-1.828125-.082031-3.660156-.1875-5.488281-.324219-1.367188-.09375-2.726563-.1875-4.085938-.300781l-26.101562-121.417969-.195313-.941406zm0 0"
      fill="#66baed"
    />
    <path
      d="m277.96875 416.421875-21.976562 35.242187-21.972657-35.242187"
      fill="#3d4159"
    />
    <path
      d="m273.679688 511.394531c-1.914063.125-3.835938.238281-5.769532.324219-3.949218.1875-7.917968.28125-11.910156.28125-4.097656 0-8.160156-.09375-12.203125-.292969-1.828125-.082031-3.660156-.1875-5.488281-.324219l17.691406-68.890624zm0 0"
      fill="#3d4159"
    />
    <path
      d="m255.988281 420.394531-36.855469 20.480469-11.210937-52.144531 22.898437-13.488281"
      fill="#2ba1cf"
    />
    <path
      d="m255.988281 420.394531 36.851563 20.480469 11.210937-52.144531-22.898437-13.488281"
      fill="#2ba1cf"
    />
    <path
      d="m305.445312 459.097656h11.691407l-20.417969 49.671875c-9.445312 1.515625-19.058594 2.507813-28.808594 2.949219l35.871094-122.085938.273438-.910156 25.214843 8.234375zm0 0"
      fill="#2a2f4f"
    />
    <path
      d="m243.796875 511.707031c-9.761719-.449219-19.382813-1.460937-28.828125-2.988281l-20.398438-49.621094h11.691407l-23.832031-62.140625 25.222656-8.234375.273437.910156zm0 0"
      fill="#2a2f4f"
    />
    <path
      d="m285.199219 355.351562v35.839844c0 13.125-8.652344 24.214844-20.570313 27.898438-2.730468.847656-5.636718 1.304687-8.644531 1.304687-16.128906 0-29.199219-13.074219-29.199219-29.203125v-35.839844zm0 0"
      fill="#eab599"
    />
    <path
      d="m285.199219 388.921875v2.273437c0 13.121094-8.652344 24.210938-20.570313 27.898438-10.753906-3.308594-18.839844-12.65625-20.332031-24.097656 1.953125.121094 3.914063.179687 5.882813.179687 5.527343 0 10.945312-.4375 16.21875-1.300781 6.503906-1.046875 12.785156-2.722656 18.800781-4.953125zm0 0"
      fill="#f6caae"
    />
    <path
      d="m175.875 296.609375c0 13.519531-9.878906 24.730469-22.8125 26.8125-1.414062.226563-2.867188.347656-4.347656.347656-15.003906 0-27.164063-12.15625-27.164063-27.160156s12.15625-27.164063 27.164063-27.164063c1.480468 0 2.933594.121094 4.347656.351563 12.933594 2.082031 22.8125 13.292969 22.8125 26.8125zm0 0"
      fill="#f6caae"
    />
    <path
      d="m175.875 296.609375c0 13.519531-9.878906 24.730469-22.8125 26.8125-2.347656-8.542969-3.601562-17.535156-3.601562-26.8125 0-9.28125 1.253906-18.269531 3.601562-26.8125 12.933594 2.082031 22.8125 13.292969 22.8125 26.8125zm0 0"
      fill="#eab599"
    />
    <path
      d="m158.421875 296.609375c0 5.359375-4.347656 9.707031-9.707031 9.707031-5.363282 0-9.707032-4.347656-9.707032-9.707031 0-5.363281 4.34375-9.707031 9.707032-9.707031 5.359375 0 9.707031 4.34375 9.707031 9.707031zm0 0"
      fill="#eab599"
    />
    <path
      d="m336.105469 296.609375c0 13.519531 9.878906 24.730469 22.8125 26.8125 1.410156.226563 2.867187.347656 4.347656.347656 15.003906 0 27.164063-12.15625 27.164063-27.160156s-12.15625-27.164063-27.164063-27.164063c-1.480469 0-2.9375.121094-4.347656.351563-12.933594 2.082031-22.8125 13.292969-22.8125 26.8125zm0 0"
      fill="#f6caae"
    />
    <path
      d="m336.105469 296.609375c0 13.519531 9.878906 24.730469 22.8125 26.8125 2.347656-8.542969 3.601562-17.535156 3.601562-26.8125 0-9.28125-1.253906-18.269531-3.601562-26.8125-12.933594 2.082031-22.8125 13.292969-22.8125 26.8125zm0 0"
      fill="#eab599"
    />
    <path
      d="m357.046875 243.695312v38.480469c0 50.289063-36.738281 92.003907-84.839844 99.746094-.160156.027344-.332031.054687-.492187.082031-5.117188.820313-10.367188 1.222656-15.726563 1.222656-55.808593 0-101.046875-45.242187-101.046875-101.046874v-38.484376c0-11.75 2.003906-23.042968 5.707032-33.535156 13.820312-39.328125 51.292968-67.523437 95.339843-67.523437h.007813c5.351562 0 10.609375.414062 15.734375 1.222656 48.335937 7.550781 85.316406 49.378906 85.316406 99.835937zm0 0"
      fill="#eab599"
    />
    <path
      d="m372.972656 296.609375c0 5.359375-4.34375 9.707031-9.707031 9.707031-5.359375 0-9.707031-4.347656-9.707031-9.707031 0-5.363281 4.347656-9.707031 9.707031-9.707031 5.363281 0 9.707031 4.34375 9.707031 9.707031zm0 0"
      fill="#eab599"
    />
    <path
      d="m357.042969 243.695312v38.480469c0 50.285157-36.734375 92.003907-84.835938 99.746094-.164062.027344-.332031.054687-.496093.082031-48.332032-7.554687-85.304688-49.378906-85.304688-99.828125v-38.480469c0-50.457031 36.980469-92.285156 85.324219-99.835937 48.335937 7.550781 85.3125 49.378906 85.3125 99.835937zm0 0"
      fill="#f6caae"
    />
    <path
      d="m234.46875 276.289062c0 6.332032-5.132812 11.464844-11.460938 11.464844-6.332031 0-11.464843-5.132812-11.464843-11.464844 0-6.328124 5.132812-11.460937 11.464843-11.460937 6.328126 0 11.460938 5.132813 11.460938 11.460937zm0 0"
      fill="#3d4159"
    />
    <path
      d="m300.441406 276.289062c0 6.332032-5.132812 11.464844-11.464844 11.464844-6.332031 0-11.464843-5.132812-11.464843-11.464844 0-6.328124 5.132812-11.460937 11.464843-11.460937 6.332032 0 11.464844 5.132813 11.464844 11.460937zm0 0"
      fill="#3d4159"
    />
    <path
      d="m232.132812 274.269531c0 2.710938-2.199218 4.910157-4.914062 4.910157-2.710938 0-4.910156-2.199219-4.910156-4.910157 0-2.714843 2.199218-4.914062 4.910156-4.914062 2.714844 0 4.914062 2.199219 4.914062 4.914062zm0 0"
      fill="#fff"
    />
    <path
      d="m298.664062 274.269531c0 2.710938-2.199218 4.910157-4.910156 4.910157-2.714844 0-4.914062-2.199219-4.914062-4.910157 0-2.714843 2.199218-4.914062 4.914062-4.914062 2.710938 0 4.910156 2.199219 4.910156 4.914062zm0 0"
      fill="#fff"
    />
    <path
      d="m267.457031 300.660156h-22.929687c-2.730469 0-4.945313-2.214844-4.945313-4.945312 0-2.734375 2.214844-4.945313 4.945313-4.945313h22.929687c2.730469 0 4.945313 2.210938 4.945313 4.945313-.003906 2.730468-2.21875 4.945312-4.945313 4.945312zm0 0"
      fill="#eab599"
    />
    <path
      d="m255.992188 331.945312c-8.460938 0-16.925782-2.121093-24.636719-6.363281-2.175781-1.195312-2.972657-3.929687-1.773438-6.101562 1.195313-2.175781 3.929688-2.96875 6.105469-1.777344 12.714844 6.992187 27.894531 6.992187 40.609375 0 2.175781-1.195313 4.910156-.402344 6.105469 1.777344 1.199218 2.171875.402344 4.90625-1.773438 6.101562-7.714844 4.242188-16.175781 6.363281-24.636718 6.363281zm0 0"
      fill="#eab599"
    />
    <path
      d="m357.046875 208.773438v39.417968h-18.808594v-30.871094l-135.765625-25.226562-28.726562-5.339844v61.4375h-18.808594v-39.421875c0-44.9375 36.421875-81.359375 81.351562-81.359375h39.40625c1.070313 0 2.140626.019532 3.210938.074219 43.433594 1.671875 78.140625 37.421875 78.140625 81.289063zm0 0"
      fill="#2a2f4f"
    />
    <path
      d="m357.046875 208.773438v39.417968h-18.808594v-30.871094l-135.765625-25.226562c7.480469-35.929688 38.652344-63.152344 76.433594-64.609375 43.433594 1.671875 78.140625 37.421875 78.140625 81.289063zm0 0"
      fill="#3d4159"
    />
  </svg>
);

export const TopMeanuButton = (className) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M4 6h16M4 12h16M4 18h16"
    />
  </svg>
);

export const User = (className) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
    />
  </svg>
);

export const Home = (className) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
    />
  </svg>
);

export const Messages = (className) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
    />
  </svg>
);

export const Link = (className) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"
    />
  </svg>
);

export const User2 = (className) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
    />
  </svg>
);

export const Logout = (className) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
    />
  </svg>
);
export const DocIcon = (className) => (
  <svg
    className={className}
    viewBox="0 0 500 500"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path d="m446.605 124.392-119.997-119.997c-2.801-2.802-6.624-4.395-10.608-4.395h-210c-24.813 0-45 20.187-45 45v422c0 24.813 20.187 45 45 45h300c24.813 0 45-20.187 45-45v-332c0-4.09-1.717-7.931-4.395-10.608zm-115.605-73.179 68.787 68.787h-53.787c-8.271 0-15-6.729-15-15zm75 430.787h-300c-8.271 0-15-6.729-15-15v-422c0-8.271 6.729-15 15-15h195v75c0 24.813 20.187 45 45 45h75v317c0 8.271-6.729 15-15 15z" />
      <path d="m346 212h-180c-8.284 0-15 6.716-15 15s6.716 15 15 15h180c8.284 0 15-6.716 15-15s-6.716-15-15-15z" />
      <path d="m346 272h-180c-8.284 0-15 6.716-15 15s6.716 15 15 15h180c8.284 0 15-6.716 15-15s-6.716-15-15-15z" />
      <path d="m346 332h-180c-8.284 0-15 6.716-15 15s6.716 15 15 15h180c8.284 0 15-6.716 15-15s-6.716-15-15-15z" />
      <path d="m286 392h-120c-8.284 0-15 6.716-15 15s6.716 15 15 15h120c8.284 0 15-6.716 15-15s-6.716-15-15-15z" />
    </g>
  </svg>
);

export const Logo = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 109 90"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M41.8115 20.4237C41.8115 22.5435 42.8127 24.4295 44.368 25.6346C44.3873 26.0718 44.4138 26.5306 44.447 27.0119V30.9648H49.0587V27.0119L49.0588 26.9793C51.9482 26.6923 54.2883 24.5386 54.8562 21.7413H73.4351C76.346 21.7413 78.7057 24.1011 78.7057 27.0119V46.1177C78.7057 49.0286 76.346 51.3883 73.4351 51.3883H54.3293C51.4185 51.3883 49.0587 49.0286 49.0587 46.1177V42.1648H44.447V46.1177C44.447 51.5756 48.8715 56.0001 54.3293 56.0001H73.4351C78.893 56.0001 83.3175 51.5756 83.3175 46.1177V27.0119C83.3175 21.5541 78.893 17.1296 73.4351 17.1296H54.3293L54.1016 17.121C52.9613 15.1565 50.8348 13.8354 48.3997 13.8354C44.7612 13.8354 41.8115 16.7851 41.8115 20.4237ZM48.3997 23.059C49.8551 23.059 51.035 21.8791 51.035 20.4237C51.035 18.9683 49.8551 17.7884 48.3997 17.7884C46.9443 17.7884 45.7644 18.9683 45.7644 20.4237C45.7644 21.8791 46.9443 23.059 48.3997 23.059Z"
      fill="#192C9F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M67.5059 35.5765C67.5059 33.4566 66.5047 31.5706 64.9494 30.3655C64.9301 29.9283 64.9036 29.4696 64.8704 28.9882L64.8704 25.0353L60.2587 25.0353L60.2587 28.9882L60.2586 29.0208C57.3692 29.3078 55.0291 31.4615 54.4612 34.2588L35.8823 34.2588C32.9714 34.2588 30.6117 31.8991 30.6117 28.9882L30.6117 9.88237C30.6117 6.97152 32.9714 4.6118 35.8823 4.6118L54.9881 4.6118C57.8989 4.6118 60.2587 6.97152 60.2587 9.88238L60.2587 13.8353L64.8704 13.8353L64.8704 9.88238C64.8704 4.42452 60.4459 5.66033e-05 54.9881 5.61261e-05L35.8823 5.44558e-05C30.4244 5.39787e-05 25.9999 4.42452 25.9999 9.88237L25.9999 28.9882C25.9999 34.4461 30.4244 38.8705 35.8823 38.8705L54.9881 38.8705L55.2158 38.8791C56.3561 40.8436 58.4826 42.1647 60.9176 42.1647C64.5562 42.1647 67.5059 39.215 67.5059 35.5765ZM60.9177 32.9412C59.4622 32.9412 58.2824 34.121 58.2824 35.5764C58.2824 37.0319 59.4622 38.2117 60.9177 38.2117C62.3731 38.2117 63.553 37.0319 63.553 35.5764C63.553 34.121 62.3731 32.9412 60.9177 32.9412Z"
      fill="#FFCE1F"
    />
    <path
      d="M20.186 72.168C19.346 72.168 18.632 72.0187 18.044 71.72C17.4653 71.4213 16.966 71.0293 16.546 70.544L17.792 69.34C18.128 69.732 18.5013 70.0307 18.912 70.236C19.332 70.4413 19.794 70.544 20.298 70.544C20.8673 70.544 21.2967 70.4227 21.586 70.18C21.8753 69.928 22.02 69.592 22.02 69.172C22.02 68.8453 21.9267 68.5793 21.74 68.374C21.5533 68.1687 21.2033 68.0193 20.69 67.926L19.766 67.786C17.8153 67.478 16.84 66.5307 16.84 64.944C16.84 64.5053 16.9193 64.1087 17.078 63.754C17.246 63.3993 17.484 63.096 17.792 62.844C18.1 62.592 18.4687 62.4007 18.898 62.27C19.3367 62.13 19.8313 62.06 20.382 62.06C21.1193 62.06 21.7633 62.1813 22.314 62.424C22.8647 62.6667 23.336 63.026 23.728 63.502L22.468 64.692C22.2253 64.3933 21.9313 64.1507 21.586 63.964C21.2407 63.7773 20.8067 63.684 20.284 63.684C19.752 63.684 19.3507 63.7867 19.08 63.992C18.8187 64.188 18.688 64.468 18.688 64.832C18.688 65.2053 18.7953 65.4807 19.01 65.658C19.2247 65.8353 19.57 65.966 20.046 66.05L20.956 66.218C21.9453 66.3953 22.6733 66.7127 23.14 67.17C23.616 67.618 23.854 68.248 23.854 69.06C23.854 69.5267 23.77 69.9513 23.602 70.334C23.4433 70.7073 23.2053 71.034 22.888 71.314C22.58 71.5847 22.1973 71.7947 21.74 71.944C21.292 72.0933 20.774 72.168 20.186 72.168ZM32.1466 74.492H30.7886C30.1446 74.492 29.6686 74.3333 29.3606 74.016C29.0619 73.708 28.9126 73.2693 28.9126 72.7V72.112C27.8486 71.9533 26.9993 71.4493 26.3646 70.6C25.7393 69.7507 25.4266 68.5887 25.4266 67.114C25.4266 66.2927 25.5293 65.5693 25.7346 64.944C25.9399 64.3093 26.2246 63.7773 26.5886 63.348C26.9619 62.9187 27.4099 62.5967 27.9326 62.382C28.4553 62.1673 29.0386 62.06 29.6826 62.06C30.3266 62.06 30.9099 62.1673 31.4326 62.382C31.9553 62.5967 32.4033 62.9187 32.7766 63.348C33.1499 63.7773 33.4346 64.3093 33.6306 64.944C33.8359 65.5693 33.9386 66.2927 33.9386 67.114C33.9386 68.5607 33.6446 69.6993 33.0566 70.53C32.4686 71.3607 31.6659 71.874 30.6486 72.07V72.98H32.1466V74.492ZM29.6826 70.53C30.3826 70.53 30.9379 70.2967 31.3486 69.83C31.7686 69.3633 31.9786 68.71 31.9786 67.87V66.358C31.9786 65.518 31.7686 64.8647 31.3486 64.398C30.9379 63.9313 30.3826 63.698 29.6826 63.698C28.9826 63.698 28.4226 63.9313 28.0026 64.398C27.5919 64.8647 27.3866 65.518 27.3866 66.358V67.87C27.3866 68.71 27.5919 69.3633 28.0026 69.83C28.4226 70.2967 28.9826 70.53 29.6826 70.53ZM37.7034 62.228V68.234C37.7034 68.9993 37.8481 69.5733 38.1374 69.956C38.4361 70.3387 38.9354 70.53 39.6354 70.53C40.3354 70.53 40.8301 70.3387 41.1194 69.956C41.4181 69.5733 41.5674 68.9993 41.5674 68.234V62.228H43.3874V67.996C43.3874 68.7147 43.3174 69.3353 43.1774 69.858C43.0467 70.3807 42.8321 70.8147 42.5334 71.16C42.2347 71.5053 41.8427 71.762 41.3574 71.93C40.8814 72.0887 40.3027 72.168 39.6214 72.168C38.9307 72.168 38.3474 72.0887 37.8714 71.93C37.4047 71.762 37.0221 71.5053 36.7234 71.16C36.4247 70.8147 36.2101 70.3807 36.0794 69.858C35.9487 69.3353 35.8834 68.7147 35.8834 67.996V62.228H37.7034ZM51.5066 72L50.7226 69.508H47.2506L46.4806 72H44.6046L47.8806 62.228H50.1766L53.4246 72H51.5066ZM49.0146 63.908H48.9446L47.6986 67.926H50.2746L49.0146 63.908ZM55.0049 62.228H58.5609C59.1955 62.228 59.7695 62.3307 60.2829 62.536C60.8055 62.7413 61.2489 63.0493 61.6129 63.46C61.9862 63.8613 62.2709 64.37 62.4669 64.986C62.6722 65.5927 62.7749 66.302 62.7749 67.114C62.7749 67.926 62.6722 68.64 62.4669 69.256C62.2709 69.8627 61.9862 70.3713 61.6129 70.782C61.2489 71.1833 60.8055 71.4867 60.2829 71.692C59.7695 71.8973 59.1955 72 58.5609 72H55.0049V62.228ZM58.5609 70.362C59.2515 70.362 59.7975 70.1613 60.1989 69.76C60.6095 69.3493 60.8149 68.724 60.8149 67.884V66.344C60.8149 65.504 60.6095 64.8833 60.1989 64.482C59.7975 64.0713 59.2515 63.866 58.5609 63.866H56.8529V70.362H58.5609ZM70.7192 67.87H66.6452V72H64.7972V62.228H66.6452V66.232H70.7192V62.228H72.5672V72H70.7192V67.87ZM76.7497 62.228V68.234C76.7497 68.9993 76.8944 69.5733 77.1837 69.956C77.4824 70.3387 77.9817 70.53 78.6817 70.53C79.3817 70.53 79.8764 70.3387 80.1657 69.956C80.4644 69.5733 80.6137 68.9993 80.6137 68.234V62.228H82.4337V67.996C82.4337 68.7147 82.3637 69.3353 82.2237 69.858C82.0931 70.3807 81.8784 70.8147 81.5797 71.16C81.2811 71.5053 80.8891 71.762 80.4037 71.93C79.9277 72.0887 79.3491 72.168 78.6677 72.168C77.9771 72.168 77.3937 72.0887 76.9177 71.93C76.4511 71.762 76.0684 71.5053 75.7697 71.16C75.4711 70.8147 75.2564 70.3807 75.1257 69.858C74.9951 69.3353 74.9297 68.7147 74.9297 67.996V62.228H76.7497ZM84.8057 62.228H89.3277C89.7291 62.228 90.0884 62.2887 90.4057 62.41C90.7324 62.5313 91.0077 62.6993 91.2317 62.914C91.4557 63.1287 91.6237 63.3947 91.7357 63.712C91.8571 64.02 91.9177 64.3607 91.9177 64.734C91.9177 65.1073 91.8664 65.4247 91.7637 65.686C91.6704 65.938 91.5397 66.148 91.3717 66.316C91.2131 66.484 91.0264 66.61 90.8117 66.694C90.6064 66.778 90.3917 66.8247 90.1677 66.834V66.918C90.3824 66.918 90.6111 66.96 90.8537 67.044C91.1057 67.128 91.3344 67.2633 91.5397 67.45C91.7544 67.6273 91.9317 67.8607 92.0717 68.15C92.2117 68.43 92.2817 68.78 92.2817 69.2C92.2817 69.592 92.2164 69.9607 92.0857 70.306C91.9644 70.642 91.7917 70.936 91.5677 71.188C91.3437 71.44 91.0777 71.6407 90.7697 71.79C90.4617 71.93 90.1257 72 89.7617 72H84.8057V62.228ZM86.6537 70.432H89.2297C89.5844 70.432 89.8597 70.3433 90.0557 70.166C90.2517 69.9793 90.3497 69.7133 90.3497 69.368V68.892C90.3497 68.5467 90.2517 68.2807 90.0557 68.094C89.8597 67.9073 89.5844 67.814 89.2297 67.814H86.6537V70.432ZM86.6537 66.302H88.9357C89.2717 66.302 89.5331 66.2133 89.7197 66.036C89.9064 65.8493 89.9997 65.5927 89.9997 65.266V64.832C89.9997 64.5053 89.9064 64.2533 89.7197 64.076C89.5331 63.8893 89.2717 63.796 88.9357 63.796H86.6537V66.302Z"
      fill="#192C9F"
    />
    <path
      d="M0.99 87V80.02H4.98V80.55H1.59V83.19H4.75V83.72H1.59V87H0.99ZM6.80805 80.49C6.67471 80.49 6.57471 80.4567 6.50805 80.39C6.44805 80.3233 6.41805 80.2367 6.41805 80.13V80.03C6.41805 79.9233 6.44805 79.8367 6.50805 79.77C6.57471 79.7033 6.67471 79.67 6.80805 79.67C6.94138 79.67 7.03805 79.7033 7.09805 79.77C7.16471 79.8367 7.19805 79.9233 7.19805 80.03V80.13C7.19805 80.2367 7.16471 80.3233 7.09805 80.39C7.03805 80.4567 6.94138 80.49 6.80805 80.49ZM6.52805 81.88H7.09805V87H6.52805V81.88ZM10.8897 87.12C10.5497 87.12 10.2397 87.06 9.95969 86.94C9.68635 86.82 9.44969 86.6467 9.24969 86.42C9.05635 86.1867 8.90635 85.9033 8.79969 85.57C8.69969 85.2367 8.64969 84.86 8.64969 84.44C8.64969 84.02 8.69969 83.6467 8.79969 83.32C8.90635 82.9867 9.05635 82.7067 9.24969 82.48C9.44969 82.2467 9.68635 82.07 9.95969 81.95C10.233 81.8233 10.5397 81.76 10.8797 81.76C11.2064 81.76 11.503 81.8233 11.7697 81.95C12.0364 82.07 12.263 82.24 12.4497 82.46C12.6364 82.68 12.7797 82.9467 12.8797 83.26C12.9864 83.5667 13.0397 83.9067 13.0397 84.28V84.55H9.24969V84.8C9.24969 85.0667 9.28635 85.3133 9.35969 85.54C9.43969 85.76 9.54969 85.95 9.68969 86.11C9.83635 86.27 10.013 86.3967 10.2197 86.49C10.4264 86.5767 10.6597 86.62 10.9197 86.62C11.6664 86.62 12.183 86.2767 12.4697 85.59L12.8897 85.87C12.7297 86.25 12.4764 86.5533 12.1297 86.78C11.7897 87.0067 11.3764 87.12 10.8897 87.12ZM10.8797 82.24C10.633 82.24 10.4097 82.2867 10.2097 82.38C10.0097 82.4667 9.83635 82.59 9.68969 82.75C9.54969 82.91 9.43969 83.1033 9.35969 83.33C9.28635 83.55 9.24969 83.7933 9.24969 84.06V84.11H12.4197V84.03C12.4197 83.7633 12.383 83.52 12.3097 83.3C12.2364 83.0733 12.1297 82.8833 11.9897 82.73C11.8564 82.5767 11.693 82.4567 11.4997 82.37C11.313 82.2833 11.1064 82.24 10.8797 82.24ZM15.2194 87C15.0127 87 14.856 86.9433 14.7494 86.83C14.6427 86.7167 14.5894 86.5667 14.5894 86.38V79.6H15.1594V86.5H15.9494V87H15.2194ZM20.6361 86.18H20.6061C20.4728 86.4667 20.2761 86.6967 20.0161 86.87C19.7628 87.0367 19.4394 87.12 19.0461 87.12C18.3861 87.12 17.8694 86.8867 17.4961 86.42C17.1228 85.9533 16.9361 85.2933 16.9361 84.44C16.9361 83.5867 17.1228 82.9267 17.4961 82.46C17.8694 81.9933 18.3861 81.76 19.0461 81.76C19.4394 81.76 19.7661 81.8467 20.0261 82.02C20.2861 82.1867 20.4794 82.4133 20.6061 82.7H20.6361V79.6H21.2061V87H20.6361V86.18ZM19.1761 86.61C19.3761 86.61 19.5628 86.5833 19.7361 86.53C19.9161 86.4767 20.0728 86.4 20.2061 86.3C20.3394 86.1933 20.4428 86.07 20.5161 85.93C20.5961 85.7833 20.6361 85.62 20.6361 85.44V83.41C20.6361 83.2433 20.5961 83.09 20.5161 82.95C20.4428 82.81 20.3394 82.69 20.2061 82.59C20.0728 82.49 19.9161 82.4133 19.7361 82.36C19.5628 82.3 19.3761 82.27 19.1761 82.27C18.6628 82.27 18.2628 82.4333 17.9761 82.76C17.6894 83.0867 17.5461 83.5267 17.5461 84.08V84.8C17.5461 85.3533 17.6894 85.7933 17.9761 86.12C18.2628 86.4467 18.6628 86.61 19.1761 86.61ZM27.5416 87.12C26.9682 87.12 26.4882 87.0133 26.1016 86.8C25.7216 86.58 25.3949 86.29 25.1216 85.93L25.5716 85.56C25.8182 85.8867 26.0949 86.14 26.4016 86.32C26.7149 86.5 27.1016 86.59 27.5616 86.59C28.1016 86.59 28.5149 86.4633 28.8016 86.21C29.0949 85.95 29.2416 85.59 29.2416 85.13C29.2416 84.7033 29.1182 84.39 28.8716 84.19C28.6249 83.99 28.2782 83.8433 27.8316 83.75L27.2116 83.62C26.5449 83.4867 26.0616 83.2633 25.7616 82.95C25.4616 82.6367 25.3116 82.2367 25.3116 81.75C25.3116 81.4433 25.3649 81.1767 25.4716 80.95C25.5782 80.7167 25.7282 80.5233 25.9216 80.37C26.1216 80.2167 26.3582 80.1 26.6316 80.02C26.9116 79.94 27.2182 79.9 27.5516 79.9C28.0716 79.9 28.5116 79.9933 28.8716 80.18C29.2316 80.3667 29.5282 80.63 29.7616 80.97L29.3116 81.3C29.1182 81.02 28.8749 80.8067 28.5816 80.66C28.2949 80.5067 27.9416 80.43 27.5216 80.43C27.0216 80.43 26.6249 80.54 26.3316 80.76C26.0449 80.9733 25.9016 81.2967 25.9016 81.73C25.9016 82.1433 26.0316 82.4467 26.2916 82.64C26.5516 82.8333 26.8982 82.9733 27.3316 83.06L27.9516 83.19C28.6449 83.3433 29.1316 83.58 29.4116 83.9C29.6916 84.22 29.8316 84.62 29.8316 85.1C29.8316 85.74 29.6282 86.2367 29.2216 86.59C28.8149 86.9433 28.2549 87.12 27.5416 87.12ZM33.2452 87.12C32.9052 87.12 32.5952 87.06 32.3152 86.94C32.0418 86.82 31.8052 86.6467 31.6052 86.42C31.4118 86.1867 31.2618 85.9033 31.1552 85.57C31.0552 85.2367 31.0052 84.86 31.0052 84.44C31.0052 84.02 31.0552 83.6467 31.1552 83.32C31.2618 82.9867 31.4118 82.7067 31.6052 82.48C31.8052 82.2467 32.0418 82.07 32.3152 81.95C32.5885 81.8233 32.8952 81.76 33.2352 81.76C33.5618 81.76 33.8585 81.8233 34.1252 81.95C34.3918 82.07 34.6185 82.24 34.8052 82.46C34.9918 82.68 35.1352 82.9467 35.2352 83.26C35.3418 83.5667 35.3952 83.9067 35.3952 84.28V84.55H31.6052V84.8C31.6052 85.0667 31.6418 85.3133 31.7152 85.54C31.7952 85.76 31.9052 85.95 32.0452 86.11C32.1918 86.27 32.3685 86.3967 32.5752 86.49C32.7818 86.5767 33.0152 86.62 33.2752 86.62C34.0218 86.62 34.5385 86.2767 34.8252 85.59L35.2452 85.87C35.0852 86.25 34.8318 86.5533 34.4852 86.78C34.1452 87.0067 33.7318 87.12 33.2452 87.12ZM33.2352 82.24C32.9885 82.24 32.7652 82.2867 32.5652 82.38C32.3652 82.4667 32.1918 82.59 32.0452 82.75C31.9052 82.91 31.7952 83.1033 31.7152 83.33C31.6418 83.55 31.6052 83.7933 31.6052 84.06V84.11H34.7752V84.03C34.7752 83.7633 34.7385 83.52 34.6652 83.3C34.5918 83.0733 34.4852 82.8833 34.3452 82.73C34.2118 82.5767 34.0485 82.4567 33.8552 82.37C33.6685 82.2833 33.4618 82.24 33.2352 82.24ZM36.9448 87V81.88H37.5148V82.8H37.5548C37.6548 82.56 37.8248 82.3467 38.0648 82.16C38.3048 81.9733 38.6448 81.88 39.0848 81.88H39.4248V82.44H38.9748C38.5482 82.44 38.1982 82.5333 37.9248 82.72C37.6515 82.9067 37.5148 83.1667 37.5148 83.5V87H36.9448ZM40.0358 81.88H40.6358L42.2058 86.39H42.2458L43.8058 81.88H44.3858L42.5358 87H41.8858L40.0358 81.88ZM45.8916 80.49C45.7583 80.49 45.6583 80.4567 45.5916 80.39C45.5316 80.3233 45.5016 80.2367 45.5016 80.13V80.03C45.5016 79.9233 45.5316 79.8367 45.5916 79.77C45.6583 79.7033 45.7583 79.67 45.8916 79.67C46.025 79.67 46.1216 79.7033 46.1816 79.77C46.2483 79.8367 46.2816 79.9233 46.2816 80.03V80.13C46.2816 80.2367 46.2483 80.3233 46.1816 80.39C46.1216 80.4567 46.025 80.49 45.8916 80.49ZM45.6116 81.88H46.1816V87H45.6116V81.88ZM49.9433 87.12C49.2366 87.12 48.6899 86.8867 48.3033 86.42C47.9233 85.9533 47.7333 85.2933 47.7333 84.44C47.7333 83.5867 47.9233 82.9267 48.3033 82.46C48.6899 81.9933 49.2366 81.76 49.9433 81.76C50.4166 81.76 50.7999 81.8633 51.0933 82.07C51.3866 82.2767 51.6099 82.55 51.7633 82.89L51.2833 83.13C51.1633 82.85 50.9933 82.6367 50.7733 82.49C50.5599 82.3433 50.2833 82.27 49.9433 82.27C49.4233 82.27 49.0266 82.4367 48.7533 82.77C48.4799 83.1033 48.3433 83.54 48.3433 84.08V84.8C48.3433 85.34 48.4799 85.7767 48.7533 86.11C49.0266 86.4433 49.4233 86.61 49.9433 86.61C50.2966 86.61 50.5933 86.5333 50.8333 86.38C51.0733 86.2267 51.2666 86.0067 51.4133 85.72L51.8333 86C51.6666 86.34 51.4266 86.6133 51.1133 86.82C50.8066 87.02 50.4166 87.12 49.9433 87.12ZM54.9561 87.12C54.6161 87.12 54.3061 87.06 54.0261 86.94C53.7528 86.82 53.5161 86.6467 53.3161 86.42C53.1228 86.1867 52.9728 85.9033 52.8661 85.57C52.7661 85.2367 52.7161 84.86 52.7161 84.44C52.7161 84.02 52.7661 83.6467 52.8661 83.32C52.9728 82.9867 53.1228 82.7067 53.3161 82.48C53.5161 82.2467 53.7528 82.07 54.0261 81.95C54.2994 81.8233 54.6061 81.76 54.9461 81.76C55.2728 81.76 55.5694 81.8233 55.8361 81.95C56.1028 82.07 56.3294 82.24 56.5161 82.46C56.7028 82.68 56.8461 82.9467 56.9461 83.26C57.0528 83.5667 57.1061 83.9067 57.1061 84.28V84.55H53.3161V84.8C53.3161 85.0667 53.3528 85.3133 53.4261 85.54C53.5061 85.76 53.6161 85.95 53.7561 86.11C53.9028 86.27 54.0794 86.3967 54.2861 86.49C54.4928 86.5767 54.7261 86.62 54.9861 86.62C55.7328 86.62 56.2494 86.2767 56.5361 85.59L56.9561 85.87C56.7961 86.25 56.5428 86.5533 56.1961 86.78C55.8561 87.0067 55.4428 87.12 54.9561 87.12ZM54.9461 82.24C54.6994 82.24 54.4761 82.2867 54.2761 82.38C54.0761 82.4667 53.9028 82.59 53.7561 82.75C53.6161 82.91 53.5061 83.1033 53.4261 83.33C53.3528 83.55 53.3161 83.7933 53.3161 84.06V84.11H56.4861V84.03C56.4861 83.7633 56.4494 83.52 56.3761 83.3C56.3028 83.0733 56.1961 82.8833 56.0561 82.73C55.9228 82.5767 55.7594 82.4567 55.5661 82.37C55.3794 82.2833 55.1728 82.24 54.9461 82.24ZM63.6791 87.12C62.7857 87.12 62.0857 86.8167 61.5791 86.21C61.0724 85.5967 60.8191 84.6967 60.8191 83.51C60.8191 82.3233 61.0724 81.4267 61.5791 80.82C62.0857 80.2067 62.7857 79.9 63.6791 79.9C64.5657 79.9 65.2624 80.2067 65.7691 80.82C66.2757 81.4333 66.5291 82.33 66.5291 83.51C66.5291 84.69 66.2757 85.5867 65.7691 86.2C65.2624 86.8133 64.5657 87.12 63.6791 87.12ZM63.6791 86.58C64.0124 86.58 64.3124 86.5233 64.5791 86.41C64.8524 86.29 65.0857 86.1167 65.2791 85.89C65.4724 85.6633 65.6224 85.3867 65.7291 85.06C65.8357 84.7333 65.8891 84.3633 65.8891 83.95V83.07C65.8891 82.6567 65.8357 82.2867 65.7291 81.96C65.6224 81.6333 65.4724 81.36 65.2791 81.14C65.0857 80.9133 64.8524 80.74 64.5791 80.62C64.3124 80.5 64.0124 80.44 63.6791 80.44C63.3457 80.44 63.0424 80.5 62.7691 80.62C62.4957 80.74 62.2624 80.9133 62.0691 81.14C61.8757 81.36 61.7257 81.6333 61.6191 81.96C61.5124 82.2867 61.4591 82.6567 61.4591 83.07V83.95C61.4591 84.3633 61.5124 84.7333 61.6191 85.06C61.7257 85.3867 61.8757 85.6633 62.0691 85.89C62.2624 86.1167 62.4957 86.29 62.7691 86.41C63.0424 86.5233 63.3457 86.58 63.6791 86.58ZM68.1917 81.88H68.7617V82.7H68.7917C68.9184 82.4133 69.1117 82.1867 69.3717 82.02C69.6317 81.8467 69.9584 81.76 70.3517 81.76C71.0117 81.76 71.5284 81.9933 71.9017 82.46C72.2751 82.9267 72.4617 83.5867 72.4617 84.44C72.4617 85.2933 72.2751 85.9533 71.9017 86.42C71.5284 86.8867 71.0117 87.12 70.3517 87.12C69.9584 87.12 69.6351 87.0367 69.3817 86.87C69.1284 86.6967 68.9317 86.4667 68.7917 86.18H68.7617V89H68.1917V81.88ZM70.2217 86.61C70.7351 86.61 71.1351 86.4467 71.4217 86.12C71.7084 85.7933 71.8517 85.3533 71.8517 84.8V84.08C71.8517 83.5267 71.7084 83.0867 71.4217 82.76C71.1351 82.4333 70.7351 82.27 70.2217 82.27C70.0217 82.27 69.8317 82.3 69.6517 82.36C69.4784 82.4133 69.3251 82.49 69.1917 82.59C69.0584 82.69 68.9517 82.81 68.8717 82.95C68.7984 83.09 68.7617 83.2433 68.7617 83.41V85.44C68.7617 85.62 68.7984 85.7833 68.8717 85.93C68.9517 86.07 69.0584 86.1933 69.1917 86.3C69.3251 86.4 69.4784 86.4767 69.6517 86.53C69.8317 86.5833 70.0217 86.61 70.2217 86.61ZM75.8639 87.12C75.5239 87.12 75.2139 87.06 74.9339 86.94C74.6606 86.82 74.4239 86.6467 74.2239 86.42C74.0306 86.1867 73.8806 85.9033 73.7739 85.57C73.6739 85.2367 73.6239 84.86 73.6239 84.44C73.6239 84.02 73.6739 83.6467 73.7739 83.32C73.8806 82.9867 74.0306 82.7067 74.2239 82.48C74.4239 82.2467 74.6606 82.07 74.9339 81.95C75.2072 81.8233 75.5139 81.76 75.8539 81.76C76.1806 81.76 76.4772 81.8233 76.7439 81.95C77.0106 82.07 77.2372 82.24 77.4239 82.46C77.6106 82.68 77.7539 82.9467 77.8539 83.26C77.9606 83.5667 78.0139 83.9067 78.0139 84.28V84.55H74.2239V84.8C74.2239 85.0667 74.2606 85.3133 74.3339 85.54C74.4139 85.76 74.5239 85.95 74.6639 86.11C74.8106 86.27 74.9872 86.3967 75.1939 86.49C75.4006 86.5767 75.6339 86.62 75.8939 86.62C76.6406 86.62 77.1572 86.2767 77.4439 85.59L77.8639 85.87C77.7039 86.25 77.4506 86.5533 77.1039 86.78C76.7639 87.0067 76.3506 87.12 75.8639 87.12ZM75.8539 82.24C75.6072 82.24 75.3839 82.2867 75.1839 82.38C74.9839 82.4667 74.8106 82.59 74.6639 82.75C74.5239 82.91 74.4139 83.1033 74.3339 83.33C74.2606 83.55 74.2239 83.7933 74.2239 84.06V84.11H77.3939V84.03C77.3939 83.7633 77.3572 83.52 77.2839 83.3C77.2106 83.0733 77.1039 82.8833 76.9639 82.73C76.8306 82.5767 76.6672 82.4567 76.4739 82.37C76.2872 82.2833 76.0806 82.24 75.8539 82.24ZM79.5636 87V81.88H80.1336V82.8H80.1736C80.2736 82.56 80.4436 82.3467 80.6836 82.16C80.9236 81.9733 81.2636 81.88 81.7036 81.88H82.0436V82.44H81.5936C81.1669 82.44 80.8169 82.5333 80.5436 82.72C80.2703 82.9067 80.1336 83.1667 80.1336 83.5V87H79.5636ZM86.7383 87C86.5183 87 86.3583 86.9433 86.2583 86.83C86.1583 86.7167 86.1016 86.5633 86.0883 86.37V86.19H86.0383C85.925 86.4767 85.7383 86.7033 85.4783 86.87C85.2183 87.0367 84.8883 87.12 84.4883 87.12C83.9483 87.12 83.5316 86.99 83.2383 86.73C82.945 86.4633 82.7983 86.09 82.7983 85.61C82.7983 85.1567 82.9583 84.7967 83.2783 84.53C83.605 84.2633 84.1383 84.13 84.8783 84.13H86.0583V83.53C86.0583 82.6833 85.6216 82.26 84.7483 82.26C84.4083 82.26 84.125 82.3333 83.8983 82.48C83.6716 82.62 83.4883 82.8233 83.3483 83.09L82.9883 82.79C83.1283 82.49 83.3416 82.2433 83.6283 82.05C83.9216 81.8567 84.3016 81.76 84.7683 81.76C85.3683 81.76 85.8283 81.91 86.1483 82.21C86.4683 82.51 86.6283 82.93 86.6283 83.47V86.5H87.3183V87H86.7383ZM84.5683 86.63C84.775 86.63 84.9683 86.6033 85.1483 86.55C85.3283 86.4967 85.485 86.4233 85.6183 86.33C85.7583 86.23 85.865 86.1133 85.9383 85.98C86.0183 85.84 86.0583 85.6833 86.0583 85.51V84.56H84.8583C84.345 84.56 83.9716 84.6433 83.7383 84.81C83.5116 84.97 83.3983 85.1933 83.3983 85.48V85.72C83.3983 86.02 83.505 86.2467 83.7183 86.4C83.9316 86.5533 84.215 86.63 84.5683 86.63ZM89.4913 87C89.2846 87 89.1279 86.9433 89.0213 86.83C88.9146 86.7167 88.8613 86.5633 88.8613 86.37V82.38H87.9713V81.88H88.5513C88.6913 81.88 88.7846 81.8533 88.8313 81.8C88.8846 81.74 88.9113 81.6367 88.9113 81.49V80.45H89.4313V81.88H90.5913V82.38H89.4313V86.5H90.5113V87H89.4913ZM92.3409 80.49C92.2075 80.49 92.1075 80.4567 92.0409 80.39C91.9809 80.3233 91.9509 80.2367 91.9509 80.13V80.03C91.9509 79.9233 91.9809 79.8367 92.0409 79.77C92.1075 79.7033 92.2075 79.67 92.3409 79.67C92.4742 79.67 92.5709 79.7033 92.6309 79.77C92.6975 79.8367 92.7309 79.9233 92.7309 80.03V80.13C92.7309 80.2367 92.6975 80.3233 92.6309 80.39C92.5709 80.4567 92.4742 80.49 92.3409 80.49ZM92.0609 81.88H92.6309V87H92.0609V81.88ZM93.8725 81.88H94.4725L96.0425 86.39H96.0825L97.6425 81.88H98.2225L96.3725 87H95.7225L93.8725 81.88ZM101.21 87.12C100.87 87.12 100.56 87.06 100.28 86.94C100.007 86.82 99.77 86.6467 99.57 86.42C99.3767 86.1867 99.2267 85.9033 99.12 85.57C99.02 85.2367 98.97 84.86 98.97 84.44C98.97 84.02 99.02 83.6467 99.12 83.32C99.2267 82.9867 99.3767 82.7067 99.57 82.48C99.77 82.2467 100.007 82.07 100.28 81.95C100.553 81.8233 100.86 81.76 101.2 81.76C101.527 81.76 101.823 81.8233 102.09 81.95C102.357 82.07 102.583 82.24 102.77 82.46C102.957 82.68 103.1 82.9467 103.2 83.26C103.307 83.5667 103.36 83.9067 103.36 84.28V84.55H99.57V84.8C99.57 85.0667 99.6067 85.3133 99.68 85.54C99.76 85.76 99.87 85.95 100.01 86.11C100.157 86.27 100.333 86.3967 100.54 86.49C100.747 86.5767 100.98 86.62 101.24 86.62C101.987 86.62 102.503 86.2767 102.79 85.59L103.21 85.87C103.05 86.25 102.797 86.5533 102.45 86.78C102.11 87.0067 101.697 87.12 101.21 87.12ZM101.2 82.24C100.953 82.24 100.73 82.2867 100.53 82.38C100.33 82.4667 100.157 82.59 100.01 82.75C99.87 82.91 99.76 83.1033 99.68 83.33C99.6067 83.55 99.57 83.7933 99.57 84.06V84.11H102.74V84.03C102.74 83.7633 102.703 83.52 102.63 83.3C102.557 83.0733 102.45 82.8833 102.31 82.73C102.177 82.5767 102.013 82.4567 101.82 82.37C101.633 82.2833 101.427 82.24 101.2 82.24ZM106.36 87.12C105.913 87.12 105.53 87.0367 105.21 86.87C104.896 86.7033 104.623 86.46 104.39 86.14L104.81 85.81C105.023 86.09 105.256 86.2967 105.51 86.43C105.763 86.5633 106.06 86.63 106.4 86.63C106.793 86.63 107.096 86.5467 107.31 86.38C107.523 86.2133 107.63 85.9733 107.63 85.66C107.63 85.3867 107.546 85.1733 107.38 85.02C107.22 84.86 106.953 84.7533 106.58 84.7L106.16 84.63C105.926 84.5967 105.713 84.5467 105.52 84.48C105.326 84.4133 105.16 84.3233 105.02 84.21C104.886 84.0967 104.78 83.96 104.7 83.8C104.626 83.6333 104.59 83.4333 104.59 83.2C104.59 82.96 104.633 82.75 104.72 82.57C104.813 82.39 104.936 82.24 105.09 82.12C105.243 82 105.426 81.91 105.64 81.85C105.853 81.79 106.083 81.76 106.33 81.76C106.756 81.76 107.106 81.8333 107.38 81.98C107.653 82.1267 107.886 82.3167 108.08 82.55L107.7 82.9C107.566 82.74 107.386 82.5933 107.16 82.46C106.94 82.32 106.653 82.25 106.3 82.25C105.933 82.25 105.646 82.33 105.44 82.49C105.24 82.65 105.14 82.8767 105.14 83.17C105.14 83.47 105.23 83.6867 105.41 83.82C105.596 83.9533 105.873 84.05 106.24 84.11L106.65 84.17C107.17 84.25 107.553 84.4067 107.8 84.64C108.053 84.8667 108.18 85.1867 108.18 85.6C108.18 86.08 108.016 86.4533 107.69 86.72C107.37 86.9867 106.926 87.12 106.36 87.12Z"
      fill="#192C9F"
    />
  </svg>
);

export const fourBox = (className) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="261.659px"
    height="261.659px"
    viewBox="0 0 261.659 261.659"
  >
    <g>
      <g>
        <path
          d="M113.2,0H13.22C5.915,0,0,5.927,0,13.22v99.974c0,7.305,5.921,13.229,13.22,13.229h99.98
			c7.305,0,13.222-5.924,13.222-13.229V13.226C126.422,5.927,120.499,0,113.2,0z"
        />
        <path
          d="M248.443,0h-99.98c-7.296,0-13.226,5.927-13.226,13.22v99.974c0,7.305,5.936,13.229,13.226,13.229h99.98
			c7.302,0,13.216-5.924,13.216-13.229V13.226C261.659,5.927,255.738,0,248.443,0z"
        />
        <path
          d="M113.2,135.24H13.22C5.915,135.24,0,141.161,0,148.463v99.979c0,7.302,5.921,13.217,13.22,13.217h99.98
			c7.305,0,13.222-5.915,13.222-13.217v-99.979C126.422,141.161,120.499,135.24,113.2,135.24z"
        />
        <path
          d="M248.443,135.24h-99.98c-7.296,0-13.226,5.921-13.226,13.223v99.979c0,7.302,5.936,13.217,13.226,13.217h99.98
			c7.302,0,13.216-5.915,13.216-13.217v-99.979C261.659,141.161,255.738,135.24,248.443,135.24z"
        />
      </g>
    </g>
  </svg>
);

export const Order = (className) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    viewBox="0 0 145.4 193.8"
    fill="currentColor"
  >
    <rect class="a" x="64.9" y="89" width="56.3" height="8" />
    <rect class="a" x="64.9" y="121" width="56.3" height="8" />
    <rect class="a" x="64.9" y="153.2" width="56.3" height="8" />
    <rect class="a" x="24.6" y="145.2" width="24" height="24" />
    <rect class="a" x="24.6" y="113" width="24" height="24" />
    <path
      class="a"
      d="M183.2,68.5h-5a20.6,20.6,0,0,0-20-16.3h-3.9v-.9a24,24,0,1,0-48,0v.9h-3.8a20.5,20.5,0,0,0-20,16.3H77.1A19.7,19.7,0,0,0,57.4,88.1V201.4A19.7,19.7,0,0,0,77.1,221H183.2a19.6,19.6,0,0,0,19.6-19.6V88.1A19.6,19.6,0,0,0,183.2,68.5ZM118,52.2a12.3,12.3,0,0,1,24.6,0h0a12.3,12.3,0,1,1-24.6,0Zm76.7,149.2A11.6,11.6,0,0,1,183.2,213H77.1a11.6,11.6,0,0,1-11.6-11.6V88.1A11.6,11.6,0,0,1,77.1,76.6H82v13a15,15,0,0,0,.2,2.2h96.3a15.5,15.5,0,0,0,.1-2.2v-13h4.6a11.6,11.6,0,0,1,11.5,11.5Z"
      transform="translate(-57.4 -27.3)"
    />
    <rect class="a" x="24.6" y="81" width="24" height="24" />
  </svg>
);

export const Star = (className) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 512.001 512.001"
  >
    <g>
      <g>
        <path
          d="M511.266,197.256c-1.764-5.431-6.458-9.388-12.108-10.209l-158.722-23.065L269.452,20.155
			c-2.527-5.12-7.741-8.361-13.451-8.361c-5.709,0-10.924,3.242-13.451,8.361l-70.988,143.828L12.843,187.047
			c-5.65,0.821-10.344,4.779-12.108,10.209c-1.765,5.43-0.293,11.391,3.795,15.376l114.848,111.955L92.27,482.67
			c-0.965,5.627,1.349,11.315,5.968,14.67c4.618,3.355,10.74,3.798,15.797,1.142L256,423.846l141.961,74.637
			c2.195,1.154,4.591,1.723,6.979,1.723c3.11,0,6.206-0.966,8.818-2.865c4.619-3.356,6.933-9.043,5.968-14.671L392.61,324.587
			l114.86-111.954C511.559,208.647,513.031,202.686,511.266,197.256z M366.023,308.608c-3.536,3.446-5.15,8.412-4.314,13.278
			l23.311,135.898l-122.038-64.162c-4.37-2.297-9.591-2.297-13.961,0l-122.045,64.163l23.304-135.9
			c0.834-4.866-0.779-9.83-4.313-13.276l-98.731-96.244l136.445-19.829c4.886-0.71,9.108-3.778,11.294-8.205L256,60.685
			l61.023,123.645c2.186,4.427,6.408,7.496,11.294,8.206l136.447,19.828L366.023,308.608z"
        />
      </g>
    </g>
  </svg>
);

export const Settings = (className) => (
  <svg
    className={className}
    enable-background="new 0 0 512 512"
    height="512"
    viewBox="0 0 512 512"
    width="512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="m272.066 512h-32.133c-25.989 0-47.134-21.144-47.134-47.133v-10.871c-11.049-3.53-21.784-7.986-32.097-13.323l-7.704 7.704c-18.659 18.682-48.548 18.134-66.665-.007l-22.711-22.71c-18.149-18.129-18.671-48.008.006-66.665l7.698-7.698c-5.337-10.313-9.792-21.046-13.323-32.097h-10.87c-25.988 0-47.133-21.144-47.133-47.133v-32.134c0-25.989 21.145-47.133 47.134-47.133h10.87c3.531-11.05 7.986-21.784 13.323-32.097l-7.704-7.703c-18.666-18.646-18.151-48.528.006-66.665l22.713-22.712c18.159-18.184 48.041-18.638 66.664.006l7.697 7.697c10.313-5.336 21.048-9.792 32.097-13.323v-10.87c0-25.989 21.144-47.133 47.134-47.133h32.133c25.989 0 47.133 21.144 47.133 47.133v10.871c11.049 3.53 21.784 7.986 32.097 13.323l7.704-7.704c18.659-18.682 48.548-18.134 66.665.007l22.711 22.71c18.149 18.129 18.671 48.008-.006 66.665l-7.698 7.698c5.337 10.313 9.792 21.046 13.323 32.097h10.87c25.989 0 47.134 21.144 47.134 47.133v32.134c0 25.989-21.145 47.133-47.134 47.133h-10.87c-3.531 11.05-7.986 21.784-13.323 32.097l7.704 7.704c18.666 18.646 18.151 48.528-.006 66.665l-22.713 22.712c-18.159 18.184-48.041 18.638-66.664-.006l-7.697-7.697c-10.313 5.336-21.048 9.792-32.097 13.323v10.871c0 25.987-21.144 47.131-47.134 47.131zm-106.349-102.83c14.327 8.473 29.747 14.874 45.831 19.025 6.624 1.709 11.252 7.683 11.252 14.524v22.148c0 9.447 7.687 17.133 17.134 17.133h32.133c9.447 0 17.134-7.686 17.134-17.133v-22.148c0-6.841 4.628-12.815 11.252-14.524 16.084-4.151 31.504-10.552 45.831-19.025 5.895-3.486 13.4-2.538 18.243 2.305l15.688 15.689c6.764 6.772 17.626 6.615 24.224.007l22.727-22.726c6.582-6.574 6.802-17.438.006-24.225l-15.695-15.695c-4.842-4.842-5.79-12.348-2.305-18.242 8.473-14.326 14.873-29.746 19.024-45.831 1.71-6.624 7.684-11.251 14.524-11.251h22.147c9.447 0 17.134-7.686 17.134-17.133v-32.134c0-9.447-7.687-17.133-17.134-17.133h-22.147c-6.841 0-12.814-4.628-14.524-11.251-4.151-16.085-10.552-31.505-19.024-45.831-3.485-5.894-2.537-13.4 2.305-18.242l15.689-15.689c6.782-6.774 6.605-17.634.006-24.225l-22.725-22.725c-6.587-6.596-17.451-6.789-24.225-.006l-15.694 15.695c-4.842 4.843-12.35 5.791-18.243 2.305-14.327-8.473-29.747-14.874-45.831-19.025-6.624-1.709-11.252-7.683-11.252-14.524v-22.15c0-9.447-7.687-17.133-17.134-17.133h-32.133c-9.447 0-17.134 7.686-17.134 17.133v22.148c0 6.841-4.628 12.815-11.252 14.524-16.084 4.151-31.504 10.552-45.831 19.025-5.896 3.485-13.401 2.537-18.243-2.305l-15.688-15.689c-6.764-6.772-17.627-6.615-24.224-.007l-22.727 22.726c-6.582 6.574-6.802 17.437-.006 24.225l15.695 15.695c4.842 4.842 5.79 12.348 2.305 18.242-8.473 14.326-14.873 29.746-19.024 45.831-1.71 6.624-7.684 11.251-14.524 11.251h-22.148c-9.447.001-17.134 7.687-17.134 17.134v32.134c0 9.447 7.687 17.133 17.134 17.133h22.147c6.841 0 12.814 4.628 14.524 11.251 4.151 16.085 10.552 31.505 19.024 45.831 3.485 5.894 2.537 13.4-2.305 18.242l-15.689 15.689c-6.782 6.774-6.605 17.634-.006 24.225l22.725 22.725c6.587 6.596 17.451 6.789 24.225.006l15.694-15.695c3.568-3.567 10.991-6.594 18.244-2.304z" />
    <path d="m256 367.4c-61.427 0-111.4-49.974-111.4-111.4s49.973-111.4 111.4-111.4 111.4 49.974 111.4 111.4-49.973 111.4-111.4 111.4zm0-192.8c-44.885 0-81.4 36.516-81.4 81.4s36.516 81.4 81.4 81.4 81.4-36.516 81.4-81.4-36.515-81.4-81.4-81.4z" />
  </svg>
);
export const speedMeter = (className) => (
  <svg
    className={className}
    enable-background="new 0 0 512 512"
    height="512"
    viewBox="0 0 512 512"
    width="512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <g>
        <path d="m289.235 380.921h-65.904c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h65.904c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5z" />
        <path d="m415.958 255.986c0-88.195-71.763-159.948-159.972-159.948-88.193 0-159.944 71.752-159.944 159.948 0 4.142 3.358 7.5 7.5 7.5h39.996c4.142 0 7.5-3.358 7.5-7.5 0-34.116 16.72-66.047 44.239-85.614l4.899 22.842c-17.183 15.681-26.948 37.694-26.948 61.1 0 4.142 3.358 7.5 7.5 7.5s7.5-3.358 7.5-7.5c0-16.063 5.64-31.311 15.746-43.393l20.867 97.29c.538 2.514 1.194 4.925 1.954 7.239-13.963-6.68-25.448-18.06-32.162-32.374-1.759-3.75-6.226-5.364-9.975-3.605-3.75 1.759-5.365 6.225-3.605 9.975 10.871 23.18 31.99 40.07 56.839 45.619 6.236 6.819 14.206 11.314 23.483 13.015 2.653.487 5.338.722 8.021.722 15.835 0 31.6-8.214 40.242-21.592 3.184-4.93 5.234-10.231 6.165-15.752 14.802-15.476 22.941-35.653 22.941-57.142 0-45.634-37.125-82.76-82.758-82.76-6.467 0-12.887.76-19.156 2.246l-12.41-17.934c10.159-3.204 20.738-4.83 31.566-4.83 57.884 0 104.976 47.081 104.976 104.951 0 4.142 3.358 7.5 7.5 7.5h39.996c4.142-.003 7.5-3.361 7.5-7.503zm-279.684-7.5h-25.041c1.759-34.324 15.52-65.527 37.149-89.5l17.687 17.687c-17.414 19.783-28.107 45.009-29.795 71.813zm119.712-61.933c37.362 0 67.758 30.397 67.758 67.76 0 12.631-3.43 24.715-9.849 35.217-1.792-5.452-4.543-10.926-8.258-16.298l-59.484-85.962c3.248-.473 6.533-.717 9.833-.717zm37.314 95.215c9.281 13.417 10.608 26.665 3.738 37.302-6.793 10.516-20.654 16.507-32.958 14.255-12.434-2.28-21.16-12.313-24.572-28.256l-31.405-146.421zm-44.814-145.5c-11.571.711-22.859 3.065-33.695 7.032-5.19-4.397-10.789-4.512-14.554-2.887-4.009 1.73-8.011 6.32-7.916 13.913-5.576 3.5-10.799 7.435-15.656 11.729l-17.677-17.677c23.971-21.631 55.175-35.387 89.498-37.145zm15 .008v-25.043c34.327 1.758 65.534 15.512 89.509 37.139l-17.686 17.704c-19.407-17.134-44.379-28.099-71.823-29.8zm112.244 112.21c-1.701-27.437-12.671-52.406-29.808-71.808l17.681-17.699c21.638 23.973 35.403 55.18 37.163 89.507z" />
        <path d="m100.818 100.814c-41.448 41.449-64.274 96.557-64.274 155.171s22.826 113.722 64.274 155.171 96.554 64.276 155.167 64.276 113.72-22.827 155.167-64.276c41.448-41.449 64.274-96.557 64.274-155.171s-22.826-113.722-64.274-155.171-96.554-64.276-155.167-64.276-113.719 22.828-155.167 64.276zm16.016 304.934 10.38-10.38c2.929-2.929 2.929-7.678 0-10.606-2.929-2.93-7.678-2.929-10.606 0l-10.38 10.38c-33.613-36.112-52.767-82.355-54.533-131.656h14.687c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-14.688c1.766-49.301 20.921-95.543 54.533-131.656l10.38 10.38c1.464 1.465 3.384 2.197 5.303 2.197s3.839-.732 5.303-2.197c2.929-2.929 2.929-7.677 0-10.606l-10.38-10.38c36.111-33.614 82.352-52.769 131.652-54.535v14.688c0 4.142 3.358 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-14.689c49.3 1.767 95.541 20.921 131.652 54.535l-10.38 10.38c-2.929 2.929-2.929 7.678 0 10.606 1.464 1.465 3.384 2.197 5.303 2.197s3.839-.732 5.303-2.197l10.38-10.38c33.613 36.112 52.767 82.355 54.533 131.656h-14.687c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h14.687c-1.766 49.301-20.921 95.543-54.533 131.656l-10.38-10.38c-2.929-2.929-7.678-2.929-10.606 0-2.929 2.929-2.929 7.677 0 10.606l10.38 10.38c-37.937 35.314-87.053 54.685-139.152 54.685s-101.214-19.37-139.151-54.684z" />
        <path d="m489.512 150.957c-14.408-31.979-34.894-60.238-60.887-83.994-3.057-2.794-7.801-2.582-10.596.477-2.794 3.058-2.581 7.801.477 10.596 49.879 45.586 78.487 110.447 78.487 177.951 0 132.894-108.115 241.013-241.007 241.013-132.877 0-240.979-108.119-240.979-241.014 0-132.88 108.102-240.986 240.979-240.986 49.592 0 97.215 14.942 137.72 43.211 3.398 2.371 8.072 1.539 10.443-1.858s1.539-8.072-1.858-10.443c-43.036-30.035-93.627-45.91-146.305-45.91-68.37 0-132.651 26.628-181.001 74.98-48.351 48.352-74.978 112.634-74.978 181.006 0 68.384 26.627 132.675 74.978 181.03 48.348 48.354 112.629 74.984 181.001 74.984 68.384 0 132.673-26.63 181.026-74.984s74.981-112.645 74.981-181.03c0-36.584-7.564-71.921-22.481-105.029z" />
      </g>
    </g>
  </svg>
);

export const teenager1 = (className) => (
  <svg
    enable-background="new 0 0 512 512"
    viewBox="0 0 512 512"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <g>
        <path
          d="m445.002 234.727h-154.527v-41.207h154.527c11.379 0 20.604 9.225 20.604 20.604 0 11.378-9.225 20.603-20.604 20.603z"
          fill="#7acefa"
        />
      </g>
      <g>
        <path
          d="m355.393 487.489c-6.33-31.767-24.73-59.178-50.212-77.266h-144.219c-25.482 18.087-43.882 45.499-50.212 77.266-2.53 12.696 7.29 24.511 20.235 24.511h29.977l73.974-20.571 70.251 20.571h29.971c12.945 0 22.765-11.815 20.235-24.511z"
          fill="#d69a8a"
        />
      </g>
      <g>
        <path
          d="m233.071 387.271c-26.869 0-51.749 8.501-72.109 22.953v101.776h144.225v-101.772c-20.361-14.454-45.244-22.957-72.116-22.957z"
          fill="#fbf1cf"
        />
      </g>
      <g>
        <path
          d="m233.075 483.319v-96.048c-.001 0-.002 0-.003 0-26.869 0-51.749 8.501-72.109 22.953v101.776h72.113c-7.92 0-14.341-6.421-14.341-14.341s6.419-14.34 14.34-14.34z"
          fill="#fae0bd"
        />
      </g>
      <g>
        <circle cx="233.075" cy="400.358" fill="#d69a8a" r="41.754" />
      </g>
      <g>
        <g>
          <path
            d="m233.075 449.611c-27.159 0-49.254-22.095-49.254-49.254 0-2.116.136-4.249.405-6.339.528-4.108 4.284-7.009 8.396-6.482 4.108.528 7.01 4.287 6.482 8.396-.188 1.458-.283 2.947-.283 4.426 0 18.888 15.366 34.254 34.254 34.254s34.254-15.366 34.254-34.254c0-1.453-.092-2.917-.273-4.35-.52-4.109 2.39-7.862 6.5-8.382 4.112-.514 7.863 2.39 8.382 6.5.26 2.055.392 4.152.392 6.232-.001 27.158-22.097 49.253-49.255 49.253z"
            fill="#eec076"
          />
        </g>
      </g>
      <g>
        <circle cx="382.582" cy="250.984" fill="#e1ac9a" r="37.17" />
      </g>
      <g>
        <circle cx="83.564" cy="250.984" fill="#d69a8a" r="37.17" />
      </g>
      <g>
        <circle cx="233.075" cy="250.981" fill="#e7beaf" r="149.376" />
      </g>
      <g>
        <path
          d="m135.207 250.981c0-73.715 53.398-134.952 123.622-147.157-8.367-1.454-16.971-2.219-25.755-2.219-82.498 0-149.376 66.878-149.376 149.376s66.878 149.376 149.376 149.376c8.783 0 17.387-.765 25.755-2.219-70.224-12.205-123.622-73.442-123.622-147.157z"
          fill="#e1ac9a"
        />
      </g>
      <g>
        <path
          d="m233.075 0c-91.034 0-164.831 73.797-164.831 164.83v28.689c0 11.379 9.225 20.604 20.604 20.604h288.454c11.379 0 20.604-9.225 20.604-20.604v-28.689c-.001-91.033-73.798-164.83-164.831-164.83z"
          fill="#ceeafb"
        />
      </g>
      <g>
        <path
          d="m333.57 145.997c-80.545 0-147.586-57.776-161.967-134.142-60.584 24.368-103.359 83.673-103.359 152.975v28.689c0 11.379 9.225 20.604 20.604 20.604h288.454c11.379 0 20.604-9.225 20.604-20.604v-28.689c0-10.488-.991-20.744-2.864-30.688-18.997 7.641-39.741 11.855-61.472 11.855z"
          fill="#a3defe"
        />
      </g>
      <g>
        <path
          d="m248.524 172.916h-30.905c-8.534 0-15.453-6.918-15.453-15.453v-51.509c0-8.534 6.918-15.453 15.453-15.453h30.905c8.534 0 15.453 6.918 15.453 15.453v51.509c0 8.534-6.919 15.453-15.453 15.453z"
          fill="#565e75"
        />
      </g>
      <g>
        <path
          d="m217.619 172.916h30.905c8.534 0 15.453-6.918 15.453-15.453v-26.844c-20.043-9.351-37.89-22.615-52.565-38.811-5.442 2.391-9.246 7.821-9.246 14.146v51.509c0 8.534 6.918 15.453 15.453 15.453z"
          fill="#404656"
        />
      </g>
      <g>
        <circle cx="233.075" cy="462.715" fill="#f2d98d" r="20.604" />
      </g>
      <g>
        <path
          d="m233.075 462.715c0-7.622 4.149-14.261 10.302-17.825-3.033-1.757-6.545-2.779-10.302-2.779-11.379 0-20.604 9.225-20.604 20.604s9.225 20.604 20.604 20.604c3.757 0 7.269-1.022 10.302-2.779-6.153-3.564-10.302-10.203-10.302-17.825z"
          fill="#eec076"
        />
      </g>
      <g>
        <g>
          <g>
            <ellipse
              cx="151.115"
              cy="290.112"
              fill="#fff"
              rx="30.241"
              ry="24.082"
            />
          </g>
          <g>
            <ellipse
              cx="315.031"
              cy="290.112"
              fill="#fff"
              rx="30.241"
              ry="24.082"
            />
          </g>
        </g>
        <g>
          <path
            d="m168.739 274.43c-4.142 0-7.5-3.358-7.5-7.5v-12.362c0-4.142 3.358-7.5 7.5-7.5s7.5 3.358 7.5 7.5v12.362c0 4.142-3.358 7.5-7.5 7.5z"
            fill="#565e75"
          />
        </g>
        <g>
          <path
            d="m297.406 274.43c-4.142 0-7.5-3.358-7.5-7.5v-12.362c0-4.142 3.358-7.5 7.5-7.5s7.5 3.358 7.5 7.5v12.362c0 4.142-3.358 7.5-7.5 7.5z"
            fill="#565e75"
          />
        </g>
        <g>
          <path
            d="m233.073 281.789c-8.668 0-16.911-3.754-22.615-10.3-2.721-3.123-2.396-7.86.727-10.582 3.123-2.721 7.86-2.396 10.582.727 2.854 3.275 6.976 5.154 11.307 5.154s8.453-1.879 11.307-5.154c2.721-3.124 7.459-3.448 10.582-.727s3.448 7.459.727 10.582c-5.706 6.546-13.949 10.3-22.617 10.3z"
            fill="#565e75"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const teenager2 = (className) => (
  <svg
    className={className}
    enable-background="new 0 0 512 512"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <g>
        <g>
          <path
            d="m256 37.087c-91.033 0-164.829 73.796-164.829 164.829v15.705h329.658v-15.705c0-91.033-73.796-164.829-164.829-164.829z"
            fill="#e1ac9a"
          />
        </g>
      </g>
      <g>
        <path
          d="m191.789 156.526c-5.272-13.574-4.723-33.77 12.702-43.206v-68.013c-65.804 21.631-113.32 83.566-113.32 156.609v15.705h100.618z"
          fill="#d69a8a"
        />
      </g>
      <g>
        <path
          d="m378.32 487.489c-11.388-57.149-61.825-100.219-122.322-100.219s-110.933 43.07-122.321 100.219c-2.53 12.696 7.29 24.511 20.235 24.511h78.881l23.207-17.677 23.204 17.677h78.881c12.945 0 22.765-11.815 20.235-24.511z"
          fill="#565e75"
        />
      </g>
      <g>
        <g>
          <path
            d="m276.609 388.973c-6.705-1.115-13.589-1.702-20.611-1.702-60.497 0-110.934 43.069-122.322 100.219-2.53 12.696 7.29 24.511 20.235 24.511h18.564c.001-61.87 45.05-113.209 104.134-123.028z"
            fill="#404656"
          />
        </g>
      </g>
      <g>
        <path
          d="m279.204 512h-46.411l-38.606-138.581h123.622z"
          fill="#fae0bd"
        />
      </g>
      <g>
        <path
          d="m222.004 438.116-15.631-59.923h99.242l-15.619 59.923z"
          fill="#f4baae"
        />
      </g>
      <g>
        <path
          d="m288.539 465.726c28.148-24.424 33.626-64.3 33.714-87.533h-16.638l-49.621 59.923 17.166 25.618c3.468 5.176 10.672 6.075 15.379 1.992z"
          fill="#fbf1cf"
        />
      </g>
      <g>
        <path
          d="m223.449 465.726c-28.148-24.424-33.626-64.3-33.714-87.533h16.637l49.621 59.923-17.166 25.618c-3.468 5.176-10.672 6.075-15.378 1.992z"
          fill="#fbf1cf"
        />
      </g>
      <g>
        <circle cx="405.509" cy="250.984" fill="#ffcabd" r="37.17" />
      </g>
      <g>
        <circle cx="106.491" cy="250.984" fill="#f4baae" r="37.17" />
      </g>
      <g>
        <path
          d="m173.653 157.758c-44.979 9.975-62.442 56.365-62.442 56.365-2.992 11.79-4.587 24.138-4.587 36.858 0 82.498 66.878 149.376 149.376 149.376s149.376-66.878 149.376-149.376c0-12.721-1.595-25.069-4.587-36.859-124.996-20.262-182.157-66.34-227.136-56.364z"
          fill="#ffdcce"
        />
      </g>
      <g>
        <path
          d="m158.131 250.981c0-35.834 12.623-68.716 33.658-94.455-6.327-.403-12.334-.055-18.136 1.232-44.979 9.975-62.442 56.365-62.442 56.365-2.992 11.79-4.587 24.138-4.587 36.858 0 82.498 66.878 149.376 149.376 149.376 8.783 0 17.387-.765 25.754-2.219-70.225-12.204-123.623-73.441-123.623-147.157z"
          fill="#ffcabd"
        />
      </g>
      <g>
        <path
          d="m389.924 113.32h-267.848c-11.379 0-20.604-9.225-20.604-20.604v-72.112h309.054v72.113c.001 11.378-9.223 20.603-20.602 20.603z"
          fill="#565e75"
        />
      </g>
      <g>
        <path
          d="m183.887 92.716v-72.112h-82.414v72.113c0 11.379 9.225 20.604 20.604 20.604h82.414c-11.379-.001-20.604-9.226-20.604-20.605z"
          fill="#404656"
        />
      </g>
      <g>
        <path
          d="m451.734 41.207h-391.468c-11.379 0-20.604-9.225-20.604-20.604 0-11.378 9.225-20.603 20.604-20.603h391.469c11.379 0 20.604 9.225 20.604 20.604-.001 11.379-9.226 20.603-20.605 20.603z"
          fill="#6e768f"
        />
      </g>
      <g>
        <path
          d="m163.284 20.604c0-11.379 9.224-20.604 20.603-20.604h-123.621c-11.379 0-20.604 9.225-20.604 20.604 0 11.379 9.225 20.604 20.604 20.604h123.622c-11.38-.001-20.604-9.225-20.604-20.604z"
          fill="#565e75"
        />
      </g>
      <g>
        <g>
          <g>
            <ellipse
              cx="170.425"
              cy="278.747"
              fill="#e68a97"
              rx="31.575"
              ry="25.145"
            />
          </g>
          <g>
            <ellipse
              cx="341.575"
              cy="278.586"
              fill="#e68a97"
              rx="31.576"
              ry="25.145"
            />
          </g>
        </g>
        <g>
          <path
            d="m188.79 259.616c-6.375 0-12.437-2.756-16.635-7.565-2.725-3.12-2.404-7.858.716-10.583 3.121-2.725 7.858-2.403 10.583.716 1.349 1.545 3.294 2.431 5.335 2.431h.006c2.043-.002 3.989-.892 5.337-2.441 2.72-3.125 7.457-3.455 10.581-.736 3.125 2.719 3.455 7.456.736 10.581-4.194 4.821-10.259 7.59-16.64 7.597-.005 0-.013 0-.019 0z"
            fill="#565e75"
          />
        </g>
        <g>
          <path
            d="m323.132 259.489c-6.373 0-12.434-2.756-16.632-7.565-2.724-3.121-2.403-7.858.717-10.583 3.121-2.723 7.858-2.402 10.583.717 1.349 1.545 3.292 2.431 5.333 2.431h.007c2.044-.002 3.99-.892 5.337-2.441 2.719-3.125 7.458-3.454 10.581-.736 3.125 2.719 3.455 7.456.736 10.581-4.194 4.822-10.26 7.59-16.641 7.596-.006 0-.014 0-.021 0z"
            fill="#565e75"
          />
        </g>
        <g>
          <path
            d="m256 271.487c-8.668 0-16.911-3.754-22.615-10.3-2.721-3.123-2.396-7.86.727-10.582 3.123-2.721 7.86-2.396 10.582.727 2.854 3.275 6.976 5.154 11.307 5.154s8.452-1.879 11.307-5.154c2.721-3.124 7.459-3.448 10.582-.727s3.448 7.459.727 10.582c-5.706 6.546-13.949 10.3-22.617 10.3z"
            fill="#565e75"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const teenager3 = (className) => (
  <svg
    id="Capa_1"
    enable-background="new 0 0 512 512"
    className={className}
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <g>
        <path
          d="m284.655 0c-24.24 0-28.656 25.949-28.656 25.949s-4.414-25.949-28.654-25.949-146.778 43.108-146.778 201.382v36.372h350.865v-36.372c.001-158.274-122.537-201.382-146.777-201.382z"
          fill="#f7ef87"
        />
      </g>
      <g>
        <path
          d="m256 125.078c-84.642 22.314-128.775-80.015-72.901-110.528-44.141 23.202-102.532 77.573-102.532 186.832v36.372h175.433z"
          fill="#f2d98d"
        />
      </g>
      <g>
        <path
          d="m378.531 487.447c-11.408-57.248-61.932-100.391-122.533-100.391s-111.125 43.144-122.533 100.391c-2.534 12.718 7.302 24.553 20.27 24.553h30.027l72.235-25.876 72.24 25.876h30.024c12.967 0 22.804-11.835 20.27-24.553z"
          fill="#fae0bd"
        />
      </g>
      <g>
        <path
          d="m349.095 428.67c-22.877-25.541-56.11-41.614-93.097-41.614s-70.218 16.072-93.095 41.612l.002.002c13.355 13.355 20.858 31.469 20.858 50.356v32.974h144.474v-32.974c0-18.887 7.503-37.001 20.858-50.356z"
          fill="#fbf1cf"
        />
      </g>
      <g>
        <circle cx="256" cy="400.165" fill="#f4baae" r="41.826" />
      </g>
      <g>
        <circle cx="405.767" cy="250.534" fill="#ffcabd" r="37.234" />
      </g>
      <g>
        <circle cx="106.233" cy="250.534" fill="#f4baae" r="37.234" />
      </g>
      <g>
        <path
          d="m401.038 213.61c-88.162 0-145.038-88.532-145.038-88.532s-56.876 88.532-145.037 88.532h-.001c-2.997 11.81-4.595 24.179-4.595 36.922 0 82.64 66.993 149.634 149.634 149.634s149.634-66.993 149.634-149.634c-.001-12.743-1.599-25.112-4.597-36.922z"
          fill="#ffdcce"
        />
      </g>
      <g>
        <path
          d="m157.966 250.532c0-17.025 2.849-33.382 8.087-48.629-16.539 7.1-34.998 11.707-55.089 11.707-2.997 11.81-4.595 24.179-4.595 36.922 0 82.64 66.993 149.634 149.634 149.634 8.798 0 17.417-.766 25.799-2.223-70.346-12.227-123.836-73.57-123.836-147.411z"
          fill="#ffcabd"
        />
      </g>
      <g>
        <circle cx="320.512" cy="263.815" fill="#fff" r="41.278" />
      </g>
      <g>
        <circle cx="191.488" cy="263.815" fill="#fff" r="41.278" />
      </g>
      <g>
        <g>
          <path
            d="m255.998 330.393c-8.68 0-16.933-3.759-22.645-10.313-2.722-3.123-2.396-7.86.727-10.582 3.122-2.721 7.86-2.396 10.582.727 2.862 3.284 6.994 5.167 11.336 5.167s8.475-1.884 11.338-5.168c2.721-3.123 7.459-3.447 10.581-.726 3.123 2.722 3.447 7.459.726 10.582-5.712 6.554-13.966 10.313-22.645 10.313z"
            fill="#565e75"
          />
        </g>
        <g>
          <path
            d="m191.556 265.59c-4.143 0-7.5-3.358-7.5-7.5v-12.383c0-4.142 3.357-7.5 7.5-7.5s7.5 3.358 7.5 7.5v12.383c0 4.142-3.358 7.5-7.5 7.5z"
            fill="#565e75"
          />
        </g>
        <g>
          <path
            d="m320.444 265.59c-4.143 0-7.5-3.358-7.5-7.5v-12.383c0-4.142 3.357-7.5 7.5-7.5s7.5 3.358 7.5 7.5v12.383c0 4.142-3.357 7.5-7.5 7.5z"
            fill="#565e75"
          />
        </g>
        <g>
          <path
            d="m283.438 252.417c-1.119 0-2.255-.251-3.325-.782-7.576-3.756-15.688-5.661-24.109-5.661-8.388 0-16.469 1.89-24.02 5.617-3.713 1.833-8.211.308-10.045-3.406-1.833-3.714-.309-8.212 3.406-10.045 9.633-4.754 19.948-7.166 30.658-7.166 10.754 0 21.106 2.43 30.771 7.221 3.712 1.84 5.229 6.34 3.389 10.051-1.309 2.642-3.966 4.171-6.725 4.171z"
            fill="#fff"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const leftArrow = (className) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M15 19l-7-7 7-7"
    />
  </svg>
);

export const rightArrow = (className) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M9 5l7 7-7 7"
    />
  </svg>
);
export const close = (className) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path d="M16.192 6.344L11.949 10.586 7.707 6.344 6.293 7.758 10.535 12 6.293 16.242 7.707 17.656 11.949 13.414 16.192 17.656 17.606 16.242 13.364 12 17.606 7.758z" />
  </svg>
);
export const print = (className) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    strokeWidth="2"
    stroke="currentColor"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="0" y="0" width="24" height="24" stroke="none"></rect>
    <path d="M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2" />
    <path d="M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4" />
    <rect x="7" y="13" width="10" height="8" rx="2" />
  </svg>
);
export const reload = (className) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    strokeWidth="2"
    stroke="currentColor"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="0" y="0" width="24" height="24" stroke="none"></rect>
    <path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -5v5h5" />
    <path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 5v-5h-5" />
  </svg>
);
export const camera = (className) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    strokeWidth="2"
    stroke="currentColor"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="0" y="0" width="24" height="24" stroke="none"></rect>
    <path d="M5 7h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2" />
    <circle cx="12" cy="13" r="3" />
  </svg>
);
export const downArrow = (className) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
  </svg>
);

export const DownArrowIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
  </svg>
);

export const LeftArrowIcon = ({ className }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M15 19l-7-7 7-7"
    />
  </svg>
);

export const RightArrowIcon = ({ className }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M9 5l7 7-7 7"
    />
  </svg>
);

export const CloseIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M16.192 6.344L11.949 10.586 7.707 6.344 6.293 7.758 10.535 12 6.293 16.242 7.707 17.656 11.949 13.414 16.192 17.656 17.606 16.242 13.364 12 17.606 7.758z" />
  </svg>
);

export const DeleteIcon = ({ className }) => (
  <svg
    className={className ?? defaultClassName}
    stroke="currentColor"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 54"
  >
    <path d="M18.6667 43C19.3739 43 20.0522 42.7191 20.5523 42.219C21.0524 41.7189 21.3333 41.0406 21.3333 40.3334V24.3334C21.3333 23.6261 21.0524 22.9479 20.5523 22.4478C20.0522 21.9477 19.3739 21.6667 18.6667 21.6667C17.9594 21.6667 17.2811 21.9477 16.781 22.4478C16.281 22.9479 16 23.6261 16 24.3334V40.3334C16 41.0406 16.281 41.7189 16.781 42.219C17.2811 42.7191 17.9594 43 18.6667 43ZM45.3333 11H34.6667V8.33337C34.6667 6.21164 33.8238 4.17681 32.3235 2.67652C30.8232 1.17623 28.7884 0.333374 26.6667 0.333374H21.3333C19.2116 0.333374 17.1768 1.17623 15.6765 2.67652C14.1762 4.17681 13.3333 6.21164 13.3333 8.33337V11H2.66667C1.95942 11 1.28115 11.281 0.781048 11.7811C0.280951 12.2812 0 12.9595 0 13.6667C0 14.374 0.280951 15.0522 0.781048 15.5523C1.28115 16.0524 1.95942 16.3334 2.66667 16.3334H5.33333V45.6667C5.33333 47.7884 6.17619 49.8233 7.67648 51.3236C9.17677 52.8239 11.2116 53.6667 13.3333 53.6667H34.6667C36.7884 53.6667 38.8232 52.8239 40.3235 51.3236C41.8238 49.8233 42.6667 47.7884 42.6667 45.6667V16.3334H45.3333C46.0406 16.3334 46.7189 16.0524 47.219 15.5523C47.7191 15.0522 48 14.374 48 13.6667C48 12.9595 47.7191 12.2812 47.219 11.7811C46.7189 11.281 46.0406 11 45.3333 11ZM18.6667 8.33337C18.6667 7.62613 18.9476 6.94785 19.4477 6.44776C19.9478 5.94766 20.6261 5.66671 21.3333 5.66671H26.6667C27.3739 5.66671 28.0522 5.94766 28.5523 6.44776C29.0524 6.94785 29.3333 7.62613 29.3333 8.33337V11H18.6667V8.33337ZM37.3333 45.6667C37.3333 46.374 37.0524 47.0522 36.5523 47.5523C36.0522 48.0524 35.3739 48.3334 34.6667 48.3334H13.3333C12.6261 48.3334 11.9478 48.0524 11.4477 47.5523C10.9476 47.0522 10.6667 46.374 10.6667 45.6667V16.3334H37.3333V45.6667ZM29.3333 43C30.0406 43 30.7189 42.7191 31.219 42.219C31.719 41.7189 32 41.0406 32 40.3334V24.3334C32 23.6261 31.719 22.9479 31.219 22.4478C30.7189 21.9477 30.0406 21.6667 29.3333 21.6667C28.6261 21.6667 27.9478 21.9477 27.4477 22.4478C26.9476 22.9479 26.6667 23.6261 26.6667 24.3334V40.3334C26.6667 41.0406 26.9476 41.7189 27.4477 42.219C27.9478 42.7191 28.6261 43 29.3333 43Z" />
  </svg>
);

export const CrossCicleIcon = ({ className }) => (
  <svg
    className={className ?? "w-5 h-5 text-gray-700"}
    fill="currentColor"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
  >
    <path d="M14.5853 16.0004L11.7573 13.1724C11.5751 12.9838 11.4743 12.7312 11.4766 12.469C11.4789 12.2068 11.584 11.956 11.7695 11.7706C11.9549 11.5852 12.2057 11.48 12.4679 11.4777C12.7301 11.4755 12.9827 11.5763 13.1713 11.7584L15.9993 14.5864L18.8273 11.7584C18.9195 11.6629 19.0299 11.5867 19.1519 11.5343C19.2739 11.4819 19.4051 11.4543 19.5379 11.4532C19.6707 11.452 19.8023 11.4773 19.9252 11.5276C20.0481 11.5779 20.1598 11.6521 20.2537 11.746C20.3476 11.8399 20.4218 11.9516 20.4721 12.0745C20.5224 12.1974 20.5477 12.329 20.5465 12.4618C20.5454 12.5946 20.5178 12.7258 20.4654 12.8478C20.413 12.9698 20.3368 13.0802 20.2413 13.1724L17.4133 16.0004L20.2413 18.8284C20.3368 18.9207 20.413 19.031 20.4654 19.153C20.5178 19.275 20.5454 19.4062 20.5465 19.539C20.5477 19.6718 20.5224 19.8035 20.4721 19.9264C20.4218 20.0493 20.3476 20.1609 20.2537 20.2548C20.1598 20.3487 20.0481 20.423 19.9252 20.4732C19.8023 20.5235 19.6707 20.5488 19.5379 20.5477C19.4051 20.5465 19.2739 20.5189 19.1519 20.4665C19.0299 20.4141 18.9195 20.3379 18.8273 20.2424L15.9993 17.4144L13.1713 20.2424C12.9827 20.4246 12.7301 20.5254 12.4679 20.5231C12.2057 20.5208 11.9549 20.4156 11.7695 20.2302C11.584 20.0448 11.4789 19.794 11.4766 19.5318C11.4743 19.2696 11.5751 19.017 11.7573 18.8284L14.5853 16.0004Z" />
    <path d="M16 28C17.5759 28 19.1363 27.6896 20.5922 27.0866C22.0481 26.4835 23.371 25.5996 24.4853 24.4853C25.5996 23.371 26.4835 22.0481 27.0866 20.5922C27.6896 19.1363 28 17.5759 28 16C28 14.4241 27.6896 12.8637 27.0866 11.4078C26.4835 9.95189 25.5996 8.62902 24.4853 7.51472C23.371 6.40042 22.0481 5.5165 20.5922 4.91345C19.1363 4.31039 17.5759 4 16 4C12.8174 4 9.76515 5.26428 7.51472 7.51472C5.26428 9.76515 4 12.8174 4 16C4 19.1826 5.26428 22.2348 7.51472 24.4853C9.76515 26.7357 12.8174 28 16 28ZM16 30C12.287 30 8.72601 28.525 6.1005 25.8995C3.475 23.274 2 19.713 2 16C2 12.287 3.475 8.72601 6.1005 6.1005C8.72601 3.475 12.287 2 16 2C19.713 2 23.274 3.475 25.8995 6.1005C28.525 8.72601 30 12.287 30 16C30 19.713 28.525 23.274 25.8995 25.8995C23.274 28.525 19.713 30 16 30Z" />
  </svg>
);

export const Arrow = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 492.004 492.004"
    stroke="currentColor"
    fill="currentColor"
    className={"h-5 w-5 opacity-60 transform  " + className}
  >
    <g>
      <g>
        <path
          d="M382.678,226.804L163.73,7.86C158.666,2.792,151.906,0,144.698,0s-13.968,2.792-19.032,7.86l-16.124,16.12
			c-10.492,10.504-10.492,27.576,0,38.064L293.398,245.9l-184.06,184.06c-5.064,5.068-7.86,11.824-7.86,19.028
			c0,7.212,2.796,13.968,7.86,19.04l16.124,16.116c5.068,5.068,11.824,7.86,19.032,7.86s13.968-2.792,19.032-7.86L382.678,265
			c5.076-5.084,7.864-11.872,7.848-19.088C390.542,238.668,387.754,231.884,382.678,226.804z"
        />
      </g>
    </g>
  </svg>
);

export const UploadIcon = ({ className }) => (
  <svg
    className={className ?? "w-5 h-5 text-gray-700"}
    fill="currentColor"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 184.69 184.69"
  >
    <g>
      <g>
        <g>
          <path
            d="M149.968,50.186c-8.017-14.308-23.796-22.515-40.717-19.813
				C102.609,16.43,88.713,7.576,73.087,7.576c-22.117,0-40.112,17.994-40.112,40.115c0,0.913,0.036,1.854,0.118,2.834
				C14.004,54.875,0,72.11,0,91.959c0,23.456,19.082,42.535,42.538,42.535h33.623v-7.025H42.538
				c-19.583,0-35.509-15.929-35.509-35.509c0-17.526,13.084-32.621,30.442-35.105c0.931-0.132,1.768-0.633,2.326-1.392
				c0.555-0.755,0.795-1.704,0.644-2.63c-0.297-1.904-0.447-3.582-0.447-5.139c0-18.249,14.852-33.094,33.094-33.094
				c13.703,0,25.789,8.26,30.803,21.04c0.63,1.621,2.351,2.534,4.058,2.14c15.425-3.568,29.919,3.883,36.604,17.168
				c0.508,1.027,1.503,1.736,2.641,1.897c17.368,2.473,30.481,17.569,30.481,35.112c0,19.58-15.937,35.509-35.52,35.509H97.391
				v7.025h44.761c23.459,0,42.538-19.079,42.538-42.535C184.69,71.545,169.884,53.901,149.968,50.186z"
          />
        </g>
        <g>
          <path
            d="M108.586,90.201c1.406-1.403,1.406-3.672,0-5.075L88.541,65.078
				c-0.701-0.698-1.614-1.045-2.534-1.045l-0.064,0.011c-0.018,0-0.036-0.011-0.054-0.011c-0.931,0-1.85,0.361-2.534,1.045
				L63.31,85.127c-1.403,1.403-1.403,3.672,0,5.075c1.403,1.406,3.672,1.406,5.075,0L82.296,76.29v97.227
				c0,1.99,1.603,3.597,3.593,3.597c1.979,0,3.59-1.607,3.59-3.597V76.165l14.033,14.036
				C104.91,91.608,107.183,91.608,108.586,90.201z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const LoadingIcon = ({ className, style }) => (
  <svg
    className={"animate-spin h-8 w-8 " + className}
    style={style}
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      className="opacity-60"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="2"
    ></circle>
    <path
      className="opacity-100"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    ></path>
  </svg>
);
export const EmailIcon2 = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    fill="currentColor"
    className={`${className ?? defaultClassName}`}
    viewBox="0 0 24 24"
  >
    <path d="M12 12.713l-11.985-9.713h23.971l-11.986 9.713zm-5.425-1.822l-6.575-5.329v12.501l6.575-7.172zm10.85 0l6.575 7.172v-12.501l-6.575 5.329zm-1.557 1.261l-3.868 3.135-3.868-3.135-8.11 8.848h23.956l-8.11-8.848z" />
  </svg>
);

export const ChatIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    fill="currentColor"
    className={`${className ?? defaultClassName}`}
    viewBox="0 0 480.9 413"
  >
    <g>
      <path
        d="M398.3,0H82.5C37,0,0,37,0,82.5V226c0,45.5,37,82.5,82.5,82.5h241.3L335.7,413l71.7-105c41.2-4.5,73.4-39.6,73.4-82V82.5
		C480.9,37,443.9,0,398.3,0z M447.6,226c0,27.2-22.1,49.3-49.3,49.3h-8.8l-30.9,45.2l-5.2-45.2h-271c-27.1,0-49.2-22.1-49.2-49.3
		V82.5c0-27.2,22.1-49.3,49.2-49.3h315.8c27.2,0,49.3,22.1,49.3,49.3V226z"
      />
      <path
        d="M126.4,122.1c-20.8,0-37.7,16.9-37.7,37.7c0,20.8,16.9,37.7,37.7,37.7c20.8,0,37.7-16.9,37.7-37.7
		C164.1,139,147.2,122.1,126.4,122.1z"
      />
      <path
        d="M236.4,122.1c-20.8,0-37.7,16.9-37.7,37.7c0,20.8,16.9,37.7,37.7,37.7s37.7-16.9,37.7-37.7
		C274.1,139,257.2,122.1,236.4,122.1z"
      />
      <path
        d="M346.3,122.1c-20.8,0-37.7,16.9-37.7,37.7c0,20.8,16.9,37.7,37.7,37.7c20.8,0,37.7-16.9,37.7-37.7
		C384,139,367.1,122.1,346.3,122.1z"
      />
    </g>
  </svg>
);

export const ChatIcon2 = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    fill="currentColor"
    className={`${className ?? defaultClassName}`}
    viewBox="0 0 1000 1000"
  >
    <g>
      <path d="M500,54.5c-270.6,0-490,179.5-490,400.9c0,108.6,53,207,138.7,279.1L99.1,945.5l263.4-105.3c43.7,10.4,89.7,16.2,137.5,16.2c270.6,0,490-179.5,490-400.9C990,234.1,770.6,54.5,500,54.5 M500,811.8c-42.5,0-85.2-5.1-127.1-15.1c-3.4-0.8-6.9-1.2-10.4-1.2c-5.6,0-11.3,1.1-16.5,3.2l-183.9,73.6l30-127.5c3.9-16.4-1.8-33.5-14.7-44.2C98.2,633.8,54.5,546.8,54.5,455.5C54.5,259,254.4,99.1,500,99.1c245.6,0,445.5,159.9,445.5,356.4C945.5,652,745.6,811.8,500,811.8" />
    </g>
  </svg>
);

export const ClockIcon2 = ({ className, style }) => (
  <svg
    className={className ?? defaultClassName}
    style={style}
    stroke="currentColor"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
  >
    <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z" />
  </svg>
);

export const WarningIcon = ({ className }) => (
  <svg
    className={className ?? defaultClassName}
    stroke="currentColor"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 490 490"
  >
    <g id="bold_copy_37_">
      <path
        d="M245,0C109.684,0,0,109.684,0,245s109.684,245,245,245s245-109.684,245-245S380.316,0,245,0z M245,459.375
		c-118.213,0-214.375-96.163-214.375-214.375S126.787,30.625,245,30.625S459.375,126.787,459.375,245S363.212,459.375,245,459.375z"
      />
      <polygon points="266.836,286.987 275.196,114.874 214.788,114.874 223.532,286.987 	" />
      <path
        d="M245.184,305.974c-20.136,0-34.178,14.424-34.178,34.576c0,19.738,13.674,34.576,34.178,34.576
		c20.503,0,33.825-14.823,33.825-34.576C278.611,320.399,265.304,305.974,245.184,305.974z"
      />
    </g>
  </svg>
);

export const WorkerIcon = ({ className, style }) => (
  <svg
    className={className ?? defaultClassName}
    style={style}
    stroke="currentColor"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 54 56"
  >
    <path d="M48.3334 21.7867V21.3334C48.3496 16.7972 46.9104 12.3755 44.2272 8.71794C41.544 5.0604 37.7585 2.35993 33.4268 1.01337H33.2668C31.0295 0.331328 28.6985 0.00732676 26.3601 0.0533723C20.7916 0.358952 15.5497 2.77804 11.7041 6.81691C7.85848 10.8558 5.69914 16.21 5.66676 21.7867C4.10412 22.3364 2.75065 23.3576 1.7932 24.7094C0.835752 26.0612 0.321533 27.6769 0.321533 29.3334C0.321533 30.9899 0.835752 32.6055 1.7932 33.9573C2.75065 35.3091 4.10412 36.3303 5.66676 36.88C6.216 42.1461 8.70387 47.0198 12.6467 50.5536C16.5895 54.0873 21.7055 56.0286 27.0001 56H27.6134C32.7333 55.7522 37.5998 53.6983 41.3491 50.2029C45.0983 46.7075 47.4878 41.9967 48.0934 36.9067C49.6744 36.3881 51.0544 35.3894 52.0412 34.0497C53.028 32.71 53.5725 31.0959 53.5989 29.4322C53.6253 27.7685 53.1323 26.1379 52.1886 24.7676C51.2448 23.3972 49.8972 22.3552 48.3334 21.7867ZM27.4801 50.6667C23.6198 50.7784 19.8494 49.4901 16.8646 47.0395C13.8799 44.5889 11.8821 41.1415 11.2401 37.3334H42.6268C41.9759 40.9384 40.1254 44.2175 37.3756 46.6381C34.6259 49.0586 31.1386 50.4784 27.4801 50.6667ZM45.6668 32H8.33343C7.62618 32 6.94791 31.7191 6.44781 31.219C5.94771 30.7189 5.66676 30.0406 5.66676 29.3334C5.66676 28.6261 5.94771 27.9479 6.44781 27.4478C6.94791 26.9477 7.62618 26.6667 8.33343 26.6667H13.6668C14.374 26.6667 15.0523 26.3858 15.5524 25.8857C16.0525 25.3856 16.3334 24.7073 16.3334 24C16.3334 23.2928 16.0525 22.6145 15.5524 22.1144C15.0523 21.6143 14.374 21.3334 13.6668 21.3334H11.0001C11.1195 18.567 11.9101 15.8712 13.3039 13.4786C14.6976 11.086 16.6526 9.06847 19.0001 7.60004V16C19.0001 16.7073 19.281 17.3856 19.7811 17.8857C20.2812 18.3858 20.9595 18.6667 21.6668 18.6667C22.374 18.6667 23.0523 18.3858 23.5524 17.8857C24.0525 17.3856 24.3334 16.7073 24.3334 16V5.57337C25.0572 5.45244 25.7873 5.37232 26.5201 5.33337H27.0001C27.8938 5.34596 28.7852 5.42619 29.6668 5.57337V16C29.6668 16.7073 29.9477 17.3856 30.4478 17.8857C30.9479 18.3858 31.6262 18.6667 32.3334 18.6667C33.0407 18.6667 33.7189 18.3858 34.219 17.8857C34.7191 17.3856 35.0001 16.7073 35.0001 16V7.52004C36.1313 8.17504 37.1866 8.9531 38.1468 9.84004C39.6842 11.3331 40.9061 13.1198 41.7398 15.0942C42.5735 17.0685 43.0021 19.1902 43.0001 21.3334H40.3334C39.6262 21.3334 38.9479 21.6143 38.4478 22.1144C37.9477 22.6145 37.6668 23.2928 37.6668 24C37.6668 24.7073 37.9477 25.3856 38.4478 25.8857C38.9479 26.3858 39.6262 26.6667 40.3334 26.6667H45.6668C46.374 26.6667 47.0523 26.9477 47.5524 27.4478C48.0525 27.9479 48.3334 28.6261 48.3334 29.3334C48.3334 30.0406 48.0525 30.7189 47.5524 31.219C47.0523 31.7191 46.374 32 45.6668 32Z" />
  </svg>
);

export const TickIcon = ({ className }) => (
  <svg
    className={className ?? "h-5"}
    stroke="currentColor"
    fill="currentColor"
    viewBox="0 0 17 17"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.49935 16.8337C3.89685 16.8337 0.166016 13.1028 0.166016 8.50033C0.166016 3.89783 3.89685 0.166992 8.49935 0.166992C13.1018 0.166992 16.8327 3.89783 16.8327 8.50033C16.8327 13.1028 13.1018 16.8337 8.49935 16.8337ZM8.49935 15.167C10.2675 15.167 11.9632 14.4646 13.2134 13.2144C14.4636 11.9641 15.166 10.2684 15.166 8.50033C15.166 6.73222 14.4636 5.03652 13.2134 3.78628C11.9632 2.53604 10.2675 1.83366 8.49935 1.83366C6.73124 1.83366 5.03555 2.53604 3.7853 3.78628C2.53506 5.03652 1.83268 6.73222 1.83268 8.50033C1.83268 10.2684 2.53506 11.9641 3.7853 13.2144C5.03555 14.4646 6.73124 15.167 8.49935 15.167ZM7.66852 11.8337L4.13268 8.29782L5.31102 7.11949L7.66852 9.47699L12.3818 4.76283L13.561 5.94116L7.66852 11.8337Z" />
  </svg>
);

export const MessageIcon = ({ className }) => (
  <svg
    className={className ?? "h-5"}
    stroke="currentColor"
    fill="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
      fill="black"
    />
    <path
      d="M16 13C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11C15.4477 11 15 11.4477 15 12C15 12.5523 15.4477 13 16 13Z"
      fill="black"
    />
    <path
      d="M8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13Z"
      fill="black"
    />
    <path
      d="M19.0701 4.93002C17.4293 3.27852 15.2638 2.25124 12.9467 2.02526C10.6297 1.79929 8.30647 2.3888 6.3775 3.69215C4.44854 4.99551 3.03475 6.93103 2.37988 9.16503C1.72501 11.399 1.87009 13.7915 2.79012 15.93C2.88601 16.1288 2.91747 16.3525 2.88012 16.57L2.00012 20.8C1.96621 20.9622 1.97314 21.1303 2.02027 21.2891C2.06739 21.4479 2.15325 21.5926 2.27012 21.71C2.36592 21.8051 2.47999 21.8799 2.60545 21.9297C2.73091 21.9795 2.86516 22.0035 3.00012 22H3.20012L7.48012 21.14C7.69765 21.1139 7.91824 21.1449 8.12012 21.23C10.2586 22.15 12.6511 22.2951 14.8851 21.6403C17.1191 20.9854 19.0546 19.5716 20.358 17.6426C21.6613 15.7137 22.2508 13.3904 22.0249 11.0734C21.7989 8.75638 20.7716 6.59081 19.1201 4.95002L19.0701 4.93002ZM19.9001 13.29C19.7046 14.484 19.2408 15.6181 18.5437 16.6069C17.8465 17.5958 16.9342 18.4136 15.8753 18.9989C14.8164 19.5842 13.6385 19.9216 12.4303 19.9859C11.2222 20.0502 10.0151 19.8396 8.90012 19.37C8.50466 19.2018 8.07985 19.1135 7.65012 19.11C7.4624 19.1113 7.2751 19.1281 7.09012 19.16L4.27012 19.73L4.84012 16.91C4.95364 16.2993 4.88046 15.6685 4.63012 15.1C4.16051 13.985 3.94992 12.778 4.01421 11.5698C4.0785 10.3616 4.41598 9.18377 5.00126 8.12487C5.58654 7.06598 6.40438 6.15362 7.39321 5.45647C8.38205 4.75932 9.51614 4.29554 10.7101 4.10002C11.9634 3.89434 13.2476 3.99 14.4566 4.37908C15.6656 4.76817 16.7645 5.43951 17.6626 6.33756C18.5606 7.23561 19.232 8.33457 19.6211 9.54354C20.0101 10.7525 20.1058 12.0367 19.9001 13.29V13.29Z"
      fill="black"
    />
  </svg>
);

export const BellIcon = ({ className }) => (
  <svg
    className={className ?? "h-5"}
    stroke="currentColor"
    fill="none"
    viewBox="0 0 20 22"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 17V17.75C13 18.5456 12.6839 19.3087 12.1213 19.8713C11.5587 20.4339 10.7956 20.75 9.99999 20.75C9.20434 20.75 8.44128 20.4339 7.87867 19.8713C7.31606 19.3087 6.99999 18.5456 6.99999 17.75V17M18.0475 15.4733C16.8437 14 15.9939 13.25 15.9939 9.18828C15.9939 5.46875 14.0945 4.14359 12.5312 3.5C12.3236 3.41469 12.1281 3.21875 12.0648 3.00547C11.7906 2.07219 11.0219 1.25 9.99999 1.25C8.97811 1.25 8.20889 2.07266 7.93749 3.00641C7.87421 3.22203 7.67874 3.41469 7.47108 3.5C5.90593 4.14453 4.00842 5.465 4.00842 9.18828C4.00608 13.25 3.15624 14 1.95249 15.4733C1.45374 16.0836 1.89061 17 2.76296 17H17.2417C18.1094 17 18.5434 16.0808 18.0475 15.4733Z"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CartIcon = ({ className, style }) => (
  <svg
    className={className ?? "h-5"}
    style={style}
    stroke="none"
    fill="currentColor"
    viewBox="0 0 21 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.54339 16.9518C6.25739 16.9518 6.83839 17.5318 6.83839 18.2458C6.83839 18.9598 6.25739 19.5408 5.54339 19.5408C4.82939 19.5408 4.24939 18.9598 4.24939 18.2458C4.24939 17.5318 4.82939 16.9518 5.54339 16.9518ZM16.8237 16.9518C17.5387 16.9518 18.1197 17.5318 18.1197 18.2458C18.1197 18.9598 17.5387 19.5408 16.8237 19.5408C16.1097 19.5408 15.5297 18.9598 15.5297 18.2458C15.5297 17.5318 16.1097 16.9518 16.8237 16.9518ZM1.26759 0.00939549L3.34759 0.369395C3.68259 0.428395 3.93759 0.706395 3.96659 1.0464L4.20159 3.8474L5.07544 3.84777C5.21804 3.84783 5.35912 3.8479 5.49871 3.84796L7.10302 3.84872C7.2309 3.84879 7.35735 3.84885 7.48238 3.84892L9.25378 3.84989C9.36506 3.84995 9.47501 3.85002 9.58364 3.85008L10.825 3.85088C10.9233 3.85094 11.0204 3.85101 11.1163 3.85108L12.2081 3.85188C12.2943 3.85195 12.3793 3.85202 12.4632 3.85208L13.4151 3.8529C13.49 3.85297 13.5638 3.85304 13.6365 3.85311L14.2621 3.85373C14.3285 3.8538 14.3939 3.85387 14.4582 3.85394L15.1828 3.85478C15.2393 3.85485 15.2949 3.85492 15.3495 3.85499L15.9613 3.85584C16.0087 3.85592 16.0552 3.85599 16.101 3.85606L16.4898 3.85671C16.5305 3.85678 16.5704 3.85685 16.6096 3.85693L17.0427 3.8578C17.0758 3.85788 17.1082 3.85795 17.1399 3.85803L17.4065 3.85869C17.4341 3.85877 17.461 3.85884 17.4873 3.85892L17.773 3.85982C17.7945 3.85989 17.8153 3.85997 17.8356 3.86004L18.0034 3.86073C18.0204 3.86081 18.037 3.86088 18.053 3.86096L18.2227 3.86188C18.2351 3.86196 18.247 3.86204 18.2584 3.86212L18.351 3.86282C18.3601 3.8629 18.3688 3.86297 18.3772 3.86305L18.4438 3.86376C18.4503 3.86384 18.4564 3.86392 18.4623 3.864L18.5076 3.86472C18.5118 3.8648 18.5159 3.86488 18.5197 3.86496L18.5483 3.86568C18.551 3.86577 18.5534 3.86585 18.5557 3.86593L18.5764 3.86691C18.5777 3.86699 18.5789 3.86707 18.58 3.86715C18.5897 3.86806 18.5912 3.86823 18.5926 3.8684C19.1496 3.9494 19.6396 4.2404 19.9736 4.6884C20.3076 5.1354 20.4476 5.6864 20.3676 6.2384L19.4186 12.7964C19.2396 14.0444 18.1556 14.9854 16.8956 14.9854H5.97459C4.65759 14.9854 3.54259 13.9574 3.43559 12.6424L2.51959 1.7484L1.01259 1.4884C0.603593 1.4164 0.330593 1.0294 0.400593 0.620395C0.472593 0.211395 0.867593 -0.0546045 1.26759 0.00939549ZM4.87483 5.34774L4.32759 5.3474L4.93059 12.5194C4.97459 13.0714 5.42559 13.4854 5.97659 13.4854H16.8936C17.4146 13.4854 17.8596 13.0974 17.9336 12.5824L18.8836 6.0234C18.9056 5.8674 18.8666 5.7114 18.7716 5.5854C18.6776 5.4584 18.5396 5.3764 18.3836 5.3544C18.3764 5.35467 18.3591 5.35492 18.3323 5.35515L18.2235 5.35577C18.2008 5.35587 18.1757 5.35595 18.1485 5.35604L17.582 5.3569C17.5342 5.35693 17.4845 5.35696 17.433 5.35699L16.101 5.35693C16.0267 5.3569 15.9509 5.35687 15.8739 5.35684L14.3538 5.35592C14.2627 5.35585 14.1706 5.35578 14.0776 5.35571L13.2175 5.35502C13.1195 5.35494 13.0208 5.35486 12.9214 5.35477L12.0103 5.35397C11.9074 5.35388 11.8041 5.35378 11.7002 5.35369L11.0727 5.35311C10.9674 5.35301 10.8617 5.35292 10.7559 5.35282L9.79819 5.35192C9.69141 5.35182 9.58456 5.35172 9.47771 5.35162L8.83706 5.35103C8.73044 5.35093 8.62395 5.35083 8.51764 5.35073L7.88243 5.35016C7.77709 5.35006 7.67205 5.34997 7.56738 5.34988L6.63687 5.34907C6.53495 5.34899 6.43357 5.34891 6.33281 5.34882L5.15688 5.34793C5.06199 5.34786 4.96795 5.3478 4.87483 5.34774ZM15.2875 7.5437C15.7015 7.5437 16.0375 7.8797 16.0375 8.2937C16.0375 8.7077 15.7015 9.0437 15.2875 9.0437H12.5155C12.1005 9.0437 11.7655 8.7077 11.7655 8.2937C11.7655 7.8797 12.1005 7.5437 12.5155 7.5437H15.2875Z"
    />
  </svg>
);

export const OpenEyeIcon = ({ className, style }) => (
  <svg
    className={className ?? "h-5"}
    style={style}
    stroke="none"
    fill="currentColor"
    viewBox="0 0 18 14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.00237 0.333755C12.449 0.336255 15.544 2.75209 17.2824 6.79709C17.3507 6.95459 17.3507 7.13292 17.2824 7.29042C15.5449 11.3363 12.449 13.7521 9.00237 13.7546H8.99737C5.55071 13.7521 2.45571 11.3363 0.717373 7.29042C0.649873 7.13292 0.649873 6.95459 0.717373 6.79709C2.45571 2.75209 5.55154 0.336255 8.99737 0.333755H9.00237ZM8.99987 1.58376C6.13654 1.58459 3.52487 3.62042 1.97487 7.04376C3.52487 10.4679 6.13571 12.5038 8.99987 12.5046C11.864 12.5038 14.4749 10.4679 16.0249 7.04376C14.4749 3.62042 11.864 1.58459 8.99987 1.58376ZM8.99962 3.78442C10.7971 3.78442 12.2596 5.24692 12.2596 7.04442C12.2596 8.84109 10.7971 10.3028 8.99962 10.3028C7.20212 10.3028 5.74046 8.84109 5.74046 7.04442C5.74046 5.24692 7.20212 3.78442 8.99962 3.78442ZM8.99962 5.03442C7.89129 5.03442 6.99046 5.93609 6.99046 7.04442C6.99046 8.15192 7.89129 9.05276 8.99962 9.05276C10.108 9.05276 11.0096 8.15192 11.0096 7.04442C11.0096 5.93609 10.108 5.03442 8.99962 5.03442Z"
    />
  </svg>
);

export const EditIcon = ({ className, style }) => (
  <svg
    className={className ?? "h-5"}
    style={style}
    stroke="none"
    fill="currentColor"
    viewBox="0 0 12 12"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.3265 10.6355C11.6979 10.6355 12 10.9415 12 11.3178C12 11.6947 11.6979 12 11.3265 12H7.51979C7.14839 12 6.84631 11.6947 6.84631 11.3178C6.84631 10.9415 7.14839 10.6355 7.51979 10.6355H11.3265ZM8.68657 0.466042L9.66991 1.24719C10.0732 1.56251 10.342 1.97817 10.4339 2.41533C10.5401 2.8962 10.4269 3.36847 10.1085 3.77696L4.25093 11.3519C3.98211 11.6959 3.58594 11.8894 3.16148 11.8966L0.82693 11.9253C0.699591 11.9253 0.593475 11.8393 0.565178 11.7174L0.034599 9.41698C-0.057368 8.99416 0.034599 8.55701 0.303426 8.22018L4.45609 2.84532C4.52683 2.75932 4.65417 2.7457 4.73906 2.80948L6.48644 4.19978C6.59963 4.29295 6.75526 4.34311 6.91797 4.32161C7.26462 4.27861 7.49807 3.96329 7.4627 3.62646C7.44148 3.45447 7.35659 3.31114 7.2434 3.20364C7.20802 3.17497 5.54554 1.84201 5.54554 1.84201C5.43943 1.75601 5.41821 1.59835 5.5031 1.49157L6.16102 0.638038C6.76941 -0.143109 7.83057 -0.214774 8.68657 0.466042Z" />
  </svg>
);

export const NumberPadIcon = ({ className, style }) => (
  <svg
    className={className ?? "h-5"}
    style={style}
    stroke="none"
    fill="currentColor"
    viewBox="0 0 512 512"
  >
    <g>
      <g>
        <g>
          <path
            d="M462.797,324.497l-112.93-32.265V187.733c0-18.825-15.309-34.133-34.133-34.133S281.6,168.909,281.6,187.733v145.084
            l-4.386-8.218c-5.589-10.761-16.905-17.442-29.534-17.442c-6.084,0-12.058,1.596-17.28,4.617
            c-15.582,8.994-20.992,28.314-13.116,45.304c1.621,4.429,40.388,108.928,83.883,152.422c1.596,1.604,3.763,2.5,6.033,2.5h136.533
            c2.85,0,5.513-1.425,7.1-3.797C486.4,454.852,486.4,410.496,486.4,384v-25.6C486.4,335.377,471.245,326.246,462.797,324.497z
             M469.333,384c0,23.927,0,63.565-30.225,110.933H310.81c-39.936-42.428-77.133-142.729-77.764-144.375
            c-3.738-8.081-2.91-18.927,5.888-24.004c7.953-4.591,19.157-1.741,23.185,5.999l20.489,38.4c1.843,3.447,5.811,5.18,9.591,4.258
            c3.806-0.947,6.468-4.361,6.468-8.277v-179.2c0-9.412,7.654-17.067,17.067-17.067s17.067,7.654,17.067,17.067v110.933
            c0,3.806,2.526,7.159,6.195,8.201l27.938,7.987v7.543c0,4.71,3.814,8.533,8.533,8.533s8.533-3.823,8.533-8.533v-2.671
            l17.067,4.881v7.125c0,4.71,3.814,8.533,8.533,8.533c4.719,0,8.533-3.823,8.533-8.533v-2.253l17.067,4.881v6.972
            c0,4.71,3.814,8.533,8.533,8.533s8.533-3.823,8.533-8.533v-2.099l6.195,1.766c0.273,0.085,0.546,0.154,0.828,0.196
            c0.102,0.017,10.044,1.98,10.044,17.203V384z"
          />
          <path
            d="M196.267,358.4H51.2c-4.71,0-8.533-3.831-8.533-8.533V25.6c0-4.702,3.823-8.533,8.533-8.533h324.267
            c4.71,0,8.533,3.831,8.533,8.533v256c0,4.71,3.814,8.533,8.533,8.533c4.719,0,8.533-3.823,8.533-8.533v-256
            c0-14.114-11.486-25.6-25.6-25.6H51.2C37.086,0,25.6,11.486,25.6,25.6v324.267c0,14.114,11.486,25.6,25.6,25.6h145.067
            c4.719,0,8.533-3.823,8.533-8.533S200.986,358.4,196.267,358.4z"
          />
          <path
            d="M221.867,221.867c18.825,0,34.133-15.309,34.133-34.133S240.691,153.6,221.867,153.6
            c-18.825,0-34.133,15.309-34.133,34.133S203.042,221.867,221.867,221.867z M221.867,170.667c9.412,0,17.067,7.654,17.067,17.067
            s-7.654,17.067-17.067,17.067c-9.412,0-17.067-7.654-17.067-17.067S212.454,170.667,221.867,170.667z"
          />
          <path
            d="M281.6,85.333c0,18.825,15.309,34.133,34.133,34.133s34.133-15.309,34.133-34.133c0-18.825-15.309-34.133-34.133-34.133
            S281.6,66.509,281.6,85.333z M332.8,85.333c0,9.412-7.654,17.067-17.067,17.067s-17.067-7.654-17.067-17.067
            c0-9.412,7.654-17.067,17.067-17.067S332.8,75.921,332.8,85.333z"
          />
          <path
            d="M110.933,256C92.109,256,76.8,271.309,76.8,290.133s15.309,34.133,34.133,34.133c18.825,0,34.133-15.309,34.133-34.133
            S129.758,256,110.933,256z M110.933,307.2c-9.412,0-17.067-7.654-17.067-17.067c0-9.412,7.654-17.067,17.067-17.067
            c9.412,0,17.067,7.654,17.067,17.067C128,299.546,120.346,307.2,110.933,307.2z"
          />
          <path
            d="M247.467,85.333c0-18.825-15.309-34.133-34.133-34.133S179.2,66.509,179.2,85.333c0,18.825,15.309,34.133,34.133,34.133
            S247.467,104.158,247.467,85.333z M196.267,85.333c0-9.412,7.654-17.067,17.067-17.067c9.412,0,17.067,7.654,17.067,17.067
            c0,9.412-7.654,17.067-17.067,17.067C203.921,102.4,196.267,94.746,196.267,85.333z"
          />
          <path
            d="M110.933,153.6c-18.825,0-34.133,15.309-34.133,34.133s15.309,34.133,34.133,34.133
            c18.825,0,34.133-15.309,34.133-34.133S129.758,153.6,110.933,153.6z M110.933,204.8c-9.412,0-17.067-7.654-17.067-17.067
            s7.654-17.067,17.067-17.067c9.412,0,17.067,7.654,17.067,17.067S120.346,204.8,110.933,204.8z"
          />
          <path
            d="M110.933,51.2C92.109,51.2,76.8,66.509,76.8,85.333c0,18.825,15.309,34.133,34.133,34.133
            c18.825,0,34.133-15.309,34.133-34.133C145.067,66.509,129.758,51.2,110.933,51.2z M110.933,102.4
            c-9.412,0-17.067-7.654-17.067-17.067c0-9.412,7.654-17.067,17.067-17.067c9.412,0,17.067,7.654,17.067,17.067
            C128,94.746,120.346,102.4,110.933,102.4z"
          />
          <path
            d="M204.8,290.133c0-9.412,7.654-17.067,17.067-17.067c8.226,0,15.275,5.854,16.777,13.918
            c0.862,4.634,5.325,7.671,9.95,6.835c4.634-0.862,7.689-5.316,6.835-9.95C252.425,267.725,238.31,256,221.867,256
            c-18.825,0-34.133,15.309-34.133,34.133c0,8.457,3.115,16.572,8.772,22.861c1.69,1.869,4.011,2.816,6.34,2.816
            c2.048,0,4.087-0.725,5.709-2.193c3.516-3.157,3.789-8.55,0.64-12.049C206.362,298.428,204.8,294.366,204.8,290.133z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const HouseIcon = ({ className, style }) => (
  <svg
    className={className ?? "h-5"}
    style={style}
    stroke="none"
    fill="currentColor"
    viewBox="0 0 20 19"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.148 0.971C16.9698 0.675523 16.7185 0.43095 16.4183 0.260871C16.118 0.0907925 15.779 0.000946629 15.434 0H4.566C3.868 0 3.211 0.372 2.852 0.971L0.143 5.485C0.0492558 5.64041 -0.000194965 5.8185 5.77679e-07 6C0.00399429 6.96521 0.359495 7.89591 1 8.618V17C1 18.103 1.897 19 3 19H17C18.103 19 19 18.103 19 17V8.618C19.6405 7.89591 19.996 6.96521 20 6C20.0002 5.8185 19.9507 5.64041 19.857 5.485L17.148 0.971ZM17.984 6.251C17.9223 6.73382 17.6868 7.17764 17.3217 7.49952C16.9566 7.8214 16.4867 7.99931 16 8C14.897 8 14 7.103 14 6C14 5.932 13.975 5.872 13.961 5.808L13.981 5.804L13.22 2H15.434L17.984 6.251ZM8.819 2H11.18L11.993 6.065C11.958 7.137 11.08 8 10 8C8.92 8 8.042 7.137 8.007 6.065L8.819 2ZM4.566 2H6.78L6.02 5.804L6.04 5.808C6.025 5.872 6 5.932 6 6C6 7.103 5.103 8 4 8C3.51325 7.99931 3.04341 7.8214 2.67828 7.49952C2.31315 7.17764 2.07772 6.73382 2.016 6.251L4.566 2ZM8 17V14H12V17H8ZM14 17V14C14 12.897 13.103 12 12 12H8C6.897 12 6 12.897 6 14V17H3V9.858C3.321 9.941 3.652 10 4 10C4.56782 10.0003 5.12915 9.8794 5.6465 9.64539C6.16386 9.41137 6.6253 9.06963 7 8.643C7.733 9.475 8.807 10 10 10C11.193 10 12.267 9.475 13 8.643C13.3747 9.06963 13.8361 9.41137 14.3535 9.64539C14.8708 9.8794 15.4322 10.0003 16 10C16.348 10 16.679 9.941 17 9.858V17H14Z" />
  </svg>
);

export const PlayIcon = ({ className }) => (
  <svg
    className={className ?? "h-5"}
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 92.2 122.88"
  >
    <g>
      <polygon points="92.2,60.97 0,122.88 0,0 92.2,60.97" />
    </g>
  </svg>
);

export const NoteIcon = ({ className, style }) => (
  <svg
    className={className ?? "h-5"}
    style={style}
    stroke="none"
    fill="currentColor"
    viewBox="0 0 215.902 235.846"
  >
    <g id="Group_27751" data-name="Group 27751" transform="translate(0 0)">
      <path
        id="Path_95"
        data-name="Path 95"
        d="M1023.217,414.9h-1.451v-4.571a7.2,7.2,0,1,0-14.4,0V414.9H976.157v-3.913a7.2,7.2,0,0,0-14.4,0V414.9H930.547v-4.571a7.2,7.2,0,0,0-14.4,0v4.739A56.122,56.122,0,0,0,863.4,470.99V582.883a56.158,56.158,0,0,0,56.095,56.09h103.723a56.152,56.152,0,0,0,56.085-56.09V470.99A56.153,56.153,0,0,0,1023.217,414.9ZM1064.9,582.883a41.73,41.73,0,0,1-41.682,41.687H919.494A41.738,41.738,0,0,1,877.8,582.883V470.99a41.718,41.718,0,0,1,38.341-41.515v3.639a7.2,7.2,0,0,0,14.4,0V429.3h31.207v4.469a7.2,7.2,0,1,0,14.4,0V429.3h31.206v3.812a7.2,7.2,0,1,0,14.4,0V429.3h1.451A41.729,41.729,0,0,1,1064.9,470.99Z"
        transform="translate(-863.399 -403.127)"
      />
      <path
        id="Path_96"
        data-name="Path 96"
        d="M972.249,419.251H882.21a7.2,7.2,0,1,0,0,14.4h90.039a7.2,7.2,0,1,0,0-14.4Z"
        transform="translate(-819.273 -341.839)"
      />
      <path
        id="Path_97"
        data-name="Path 97"
        d="M972.249,428.751H882.21a7.2,7.2,0,0,0,0,14.4h90.039a7.2,7.2,0,0,0,0-14.4Z"
        transform="translate(-819.273 -305.729)"
      />
      <path
        id="Path_98"
        data-name="Path 98"
        d="M972.249,438.251H882.21a7.2,7.2,0,0,0,0,14.4h90.039a7.2,7.2,0,0,0,0-14.4Z"
        transform="translate(-819.273 -269.619)"
      />
    </g>
  </svg>
);

export const TemplateIcon = ({ className }) => (
  <svg className={`${defaultClassName} ${className}`} fill="currentColor" />
);

export const BackupTemplateIcon = ({ className }) => (
  <svg className={`${defaultClassName} ${className}`} fill="currentColor" />
);
